"use strict";

function disableScroll() {
  document.body.style.overflow = 'hidden';
  document.documentElement.style.overflow = 'hidden';
}

function enableScroll() {
  document.body.style.overflow = 'hidden auto';
  document.documentElement.style.overflow = 'hidden auto';
}

function _typeof(e) {
  return (_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
    return typeof e
  } : function(e) {
    return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e
  })(e)
}
if ($(document)
  .ready(function() {
    $(".fancybox")
      .fancybox({
        helpers: {
          overlay: {
            locked: !1
          },
          title: {
            type: "float"
          }
        }
      }), $(document)
      .on("show.bs.modal", ".modal", function() {
        var e = 1040 + 10 * $(".modal:visible")
          .length;
        $(this)
          .css("z-index", e), setTimeout(function() {
            $(".modal-backdrop")
              .not(".modal-stack")
              .css("z-index", e - 1)
              .addClass("modal-stack")
          }, 0)
      }), $(document)
      .on("hidden.bs.modal", ".modal", function() {
        $(".modal:visible")
          .length && $(document.body)
          .addClass("modal-open")
      });
    var e = $(".large-image");
    $(".image-additional ul li a")
      .bind("mouseover", function() {
        e.attr("title", $(this)
            .attr("title")), e.children("img")
          .attr("src", $(this)
            .attr("data-img")), e.attr("href", $(this)
            .attr("href"))
      })
  }), "undefined" == typeof jQuery) throw new Error("Bootstrap's JavaScript requires jQuery");

function ShowMessage(e, t) {
  t = 1 < arguments.length ? t : 1e3;
  show_preloader(), set_preloaders_message('<div id="add_product_notification">' + e.replace(" ", "&nbsp;") + "</div>"), changeCss(jQuery("#own_preloader")), window.setTimeout(hide_preloader, t)
}

function cartTriggers() {
  $(".total_amount_s")
    .html(), $(".cart-table .del a")
    .each(function() {
      $(this)
        .attr("in_process") || ($(this)
          .attr("in_process", !0), $(this)
          .bind("click dblclick", function(e) {
            e.preventDefault();
            var t, o = $(this);
            return o.attr("processed") || confirm("Уверены, что хотите удалить товар?") && (o.attr("processed", !0), e.preventDefault(), t = o.parents("tr:first"), e = "/cart_items/" + o.attr("iid")
              .replace("delete_", "") + ".json", show_preloader(), $.ajax({
                url: e,
                type: "post",
                data: {
                  _method: "delete"
                },
                dataType: "json",
                success: function(e) {
                  o.attr("processed", !1), hide_preloader(), 0 === e.discounts.length ? $(".discounts-list")
                    .hide() : ($.each(e.discounts, function() {
                        var e = this.description,
                          t = InSales.formatMoney(this.amount, cv_currency_format);
                        $(".discounts-list")
                          .html('<tr class="row-table-1 discounts-list-line"><td class="right cart-total-name "><b>' + e + '</b></td><td class="right cart-total1 nowrap"> - ' + t + "</td></tr>")
                      }), $(".discounts-list")
                      .show()), 0 == e.total_price && ($("#cartform")
                      .hide(), $(".cart-message")
                      .show()), t.slideUp("normal", function() {
                      t.remove(), $("#cartform table td.index:visible")
                        .each(function(e) {
                          $(this)
                            .html(e + 1 + ".")
                        })
                    }), $(".total_amount")
                    .html(InSales.formatMoney(e.total_price, cv_currency_format)), $(".cart_total_price")
                    .html(InSales.formatMoney(e.total_price, cv_currency_format)), $(".cart_items_count")
                    .html(e.items_count), 1 == e.items_count ? $("#cart_text")
                    .html("товар") : 4 < e.items_count ? $("#cart_text")
                    .html("товаров") : $("#cart_text")
                    .html("товара")
                },
                error: function() {
                  return !o.attr("processed") && void o.attr("processed", !1)
                }
              })), !1
          }))
    }), qSwaps = [], $(".cart-table .quantity input")
    .each(function(e) {
      qSwaps[e] = $(this)
        .val()
    }), $(".cart-table .quantity input")
    .each(function(o) {
      $(this)
        .attr("processed") || ($(this)
          .attr("processed", !0), $(this)
          .bind("change keyup", function() {
            var e = $(this),
              t = e.val();
            (val = t.replace(/[^\d\.\,]+/g, "")) != t && e.val(val), val != qSwaps[o] && (qSwaps[o] = val, e.parents("tr:first")
              .find(".total-price")
              .html(InSales.formatMoney(val * e.attr("price"), cv_currency_format)), t = $("#cartform")
              .serialize(), show_preloader(), $.ajax({
                url: "/cart_items/update_all.json",
                type: "post",
                data: t,
                dataType: "json",
                success: function(e) {
                  hide_preloader(), 0 === e.discounts.length ? $(".discounts-list")
                    .hide() : ($.each(e.discounts, function() {
                        var e = this.description,
                          t = InSales.formatMoney(this.amount, cv_currency_format);
                        $(".discounts-list")
                          .html('<tr class="row-table-1 discounts-list-line"><td class="right cart-total-name "><b>' + e + '</b></td><td class="right cart-total1 nowrap"> - ' + t + "</td></tr>")
                      }), $(".discounts-list")
                      .show()), $(".total_amount")
                    .html(InSales.formatMoney(e.total_price, cv_currency_format)), $(".cart_total_price")
                    .html(InSales.formatMoney(e.total_price, cv_currency_format)), $(".cart_items_count")
                    .html(e.items_count), 1 == e.items_count ? $("#cart_text")
                    .html("товар") : 4 < e.items_count ? $("#cart_text")
                    .html("товаров") : $("#cart_text")
                    .html("товара")
                },
                error: function() {
                  alert("произошла ошибка"), hide_preloader()
                }
              }))
          })
          .bind("blur", function() {
            var e = $(this),
              t = e.val();
            ((val = t.replace(/[^\d\.\,]+/g, "")) < 0 || "" == val) && (val = 0), e.val(val), e.change()
          }))
    })
}

function getParam(e) {
  for (var t = location.search.substring(1)
      .split("&"), o = "", i = 0; i < t.length; i++)
    if (t[i].split("=")[0] == e) return o = 1 < t[i].split("=")
      .length ? t[i].split("=")[1] : o;
  return ""
}

function recalc_offer_price() {
  rc_total_count = 0, $(".product-variants input:enabled")
    .each(function() {
      var e = $(this)
        .val();
      (isNaN(e) || e < 0) && (e = 0, $(this)
        .val(e)), rc_total_count += $(this)
        .attr("price") * e
    }), $("#price-field")
    .html(InSales.formatMoney(rc_total_count, cv_currency_format))
}! function() {
  var e = jQuery.fn.jquery.split(" ")[0].split(".");
  if (e[0] < 2 && e[1] < 9 || 1 == e[0] && 9 == e[1] && e[2] < 1 || 3 < e[0]) throw new Error("Bootstrap's JavaScript requires jQuery version 1.9.1 or higher, but lower than version 4")
}(),
function(n) {
  function a(i, a) {
    return this.each(function() {
      var e = n(this),
        t = e.data("bs.modal"),
        o = n.extend({}, r.DEFAULTS, e.data(), "object" == _typeof(i) && i);
      t || e.data("bs.modal", t = new r(this, o)), "string" == typeof i ? t[i](a) : o.show && t.show(a)
    })
  }

  function r(e, t) {
    this.options = t, this.$body = n(document.body), this.$element = n(e), this.$dialog = this.$element.find(".modal-dialog"), this.$backdrop = null, this.isShown = null, this.originalBodyPad = null, this.scrollbarWidth = 0, this.ignoreBackdropClick = !1, this.options.remote && this.$element.find(".modal-content")
      .load(this.options.remote, n.proxy(function() {
        this.$element.trigger("loaded.bs.modal")
      }, this))
  }
  r.VERSION = "3.3.7", r.TRANSITION_DURATION = 300, r.BACKDROP_TRANSITION_DURATION = 150, r.DEFAULTS = {
    backdrop: !0,
    keyboard: !0,
    show: !0
  }, r.prototype.toggle = function(e) {
    return this.isShown ? this.hide() : this.show(e)
  }, r.prototype.show = function(o) {
    var i = this,
      e = n.Event("show.bs.modal", {
        relatedTarget: o
      });
    this.$element.trigger(e), this.isShown || e.isDefaultPrevented() || (this.isShown = !0, this.checkScrollbar(), this.setScrollbar(), this.$body.addClass("modal-open"), this.escape(), this.resize(), this.$element.on("click.dismiss.bs.modal", '[data-dismiss="modal"]', n.proxy(this.hide, this)), this.$dialog.on("mousedown.dismiss.bs.modal", function() {
      i.$element.one("mouseup.dismiss.bs.modal", function(e) {
        n(e.target)
          .is(i.$element) && (i.ignoreBackdropClick = !0)
      })
    }), this.backdrop(function() {
      var e = n.support.transition && i.$element.hasClass("fade"),
        t = (i.$element.parent()
          .length || i.$element.appendTo(i.$body), i.$element.show()
          .scrollTop(0), i.adjustDialog(), e && i.$element[0].offsetWidth, i.$element.addClass("in"), i.enforceFocus(), n.Event("shown.bs.modal", {
            relatedTarget: o
          }));
      e ? i.$dialog.one("bsTransitionEnd", function() {
          i.$element.trigger("focus")
            .trigger(t)
        })
        .emulateTransitionEnd(r.TRANSITION_DURATION) : i.$element.trigger("focus")
        .trigger(t)
    }))
  }, r.prototype.hide = function(e) {
    e && e.preventDefault(), e = n.Event("hide.bs.modal"), this.$element.trigger(e), this.isShown && !e.isDefaultPrevented() && (this.isShown = !1, this.escape(), this.resize(), n(document)
      .off("focusin.bs.modal"), this.$element.removeClass("in")
      .off("click.dismiss.bs.modal")
      .off("mouseup.dismiss.bs.modal"), this.$dialog.off("mousedown.dismiss.bs.modal"), n.support.transition && this.$element.hasClass("fade") ? this.$element.one("bsTransitionEnd", n.proxy(this.hideModal, this))
      .emulateTransitionEnd(r.TRANSITION_DURATION) : this.hideModal())
  }, r.prototype.enforceFocus = function() {
    n(document)
      .off("focusin.bs.modal")
      .on("focusin.bs.modal", n.proxy(function(e) {
        document === e.target || this.$element[0] === e.target || this.$element.has(e.target)
          .length || this.$element.trigger("focus")
      }, this))
  }, r.prototype.escape = function() {
    this.isShown && this.options.keyboard ? this.$element.on("keydown.dismiss.bs.modal", n.proxy(function(e) {
      27 == e.which && this.hide()
    }, this)) : this.isShown || this.$element.off("keydown.dismiss.bs.modal")
  }, r.prototype.resize = function() {
    this.isShown ? n(window)
      .on("resize.bs.modal", n.proxy(this.handleUpdate, this)) : n(window)
      .off("resize.bs.modal")
  }, r.prototype.hideModal = function() {
    var e = this;
    this.$element.hide(), this.backdrop(function() {
      e.$body.removeClass("modal-open"), e.resetAdjustments(), e.resetScrollbar(), e.$element.trigger("hidden.bs.modal")
    })
  }, r.prototype.removeBackdrop = function() {
    this.$backdrop && this.$backdrop.remove(), this.$backdrop = null
  }, r.prototype.backdrop = function(e) {
    var t, o = this,
      i = this.$element.hasClass("fade") ? "fade" : "";
    this.isShown && this.options.backdrop ? (t = n.support.transition && i, this.$backdrop = n(document.createElement("div"))
      .addClass("modal-backdrop " + i)
      .appendTo(this.$body), this.$element.on("click.dismiss.bs.modal", n.proxy(function(e) {
        return this.ignoreBackdropClick ? void(this.ignoreBackdropClick = !1) : void(e.target === e.currentTarget && ("static" == this.options.backdrop ? this.$element[0].focus() : this.hide()))
      }, this)), t && this.$backdrop[0].offsetWidth, this.$backdrop.addClass("in"), e && (t ? this.$backdrop.one("bsTransitionEnd", e)
        .emulateTransitionEnd(r.BACKDROP_TRANSITION_DURATION) : e())) : !this.isShown && this.$backdrop ? (this.$backdrop.removeClass("in"), i = function() {
        o.removeBackdrop(), e && e()
      }, n.support.transition && this.$element.hasClass("fade") ? this.$backdrop.one("bsTransitionEnd", i)
      .emulateTransitionEnd(r.BACKDROP_TRANSITION_DURATION) : i()) : e && e()
  }, r.prototype.handleUpdate = function() {
    this.adjustDialog()
  }, r.prototype.adjustDialog = function() {
    var e = this.$element[0].scrollHeight > document.documentElement.clientHeight;
    this.$element.css({
      paddingLeft: !this.bodyIsOverflowing && e ? this.scrollbarWidth : "",
      paddingRight: this.bodyIsOverflowing && !e ? this.scrollbarWidth : ""
    })
  }, r.prototype.resetAdjustments = function() {
    this.$element.css({
      paddingLeft: "",
      paddingRight: ""
    })
  }, r.prototype.checkScrollbar = function() {
    var e, t = window.innerWidth;
    t || (t = (e = document.documentElement.getBoundingClientRect())
      .right - Math.abs(e.left)), this.bodyIsOverflowing = document.body.clientWidth < t, this.scrollbarWidth = this.measureScrollbar()
  }, r.prototype.setScrollbar = function() {
    var e = parseInt(this.$body.css("padding-right") || 0, 10);
    this.originalBodyPad = document.body.style.paddingRight || "", this.bodyIsOverflowing && this.$body.css("padding-right", e + this.scrollbarWidth)
  }, r.prototype.resetScrollbar = function() {
    this.$body.css("padding-right", this.originalBodyPad)
  }, r.prototype.measureScrollbar = function() {
    var e = document.createElement("div"),
      t = (e.className = "modal-scrollbar-measure", this.$body.append(e), e.offsetWidth - e.clientWidth);
    return this.$body[0].removeChild(e), t
  };
  var e = n.fn.modal;
  n.fn.modal = a, n.fn.modal.Constructor = r, n.fn.modal.noConflict = function() {
      return n.fn.modal = e, this
    }, n(document)
    .on("click.bs.modal.data-api", '[data-toggle="modal"]', function(e) {
      var t = n(this),
        o = t.attr("href"),
        i = n(t.attr("data-target") || o && o.replace(/.*(?=#[^\s]+$)/, "")),
        o = i.data("bs.modal") ? "toggle" : n.extend({
          remote: !/#/.test(o) && o
        }, i.data(), t.data());
      t.is("a") && e.preventDefault(), i.one("show.bs.modal", function(e) {
        e.isDefaultPrevented() || i.one("hidden.bs.modal", function() {
          t.is(":visible") && t.trigger("focus")
        })
      }), a.call(i, o, this)
    })
}(jQuery),
function(r) {
  function t(o) {
    return this.each(function() {
      var e = r(this),
        t = e.data("bs.tab");
      t || e.data("bs.tab", t = new s(this)), "string" == typeof o && t[o]()
    })
  }

  function s(e) {
    this.element = r(e)
  }

  function e(e) {
    e.preventDefault(), t.call(r(this), "show")
  }
  s.VERSION = "3.3.7", s.TRANSITION_DURATION = 150, s.prototype.show = function() {
    var e, t, o, i = this.element,
      a = i.closest("ul:not(.dropdown-menu)"),
      n = (n = i.data("target")) || (n = i.attr("href")) && n.replace(/.*(?=#[^\s]*$)/, "");
    i.parent("li")
      .hasClass("active") || (e = a.find(".active:last a"), t = r.Event("hide.bs.tab", {
        relatedTarget: i[0]
      }), o = r.Event("show.bs.tab", {
        relatedTarget: e[0]
      }), e.trigger(t), i.trigger(o), o.isDefaultPrevented()) || t.isDefaultPrevented() || (o = r(n), this.activate(i.closest("li"), a), this.activate(o, o.parent(), function() {
        e.trigger({
          type: "hidden.bs.tab",
          relatedTarget: i[0]
        }), i.trigger({
          type: "shown.bs.tab",
          relatedTarget: e[0]
        })
      }))
  }, s.prototype.activate = function(e, t, o) {
    function i() {
      a.removeClass("active")
        .find("> .dropdown-menu > .active")
        .removeClass("active")
        .end()
        .find('[data-toggle="tab"]')
        .attr("aria-expanded", !1), e.addClass("active")
        .find('[data-toggle="tab"]')
        .attr("aria-expanded", !0), n ? (e[0].offsetWidth, e.addClass("in")) : e.removeClass("fade"), e.parent(".dropdown-menu")
        .length && e.closest("li.dropdown")
        .addClass("active")
        .end()
        .find('[data-toggle="tab"]')
        .attr("aria-expanded", !0), o && o()
    }
    var a = t.find("> .active"),
      n = o && r.support.transition && (a.length && a.hasClass("fade") || !!t.find("> .fade")
        .length);
    a.length && n ? a.one("bsTransitionEnd", i)
      .emulateTransitionEnd(s.TRANSITION_DURATION) : i(), a.removeClass("in")
  };
  var o = r.fn.tab;
  r.fn.tab = t, r.fn.tab.Constructor = s, r.fn.tab.noConflict = function() {
    return r.fn.tab = o, this
  };
  r(document)
    .on("click.bs.tab.data-api", '[data-toggle="tab"]', e)
    .on("click.bs.tab.data-api", '[data-toggle="pill"]', e)
}(jQuery),
function(e) {
  "function" == typeof define && define.amd ? define([], e) : "object" == ("undefined" == typeof exports ? "undefined" : _typeof(exports)) ? module.exports = e() : window.noUiSlider = e()
}(function() {
  function r(e) {
    return null != e
  }

  function Z(e) {
    e.preventDefault()
  }

  function u(e) {
    return "number" == typeof e && !isNaN(e) && isFinite(e)
  }

  function X(e, t, o) {
    0 < o && (oe(e, t), setTimeout(function() {
      ie(e, t)
    }, o))
  }

  function ee(e) {
    return Math.max(Math.min(e, 100), 0)
  }

  function te(e) {
    return Array.isArray(e) ? e : [e]
  }

  function t(e) {
    e = (e += "")
      .split(".");
    return 1 < e.length ? e[1].length : 0
  }

  function oe(e, t) {
    e.classList ? e.classList.add(t) : e.className += " " + t
  }

  function ie(e, t) {
    e.classList ? e.classList.remove(t) : e.className = e.className.replace(new RegExp("(^|\\b)" + t.split(" ")
      .join("|") + "(\\b|$)", "gi"), " ")
  }

  function ae(e) {
    var t = void 0 !== window.pageXOffset,
      o = "CSS1Compat" === (e.compatMode || "");
    return {
      x: t ? window.pageXOffset : (o ? e.documentElement : e.body)
        .scrollLeft,
      y: t ? window.pageYOffset : (o ? e.documentElement : e.body)
        .scrollTop
    }
  }

  function p(e, t) {
    return 100 / (t - e)
  }

  function f(e, t) {
    return 100 * t / (e[1] - e[0])
  }

  function s(e, t) {
    for (var o = 1; e >= t[o];) o += 1;
    return o
  }

  function o(e, t, o) {
    this.xPct = [], this.xVal = [], this.xSteps = [o || !1], this.xNumSteps = [!1], this.xHighestCompleteStep = [], this.snap = t;
    var i, a, n, r, s = [];
    for (i in e) e.hasOwnProperty(i) && s.push([e[i], i]);
    for (s.length && "object" == _typeof(s[0][0]) ? s.sort(function(e, t) {
        return e[0][0] - t[0][0]
      }) : s.sort(function(e, t) {
        return e[0] - t[0]
      }), i = 0; i < s.length; i++) {
      l = void 0;
      c = void 0;
      d = void 0;
      var l = s[i][1];
      var c = s[i][0];
      var d = this;
      if ("number" == typeof c && (c = [c]), !Array.isArray(c)) throw new Error("noUiSlider (12.0.0): 'range' contains invalid value.");
      if (!u(l = "min" === l ? 0 : "max" === l ? 100 : parseFloat(l)) || !u(c[0])) throw new Error("noUiSlider (12.0.0): 'range' value isn't numeric.");
      d.xPct.push(l), d.xVal.push(c[0]), l ? d.xSteps.push(!isNaN(c[1]) && c[1]) : isNaN(c[1]) || (d.xSteps[0] = c[1]), d.xHighestCompleteStep.push(0)
    }
    for (this.xNumSteps = this.xSteps.slice(0), i = 0; i < this.xNumSteps.length; i++) a = i, n = this.xNumSteps[i], r = this, n && (r.xSteps[a] = f([r.xVal[a], r.xVal[a + 1]], n) / p(r.xPct[a], r.xPct[a + 1]), n = (r.xVal[a + 1] - r.xVal[a]) / r.xNumSteps[a], n = Math.ceil(+n.toFixed(3) - 1), n = r.xVal[a] + r.xNumSteps[a] * n, r.xHighestCompleteStep[a] = n)
  }

  function i(e) {
    if ("object" != _typeof(e = e) || "function" != typeof e.to || "function" != typeof e.from) throw new Error("noUiSlider (12.0.0): 'format' requires 'to' and 'from' methods.")
  }

  function l(e, t) {
    if (!u(t)) throw new Error("noUiSlider (12.0.0): 'step' is not numeric.");
    e.singleStep = t
  }

  function c(e, t) {
    if ("object" != _typeof(t) || Array.isArray(t)) throw new Error("noUiSlider (12.0.0): 'range' is not an object.");
    if (void 0 === t.min || void 0 === t.max) throw new Error("noUiSlider (12.0.0): Missing 'min' or 'max' in 'range'.");
    if (t.min === t.max) throw new Error("noUiSlider (12.0.0): 'range' 'min' and 'max' cannot be equal.");
    e.spectrum = new o(t, e.snap, e.singleStep)
  }

  function d(e, t) {
    if (t = te(t), !Array.isArray(t) || !t.length) throw new Error("noUiSlider (12.0.0): 'start' option is incorrect.");
    e.handles = t.length, e.start = t
  }

  function m(e, t) {
    if ("boolean" != typeof(e.snap = t)) throw new Error("noUiSlider (12.0.0): 'snap' option must be a boolean.")
  }

  function h(e, t) {
    if ("boolean" != typeof(e.animate = t)) throw new Error("noUiSlider (12.0.0): 'animate' option must be a boolean.")
  }

  function v(e, t) {
    if ("number" != typeof(e.animationDuration = t)) throw new Error("noUiSlider (12.0.0): 'animationDuration' option must be a number.")
  }

  function g(e, t) {
    var o, i = [!1];
    if ("lower" === t ? t = [!0, !1] : "upper" === t && (t = [!1, !0]), !0 === t || !1 === t) {
      for (o = 1; o < e.handles; o++) i.push(t);
      i.push(!1)
    } else {
      if (!Array.isArray(t) || !t.length || t.length !== e.handles + 1) throw new Error("noUiSlider (12.0.0): 'connect' option doesn't match handle count.");
      i = t
    }
    e.connect = i
  }

  function _(e, t) {
    switch (t) {
      case "horizontal":
        e.ort = 0;
        break;
      case "vertical":
        e.ort = 1;
        break;
      default:
        throw new Error("noUiSlider (12.0.0): 'orientation' option is invalid.")
    }
  }

  function k(e, t) {
    if (!u(t)) throw new Error("noUiSlider (12.0.0): 'margin' option must be numeric.");
    if (0 !== t && (e.margin = e.spectrum.getMargin(t), !e.margin)) throw new Error("noUiSlider (12.0.0): 'margin' option is only supported on linear sliders.")
  }

  function b(e, t) {
    if (!u(t)) throw new Error("noUiSlider (12.0.0): 'limit' option must be numeric.");
    if (e.limit = e.spectrum.getMargin(t), !e.limit || e.handles < 2) throw new Error("noUiSlider (12.0.0): 'limit' option is only supported on linear sliders with 2 or more handles.")
  }

  function y(e, t) {
    if (!u(t) && !Array.isArray(t)) throw new Error("noUiSlider (12.0.0): 'padding' option must be numeric or array of exactly 2 numbers.");
    if (Array.isArray(t) && 2 !== t.length && !u(t[0]) && !u(t[1])) throw new Error("noUiSlider (12.0.0): 'padding' option must be numeric or array of exactly 2 numbers.");
    if (0 !== t) {
      if (Array.isArray(t) || (t = [t, t]), !(e.padding = [e.spectrum.getMargin(t[0]), e.spectrum.getMargin(t[1])]) === e.padding[0] || !1 === e.padding[1]) throw new Error("noUiSlider (12.0.0): 'padding' option is only supported on linear sliders.");
      if (e.padding[0] < 0 || e.padding[1] < 0) throw new Error("noUiSlider (12.0.0): 'padding' option must be a positive number(s).");
      if (100 <= e.padding[0] + e.padding[1]) throw new Error("noUiSlider (12.0.0): 'padding' option must not exceed 100% of the range.")
    }
  }

  function $(e, t) {
    switch (t) {
      case "ltr":
        e.dir = 0;
        break;
      case "rtl":
        e.dir = 1;
        break;
      default:
        throw new Error("noUiSlider (12.0.0): 'direction' option was not recognized.")
    }
  }

  function x(e, t) {
    if ("string" != typeof t) throw new Error("noUiSlider (12.0.0): 'behaviour' must be a string containing options.");
    var o = 0 <= t.indexOf("tap"),
      i = 0 <= t.indexOf("drag"),
      a = 0 <= t.indexOf("fixed"),
      n = 0 <= t.indexOf("snap"),
      t = 0 <= t.indexOf("hover");
    if (a) {
      if (2 !== e.handles) throw new Error("noUiSlider (12.0.0): 'fixed' behaviour must be used with 2 handles");
      k(e, e.start[1] - e.start[0])
    }
    e.events = {
      tap: o || n,
      drag: i,
      fixed: a,
      snap: n,
      hover: t
    }
  }

  function w(e, t) {
    if (!1 !== t)
      if (!0 === t) {
        e.tooltips = [];
        for (var o = 0; o < e.handles; o++) e.tooltips.push(!0)
      } else {
        if (e.tooltips = te(t), e.tooltips.length !== e.handles) throw new Error("noUiSlider (12.0.0): must pass a formatter for all handles.");
        e.tooltips.forEach(function(e) {
          if ("boolean" != typeof e && ("object" != _typeof(e) || "function" != typeof e.to)) throw new Error("noUiSlider (12.0.0): 'tooltips' must be passed a formatter or 'false'.")
        })
      }
  }

  function S(e, t) {
    i(e.ariaFormat = t)
  }

  function C(e, t) {
    i(e.format = t)
  }

  function T(e, t) {
    if ("boolean" != typeof(e.keyboardSupport = t)) throw new Error("noUiSlider (12.0.0): 'keyboardSupport' option must be a boolean.")
  }

  function E(e, t) {
    e.documentElement = t
  }

  function P(e, t) {
    if ("string" != typeof t && !1 !== t) throw new Error("noUiSlider (12.0.0): 'cssPrefix' must be a string or `false`.");
    e.cssPrefix = t
  }

  function M(e, t) {
    if ("object" != _typeof(t)) throw new Error("noUiSlider (12.0.0): 'cssClasses' must be an object.");
    if ("string" == typeof e.cssPrefix)
      for (var o in e.cssClasses = {}, t) t.hasOwnProperty(o) && (e.cssClasses[o] = e.cssPrefix + t[o]);
    else e.cssClasses = t
  }

  function ne(t) {
    var o = {
        margin: 0,
        limit: 0,
        padding: 0,
        animate: !0,
        animationDuration: 300,
        ariaFormat: O,
        format: O
      },
      i = {
        step: {
          r: !1,
          t: l
        },
        start: {
          r: !0,
          t: d
        },
        connect: {
          r: !0,
          t: g
        },
        direction: {
          r: !0,
          t: $
        },
        snap: {
          r: !1,
          t: m
        },
        animate: {
          r: !1,
          t: h
        },
        animationDuration: {
          r: !1,
          t: v
        },
        range: {
          r: !0,
          t: c
        },
        orientation: {
          r: !1,
          t: _
        },
        margin: {
          r: !1,
          t: k
        },
        limit: {
          r: !1,
          t: b
        },
        padding: {
          r: !1,
          t: y
        },
        behaviour: {
          r: !0,
          t: x
        },
        ariaFormat: {
          r: !1,
          t: S
        },
        format: {
          r: !1,
          t: C
        },
        tooltips: {
          r: !1,
          t: w
        },
        keyboardSupport: {
          r: !0,
          t: T
        },
        documentElement: {
          r: !1,
          t: E
        },
        cssPrefix: {
          r: !0,
          t: P
        },
        cssClasses: {
          r: !0,
          t: M
        }
      },
      a = {
        connect: !1,
        direction: "ltr",
        behaviour: "tap",
        orientation: "horizontal",
        keyboardSupport: !0,
        cssPrefix: "noUi-",
        cssClasses: {
          target: "target",
          base: "base",
          origin: "origin",
          handle: "handle",
          handleLower: "handle-lower",
          handleUpper: "handle-upper",
          horizontal: "horizontal",
          vertical: "vertical",
          background: "background",
          connect: "connect",
          connects: "connects",
          ltr: "ltr",
          rtl: "rtl",
          draggable: "draggable",
          drag: "state-drag",
          tap: "state-tap",
          active: "active",
          tooltip: "tooltip",
          pips: "pips",
          pipsHorizontal: "pips-horizontal",
          pipsVertical: "pips-vertical",
          marker: "marker",
          markerHorizontal: "marker-horizontal",
          markerVertical: "marker-vertical",
          markerNormal: "marker-normal",
          markerLarge: "marker-large",
          markerSub: "marker-sub",
          value: "value",
          valueHorizontal: "value-horizontal",
          valueVertical: "value-vertical",
          valueNormal: "value-normal",
          valueLarge: "value-large",
          valueSub: "value-sub"
        }
      },
      e = (t.format && !t.ariaFormat && (t.ariaFormat = t.format), Object.keys(i)
        .forEach(function(e) {
          if (!r(t[e]) && void 0 === a[e]) {
            if (i[e].r) throw new Error("noUiSlider (12.0.0): '" + e + "' is required.");
            return !0
          }
          i[e].t(o, (r(t[e]) ? t : a)[e])
        }), o.pips = t.pips, document.createElement("div")),
      n = void 0 !== e.style.msTransform,
      e = void 0 !== e.style.transform;
    return o.transformRule = e ? "transform" : n ? "msTransform" : "webkitTransform", o.style = [["left", "top"], ["right", "bottom"]][o.dir][o.ort], o
  }

  function a(e, y, n) {
    function $(e, t) {
      var o = A.createElement("div");
      return t && oe(o, t), e.appendChild(o), o
    }

    function N(e, t) {
      return !!t && $(e, y.cssClasses.connect)
    }

    function I() {
      x && (x.parentElement.removeChild(x), x = null)
    }

    function r(e) {
      I();
      var f, m, h, v, g, _, k, a, n, r, s, i, l, c, d, t = e.mode,
        o = e.density || 1,
        u = e.filter || !1,
        p = function(e, t, o) {
          if ("range" === e || "steps" === e) return P.xVal;
          if ("count" === e) {
            if (t < 2) throw new Error("noUiSlider (12.0.0): 'values' (>= 2) required for mode 'count'.");
            var i = t - 1,
              a = 100 / i;
            for (t = []; i--;) t[i] = i * a;
            t.push(100), e = "positions"
          }
          return "positions" === e ? t.map(function(e) {
            return P.fromStepping(o ? P.getStep(e) : e)
          }) : "values" === e ? o ? t.map(function(e) {
            return P.fromStepping(P.getStep(P.toStepping(e)))
          }) : t : void 0
        }(t, e.values || !1, e.stepped || !1),
        p = (f = o, m = t, h = p, v = {}, o = P.xVal[0], t = P.xVal[P.xVal.length - 1], _ = g = !1, k = 0, (h = h.slice()
          .sort(function(e, t) {
            return e - t
          })
          .filter(function(e) {
            return !this[e] && (this[e] = !0)
          }, {}))[0] !== o && (h.unshift(o), g = !0), h[h.length - 1] !== t && (h.push(t), _ = !0), h.forEach(function(e, t) {
          var o, i, a, n, r, s, l, c, d = h[t + 1],
            u = "steps" === m,
            p = (p = u ? P.xNumSteps[t] : p) || d - e;
          if (!1 !== e && void 0 !== d)
            for (p = Math.max(p, 1e-7), o = e; o <= d; o = +(o + p)
              .toFixed(7)) {
              for (s = (r = (a = P.toStepping(o)) - k) / f, c = r / (l = Math.round(s)), i = 1; i <= l; i += 1) v[(n = k + i * c)
                .toFixed(5)] = [P.fromStepping(n), 0];
              r = -1 < h.indexOf(o) ? 1 : u ? 2 : 0, !t && g && (r = 0), o === d && _ || (v[a.toFixed(5)] = [o, r]), k = a
            }
        }), v),
        o = e.format || {
          to: Math.round
        };
      return x = S.appendChild((a = p, n = u, r = o, s = A.createElement("div"), (i = [])[0] = y.cssClasses.valueNormal, i[1] = y.cssClasses.valueLarge, i[2] = y.cssClasses.valueSub, (l = [])[0] = y.cssClasses.markerNormal, l[1] = y.cssClasses.markerLarge, l[2] = y.cssClasses.markerSub, c = [y.cssClasses.valueHorizontal, y.cssClasses.valueVertical], d = [y.cssClasses.markerHorizontal, y.cssClasses.markerVertical], oe(s, y.cssClasses.pips), oe(s, 0 === y.ort ? y.cssClasses.pipsHorizontal : y.cssClasses.pipsVertical), Object.keys(a)
        .forEach(function(e) {
          var t, o, i;
          o = a[t = e][0], e = a[e][1], -1 !== (e = n ? n(o, e) : e) && ((i = $(s, !1))
            .className = b(e, y.cssClasses.marker), i.style[y.style] = t + "%", 0 < e) && ((i = $(s, !1))
            .className = b(e, y.cssClasses.value), i.setAttribute("data-value", o), i.style[y.style] = t + "%", i.innerHTML = r.to(o))
        }), s));

      function b(e, t) {
        var o = t === y.cssClasses.value;
        return t + " " + (o ? c : d)[y.ort] + " " + (o ? i : l)[e]
      }
    }

    function F() {
      var e = h.getBoundingClientRect(),
        t = "offset" + ["Width", "Height"][y.ort];
      return 0 === y.ort ? e.width || h[t] : e.height || h[t]
    }

    function s(i, a, n, r) {
      function t(e) {
        return !!(e = function(e, t, o) {
          var i, a = 0 === e.type.indexOf("touch"),
            n = 0 === e.type.indexOf("mouse"),
            r = 0 === e.type.indexOf("pointer");
          if (0 === e.type.indexOf("MSPointer") && (r = !0), a) {
            a = function(e) {
              return e.target === o || o.contains(e.target)
            };
            if ("touchstart" === e.type) {
              var s = Array.prototype.filter.call(e.touches, a);
              if (1 < s.length) return !1;
              i = s[0].pageX, s = s[0].pageY
            } else {
              a = Array.prototype.find.call(e.changedTouches, a);
              if (!a) return !1;
              i = a.pageX, s = a.pageY
            }
          }
          return t = t || ae(A), (n || r) && (i = e.clientX + t.x, s = e.clientY + t.y), e.pageOffset = t, e.points = [i, s], e.cursor = n || r, e
        }(e, r.pageOffset, r.target || a)) && (!S.hasAttribute("disabled") || r.doNotReject) && (t = S, o = y.cssClasses.tap, (t.classList ? !t.classList.contains(o) : !new RegExp("\\b" + o + "\\b")
          .test(t.className)) || r.doNotReject) && !(i === w.start && void 0 !== e.buttons && 1 < e.buttons) && (!r.hover || !e.buttons) && (W || e.preventDefault(), e.calcPoint = e.points[y.ort], void n(e, r));
        var t, o
      }
      var o = [];
      return i.split(" ")
        .forEach(function(e) {
          a.addEventListener(e, t, !!W && {
            passive: !0
          }), o.push([e, t])
        }), o
    }

    function z(e) {
      var t, o, i = ee(100 * (e - (e = h, i = y.ort, t = e.getBoundingClientRect(), o = (e = e.ownerDocument)
        .documentElement, e = ae(e), /webkit.*Chrome.*Mobile/i.test(navigator.userAgent) && (e.x = 0), i ? t.top + e.y - o.clientTop : t.left + e.x - o.clientLeft)) / F());
      return y.dir ? 100 - i : i
    }

    function R(e, t) {
      "mouseout" === e.type && "HTML" === e.target.nodeName && null === e.relatedTarget && l(e, t)
    }

    function U(e, t) {
      if (-1 === navigator.appVersion.indexOf("MSIE 9") && 0 === e.buttons && 0 !== t.buttonsProperty) return l(e, t);
      e = (y.dir ? -1 : 1) * (e.calcPoint - t.startCalcPoint);
      B(0 < e, 100 * e / t.baseSize, t.locations, t.handleNumbers)
    }

    function l(e, t) {
      t.handle && (ie(t.handle, y.cssClasses.active), --E), t.listeners.forEach(function(e) {
        j.removeEventListener(e[0], e[1])
      }), 0 === E && (ie(S, y.cssClasses.drag), p(), e.cursor) && (D.style.cursor = "", D.removeEventListener("selectstart", Z)), t.handleNumbers.forEach(function(e) {
        d("change", e), d("set", e), d("end", e)
      })
    }

    function c(e, t) {
      if (1 === t.handleNumbers.length) {
        var o = v[t.handleNumbers[0]];
        if (o.hasAttribute("disabled")) return !1;
        o = o.children[0], E += 1, oe(o, y.cssClasses.active)
      }
      e.stopPropagation();
      var i = [],
        a = s(w.move, j, U, {
          target: e.target,
          handle: o,
          listeners: i,
          startCalcPoint: e.calcPoint,
          baseSize: F(),
          pageOffset: e.pageOffset,
          handleNumbers: t.handleNumbers,
          buttonsProperty: e.buttons,
          locations: C.slice()
        }),
        n = s(w.end, j, l, {
          target: e.target,
          handle: o,
          listeners: i,
          doNotReject: !0,
          handleNumbers: t.handleNumbers
        }),
        o = s("mouseout", j, R, {
          target: e.target,
          handle: o,
          listeners: i,
          doNotReject: !0,
          handleNumbers: t.handleNumbers
        });
      i.push.apply(i, a.concat(n, o)), e.cursor && (D.style.cursor = getComputedStyle(e.target)
        .cursor, 1 < v.length && oe(S, y.cssClasses.drag), D.addEventListener("selectstart", Z, !1)), t.handleNumbers.forEach(function(e) {
        d("start", e)
      })
    }

    function t(e, t) {
      M[e] = M[e] || [], M[e].push(t), "update" === e.split(".")[0] && v.forEach(function(e, t) {
        d("update", t)
      })
    }

    function d(o, i, a) {
      Object.keys(M)
        .forEach(function(e) {
          var t = e.split(".")[0];
          o === t && M[e].forEach(function(e) {
            e.call(_, O.map(y.format.to), i, O.slice(), a || !1, C.slice())
          })
        })
    }

    function u(e, t, o, i, a, n) {
      return 1 < v.length && (i && 0 < t && (o = Math.max(o, e[t - 1] + y.margin)), a) && t < v.length - 1 && (o = Math.min(o, e[t + 1] - y.margin)), 1 < v.length && y.limit && (i && 0 < t && (o = Math.min(o, e[t - 1] + y.limit)), a) && t < v.length - 1 && (o = Math.max(o, e[t + 1] - y.limit)), y.padding && (0 === t && (o = Math.max(o, y.padding[0])), t === v.length - 1) && (o = Math.min(o, 100 - y.padding[1])), ((o = ee(o = P.getStep(o))) !== e[t] || n) && o
    }

    function a(e, t) {
      var o = y.ort;
      return (o ? t : e) + ", " + (o ? e : t)
    }

    function B(e, o, i, t) {
      var a = i.slice(),
        n = [!e, e],
        r = [e, !e],
        s = (t = t.slice(), e && t.reverse(), 1 < t.length ? t.forEach(function(e, t) {
          t = u(a, e, a[e] + o, n[t], r[t], !1);
          !1 === t ? o = 0 : (o = t - a[e], a[e] = t)
        }) : n = r = [!0], !1);
      t.forEach(function(e, t) {
        s = f(e, i[e] + o, n[t], r[t]) || s
      }), s && t.forEach(function(e) {
        d("update", e), d("slide", e)
      })
    }

    function G(e, t) {
      return y.dir ? 100 - e - t : e
    }

    function p() {
      T.forEach(function(e) {
        var t = 50 < C[e] ? -1 : 1,
          t = 3 + (v.length + t * e);
        v[e].style.zIndex = t
      })
    }

    function f(e, t, o, i) {
      return !1 !== (t = u(C, e, t, o, i, !1)) && (function(e, t) {
        C[e] = t, O[e] = P.fromStepping(t);
        t = "translate(" + a(G(t, 0) - K + "%", "0") + ")";
        v[e].style[y.transformRule] = t, q(e), q(e + 1)
      }(e, t), !0)
    }

    function q(e) {
      var t, o;
      g[e] && (o = 100, t = "translate(" + a(G(t = (t = 0) !== e ? C[e - 1] : t, o = (o = e !== g.length - 1 ? C[e] : o) - t) + "%", "0") + ")", o = "scale(" + a(o / 100, "1") + ")", g[e].style[y.transformRule] = t + " " + o)
    }

    function m(e, t) {
      var o = te(e),
        e = void 0 === C[0];
      t = void 0 === t || !!t, y.animate && !e && X(S, y.cssClasses.tap, y.animationDuration), T.forEach(function(e) {
        var t;
        f(e, null === (t = o[e = e]) || !1 === t || void 0 === t || ("number" == typeof t && (t += ""), t = y.format.from(t), !1 === (t = P.toStepping(t))) || isNaN(t) ? C[e] : t, !0, !1)
      }), T.forEach(function(e) {
        f(e, C[e], !0, !0)
      }), p(), T.forEach(function(e) {
        d("update", e), null !== o[e] && t && d("set", e)
      })
    }

    function H() {
      var e = O.map(y.format.to);
      return 1 === e.length ? e[0] : e
    }
    var h, v, g, _, x, k, i, o, V, b, w = window.navigator.pointerEnabled ? {
        start: "pointerdown",
        move: "pointermove",
        end: "pointerup"
      } : window.navigator.msPointerEnabled ? {
        start: "MSPointerDown",
        move: "MSPointerMove",
        end: "MSPointerUp"
      } : {
        start: "mousedown touchstart",
        move: "mousemove touchmove",
        end: "mouseup touchend"
      },
      W = window.CSS && CSS.supports && CSS.supports("touch-action", "none") && function() {
        var e = !1;
        try {
          var t = Object.defineProperty({}, "passive", {
            get: function() {
              e = !0
            }
          });
          window.addEventListener("test", null, t)
        } catch (e) {}
        return e
      }(),
      S = e,
      C = [],
      T = [],
      E = 0,
      P = y.spectrum,
      O = [],
      M = {},
      A = e.ownerDocument,
      j = y.documentElement || A.documentElement,
      D = A.body,
      K = "rtl" === A.dir || 1 === y.ort ? 0 : 100,
      Q = (oe(e = S, y.cssClasses.target), 0 === y.dir ? oe(e, y.cssClasses.ltr) : oe(e, y.cssClasses.rtl), 0 === y.ort ? oe(e, y.cssClasses.horizontal) : oe(e, y.cssClasses.vertical), h = $(e, y.cssClasses.base), y.connect),
      Y = h,
      J = $(Y, y.cssClasses.connects);
    v = [], (g = [])
      .push(N(J, Q[0]));
    for (var L = 0; L < y.handles; L++) v.push((o = L, b = void 0, (b = $(V = $(Y, y.cssClasses.origin), y.cssClasses.handle))
      .setAttribute("data-handle", o), y.keyboardSupport && b.setAttribute("tabindex", "0"), b.setAttribute("role", "slider"), b.setAttribute("aria-orientation", y.ort ? "vertical" : "horizontal"), 0 === o ? oe(b, y.cssClasses.handleLower) : o == y.handles - 1 && oe(b, y.cssClasses.handleUpper), V)), T[L] = L, g.push(N(J, Q[L + 1]));
    return (k = y.events)
      .fixed || v.forEach(function(e, t) {
        s(w.start, e.children[0], c, {
          handleNumbers: [t]
        })
      }), k.tap && s(w.start, h, function(e) {
        e.stopPropagation();
        var o, i, a, t = z(e.calcPoint),
          n = (o = t, a = !(i = 100), v.forEach(function(e, t) {
            !e.hasAttribute("disabled") && ((e = Math.abs(C[t] - o)) < i || 100 === e && 100 === i) && (a = t, i = e)
          }), a);
        return !1 !== n && (y.events.snap || X(S, y.cssClasses.tap, y.animationDuration), f(n, t, !0, !0), p(), d("slide", n, !0), d("update", n, !0), d("change", n, !0), d("set", n, !0), void(y.events.snap && c(e, {
          handleNumbers: [n]
        })))
      }, {}), k.hover && s(w.move, h, function(e) {
        var e = z(e.calcPoint),
          e = P.getStep(e),
          t = P.fromStepping(e);
        Object.keys(M)
          .forEach(function(e) {
            "hover" === e.split(".")[0] && M[e].forEach(function(e) {
              e.call(_, t)
            })
          })
      }, {
        hover: !0
      }), k.drag && g.forEach(function(e, t) {
        var o, i, a;
        !1 !== e && 0 !== t && t !== g.length - 1 && (o = v[t - 1], i = v[t], a = [e], oe(e, y.cssClasses.draggable), k.fixed && (a.push(o.children[0]), a.push(i.children[0])), a.forEach(function(e) {
          s(w.start, e, c, {
            handles: [o, i],
            handleNumbers: [t - 1, t]
          })
        }))
      }), m(y.start), _ = {
        destroy: function() {
          for (var e in y.cssClasses) y.cssClasses.hasOwnProperty(e) && ie(S, y.cssClasses[e]);
          for (; S.firstChild;) S.removeChild(S.firstChild);
          delete S.noUiSlider
        },
        steps: function() {
          return C.map(function(e, t) {
            var o = P.getNearbySteps(e),
              t = O[t],
              i = o.thisStep.step,
              a = null,
              t = (!1 !== i && t + i > o.stepAfter.startValue && (i = o.stepAfter.startValue - t), a = t > o.thisStep.startValue ? o.thisStep.step : !1 !== o.stepBefore.step && t - o.stepBefore.highestStep, 100 === e ? i = null : 0 == e && (a = null), P.countStepDecimals());
            return null !== i && !1 !== i && (i = +i.toFixed(t)), [a = null !== a && !1 !== a ? +a.toFixed(t) : a, i]
          })
        },
        on: t,
        off: function(e) {
          var i = e && e.split(".")[0],
            a = i && e.substring(i.length);
          Object.keys(M)
            .forEach(function(e) {
              var t = e.split(".")[0],
                o = e.substring(t.length);
              i && i !== t || a && a !== o || delete M[e]
            })
        },
        get: H,
        set: m,
        reset: function(e) {
          m(y.start, e)
        },
        __moveHandles: function(e, t, o) {
          B(e, t, C, o)
        },
        options: n,
        updateOptions: function(t, e) {
          var o = H(),
            i = ["margin", "limit", "padding", "range", "animate", "snap", "step", "format"],
            a = (i.forEach(function(e) {
              void 0 !== t[e] && (n[e] = t[e])
            }), ne(n));
          i.forEach(function(e) {
            void 0 !== t[e] && (y[e] = a[e])
          }), P = a.spectrum, y.margin = a.margin, y.limit = a.limit, y.padding = a.padding, y.pips && r(y.pips), C = [], m(t.start || o, e)
        },
        target: S,
        removePips: I,
        pips: r
      }, y.pips && r(y.pips), y.tooltips && (i = v.map(function(e, t) {
        return !!y.tooltips[t] && $(e.firstChild, y.cssClasses.tooltip)
      }), t("update", function(e, t, o) {
        i[t] && (e = e[t], !0 !== y.tooltips[t] && (e = y.tooltips[t].to(o[t])), i[t].innerHTML = e)
      })), t("update", function(e, t, n, o, r) {
        T.forEach(function(e) {
          var t = v[e],
            o = u(C, e, 0, !0, !0, !0),
            i = u(C, e, 100, !0, !0, !0),
            a = r[e],
            e = y.ariaFormat.to(n[e]),
            o = P.fromStepping(o)
            .toFixed(1),
            i = P.fromStepping(i)
            .toFixed(1),
            a = P.fromStepping(a)
            .toFixed(1);
          t.children[0].setAttribute("aria-valuemin", o), t.children[0].setAttribute("aria-valuemax", i), t.children[0].setAttribute("aria-valuenow", a), t.children[0].setAttribute("aria-valuetext", e)
        })
      }), _
  }
  o.prototype.getMargin = function(e) {
    var t = this.xNumSteps[0];
    if (t && 0 != e / t % 1) throw new Error("noUiSlider (12.0.0): 'limit', 'margin' and 'padding' must be divisible by step.");
    return 2 === this.xPct.length && f(this.xVal, e)
  }, o.prototype.toStepping = function(e) {
    return t = this.xVal, o = this.xPct, (e = e) >= t.slice(-1)[0] ? 100 : (a = t[(i = s(e, t)) - 1], t = t[i], n = o[i - 1], o = o[i], n + (i = e, f(e = [a, t], e[0] < 0 ? i + Math.abs(e[0]) : i - e[0]) / p(n, o)));
    var t, o, i, a, n
  }, o.prototype.fromStepping = function(e) {
    return t = this.xVal, o = this.xPct, 100 <= (e = e) ? t.slice(-1)[0] : (a = t[(i = s(e, o)) - 1], t = t[i], (e - (e = o[i - 1])) * p(e, o[i]) * ((e = [a, t])[1] - e[0]) / 100 + e[0]);
    var t, o, i, a
  }, o.prototype.getStep = function(e) {
    return t = this.xPct, o = this.xSteps, i = this.snap, 100 === (e = e) ? e : (n = t[(a = s(e, t)) - 1], r = t[a], i ? (r - n) / 2 < e - n ? r : n : o[a - 1] ? t[a - 1] + (i = e - t[a - 1], r = o[a - 1], Math.round(i / r) * r) : e);
    var t, o, i, a, n, r
  }, o.prototype.getNearbySteps = function(e) {
    e = s(e, this.xPct);
    return {
      stepBefore: {
        startValue: this.xVal[e - 2],
        step: this.xNumSteps[e - 2],
        highestStep: this.xHighestCompleteStep[e - 2]
      },
      thisStep: {
        startValue: this.xVal[e - 1],
        step: this.xNumSteps[e - 1],
        highestStep: this.xHighestCompleteStep[e - 1]
      },
      stepAfter: {
        startValue: this.xVal[e],
        step: this.xNumSteps[e],
        highestStep: this.xHighestCompleteStep[e]
      }
    }
  }, o.prototype.countStepDecimals = function() {
    var e = this.xNumSteps.map(t);
    return Math.max.apply(null, e)
  }, o.prototype.convert = function(e) {
    return this.getStep(this.toStepping(e))
  };
  var O = {
    to: function(e) {
      return void 0 !== e && e.toFixed(2)
    },
    from: Number
  };
  return {
    __spectrum: o,
    version: "12.0.0",
    create: function(e, t) {
      if (!e || !e.nodeName) throw new Error("noUiSlider (12.0.0): create requires a single element, got: " + e);
      if (e.noUiSlider) throw new Error("noUiSlider (12.0.0): Slider was already initialized.");
      t = a(e, ne(t), t);
      return e.noUiSlider = t
    }
  }
}),
function(o) {
  function a(e) {
    var t;
    return (i[e] || (t = i[e] = {
        i: e,
        l: !1,
        exports: {}
      }, o[e].call(t.exports, t, t.exports, a), t.l = !0, t))
      .exports
  }
  var i = {};
  a.m = o, a.c = i, a.d = function(e, t, o) {
    a.o(e, t) || Object.defineProperty(e, t, {
      enumerable: !0,
      get: o
    })
  }, a.r = function(e) {
    "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
      value: "Module"
    }), Object.defineProperty(e, "__esModule", {
      value: !0
    })
  }, a.t = function(t, e) {
    if (1 & e && (t = a(t)), 8 & e) return t;
    if (4 & e && "object" == _typeof(t) && t && t.__esModule) return t;
    var o = Object.create(null);
    if (a.r(o), Object.defineProperty(o, "default", {
        enumerable: !0,
        value: t
      }), 2 & e && "string" != typeof t)
      for (var i in t) a.d(o, i, function(e) {
        return t[e]
      }.bind(null, i));
    return o
  }, a.n = function(e) {
    var t = e && e.__esModule ? function() {
      return e.default
    } : function() {
      return e
    };
    return a.d(t, "a", t), t
  }, a.o = function(e, t) {
    return Object.prototype.hasOwnProperty.call(e, t)
  }, a.p = "", a(a.s = 0)
}([function(e, t, o) {
  function i(e) {
    return e && e.__esModule ? e : {
      default: e
    }
  }
  o(1), o(7), o(8);
  var a = i(o(2)),
    n = i(o(3)),
    r = i(o(4));
  n.default === r.default && o(9), window.Inputmask = a.default
}, function(e, t, o) {
  var i, o = [o(2)];
  void 0 !== (t = "function" == typeof(i = function(e) {
    return e.extendDefinitions({
      A: {
        validator: "[A-Za-zА-яЁёÀ-ÿµ]",
        casing: "upper"
      },
      "&": {
        validator: "[0-9A-Za-zА-яЁёÀ-ÿµ]",
        casing: "upper"
      },
      "#": {
        validator: "[0-9A-Fa-f]",
        casing: "upper"
      }
    }), e.extendAliases({
      cssunit: {
        regex: "[+-]?[0-9]+\\.?([0-9]+)?(px|em|rem|ex|%|in|cm|mm|pt|pc)"
      },
      url: {
        regex: "(https?|ftp)//.*",
        autoUnmask: !1
      },
      ip: {
        mask: "i[i[i]].i[i[i]].i[i[i]].i[i[i]]",
        definitions: {
          i: {
            validator: function(e, t, o) {
              return e = -1 < o - 1 && "." !== t.buffer[o - 1] ? (e = t.buffer[o - 1] + e, -1 < o - 2 && "." !== t.buffer[o - 2] ? t.buffer[o - 2] + e : "0" + e) : "00" + e, /25[0-5]|2[0-4][0-9]|[01][0-9][0-9]/.test(e)
            }
          }
        },
        onUnMask: function(e) {
          return e
        },
        inputmode: "numeric"
      },
      email: {
        mask: "*{1,64}[.*{1,64}][.*{1,64}][.*{1,63}]@-{1,63}.-{1,63}[.-{1,63}][.-{1,63}]",
        greedy: !1,
        casing: "lower",
        onBeforePaste: function(e) {
          return (e = e.toLowerCase())
            .replace("mailto:", "")
        },
        definitions: {
          "*": {
            validator: "[0-9１-９A-Za-zА-яЁёÀ-ÿµ!#$%&'*+/=?^_`{|}~-]"
          },
          "-": {
            validator: "[0-9A-Za-z-]"
          }
        },
        onUnMask: function(e) {
          return e
        },
        inputmode: "email"
      },
      mac: {
        mask: "##:##:##:##:##:##"
      },
      vin: {
        mask: "V{13}9{4}",
        definitions: {
          V: {
            validator: "[A-HJ-NPR-Za-hj-npr-z\\d]",
            casing: "upper"
          }
        },
        clearIncomplete: !0,
        autoUnmask: !0
      }
    }), e
  }) ? i.apply(t, o) : i) && (e.exports = t)
}, function(e, t, o) {
  var i, ue = "function" == typeof Symbol && "symbol" == _typeof(Symbol.iterator) ? function(e) {
    return _typeof(e)
  } : function(e) {
    return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : _typeof(e)
  };
  o = [o(3), o(5), o(6)], void 0 !== (t = "function" == typeof(i = function(oe, ie, ae) {
    function ne(e, t, o) {
      return this instanceof ne ? (this.el = void 0, this.events = {}, this.maskset = void 0, this.refreshValue = !1, void(!0 !== o && (oe.isPlainObject(e) ? t = e : (t = t || {}, e && (t.alias = e)), this.opts = oe.extend(!0, {}, this.defaults, t), this.noMasksCache = t && void 0 !== t.definitions, this.userOptions = t || {}, this.isRTL = this.opts.numericInput, d(this.opts.alias, t, this.opts)))) : new ne(e, t, o)
    }

    function d(e, t, o) {
      var i = ne.prototype.aliases[e];
      return i ? (i.alias && d(i.alias, void 0, o), oe.extend(!0, o, i), oe.extend(!0, o, t), !0) : (null === o.mask && (o.mask = e), !1)
    }

    function r(o, s) {
      function e(e, t, o) {
        var i = !1;
        if ((null === e || "" === e) && ((i = null !== o.regex) ? e = (e = o.regex)
            .replace(/^(\^)(.*)(\$)$/, "$2") : (i = !0, e = ".*")), 1 === e.length && !1 === o.greedy && 0 !== o.repeat && (o.placeholder = ""), 0 < o.repeat || "*" === o.repeat || "+" === o.repeat) {
          var a = "*" === o.repeat ? 0 : "+" === o.repeat ? 1 : o.repeat;
          e = o.groupmarker[0] + e + o.groupmarker[1] + o.quantifiermarker[0] + a + "," + o.repeat + o.quantifiermarker[1]
        }
        var n, r = i ? "regex_" + o.regex : o.numericInput ? e.split("")
          .reverse()
          .join("") : e;
        return void 0 === ne.prototype.masksCache[r] || !0 === s ? (n = {
          mask: e,
          maskToken: ne.prototype.analyseMask(e, i, o),
          validPositions: {},
          _buffer: void 0,
          buffer: void 0,
          tests: {},
          excludes: {},
          metadata: t,
          maskLength: void 0
        }, !0 !== s && (ne.prototype.masksCache[r] = n, n = oe.extend(!0, {}, ne.prototype.masksCache[r]))) : n = oe.extend(!0, {}, ne.prototype.masksCache[r]), n
      }
      if (oe.isFunction(o.mask) && (o.mask = o.mask(o)), oe.isArray(o.mask)) {
        if (1 < o.mask.length) {
          if (null === o.keepStatic) {
            o.keepStatic = "auto";
            for (var t = 0; t < o.mask.length; t++)
              if (o.mask[t].charAt(0) !== o.mask[0].charAt(0)) {
                o.keepStatic = !0;
                break
              }
          }
          var i = o.groupmarker[0];
          return oe.each(o.isRTL ? o.mask.reverse() : o.mask, function(e, t) {
            1 < i.length && (i += o.groupmarker[1] + o.alternatormarker + o.groupmarker[0]), i += void 0 === t.mask || oe.isFunction(t.mask) ? t : t.mask
          }), e(i += o.groupmarker[1], o.mask, o)
        }
        o.mask = o.mask.pop()
      }
      return o.mask && void 0 !== o.mask.mask && !oe.isFunction(o.mask.mask) ? e(o.mask.mask, o.mask, o) : e(o.mask, o.mask, o)
    }

    function re(e) {
      var t = ae.createElement("input"),
        o = "on" + e,
        i = o in t;
      return i || (t.setAttribute(o, "return;"), i = "function" == typeof t[o]), t = null, i
    }

    function se(e, t, G) {
      function p(e, t, o, i, a) {
        var n = G.greedy;
        a && (G.greedy = !1), t = t || 0;
        var r, s, l, c = [],
          d = 0;
        x();
        do {
          if (!0 === e && q()
            .validPositions[d]) s = (l = a && !0 === q()
              .validPositions[d].match.optionality && void 0 === q()
              .validPositions[d + 1] && (!0 === q()
                .validPositions[d].generatedInput || q()
                .validPositions[d].input == G.skipOptionalPartCharacter && 0 < d) ? f(d, v(d, r, d - 1)) : q()
              .validPositions[d])
            .match, r = l.locator.slice(), c.push(!0 === o ? l.input : !1 === o ? s.nativeDef : E(d, s));
          else {
            s = (l = m(d, r, d - 1))
              .match, r = l.locator.slice();
            var u = !0 !== i && (!1 === G.jitMasking ? s.jit : G.jitMasking);
            (!1 === u || void 0 === u || "number" == typeof u && isFinite(u) && u > d) && c.push(!1 === o ? s.nativeDef : E(d, s))
          }
          "auto" === G.keepStatic && s.newBlockMarker && null !== s.fn && (G.keepStatic = d - 1), d++
        } while ((void 0 === A || d < A) && (null !== s.fn || "" !== s.def) || t > d);
        return "" === c[c.length - 1] && c.pop(), (!1 !== o || void 0 === q()
          .maskLength) && (q()
          .maskLength = d - 1), G.greedy = n, c
      }

      function q() {
        return t
      }

      function $(e) {
        var t = q();
        t.buffer = void 0, !0 !== e && (t.validPositions = {}, t.p = 0)
      }

      function x(e, t, o) {
        var i = -1,
          a = -1,
          n = o || q()
          .validPositions;
        for (var r in void 0 === e && (e = -1), n) {
          var s = parseInt(r);
          n[s] && (t || !0 !== n[s].generatedInput) && (s <= e && (i = s), s >= e && (a = s))
        }
        return -1 === i || i == e ? a : -1 == a ? i : e - i < a - e ? i : a
      }

      function I(e) {
        var t = e.locator[e.alternation];
        return "string" == typeof t && 0 < t.length && (t = t.split(",")[0]), void 0 === t ? "" : t.toString()
      }

      function F(e, t) {
        var o = (null == e.alternation ? e.locator : e.mloc[I(e)])
          .join("");
        if ("" !== o)
          for (; o.length < t;) o += "0";
        return o
      }

      function f(e, t) {
        for (var o, i, a, n, r = F(w(e = 0 < e ? e - 1 : 0)), s = 0; s < t.length; s++) {
          o = F(n = t[s], r.length);
          var l = Math.abs(o - r);
          (void 0 === i || "" !== o && l < i || a && a.match.optionality && "master" === a.match.newBlockMarker && (!n.match.optionality || !n.match.newBlockMarker) || a && a.match.optionalQuantifier && !n.match.optionalQuantifier) && (i = l, a = n)
        }
        return a
      }

      function m(e, t, o) {
        return q()
          .validPositions[e] || f(e, v(e, t ? t.slice() : t, o))
      }

      function w(e, t) {
        return q()
          .validPositions[e] ? q()
          .validPositions[e] : (t || v(e))[0]
      }

      function z(e, t) {
        for (var o = !1, i = v(e), a = 0; a < i.length; a++)
          if (i[a].match && i[a].match.def === t) {
            o = !0;
            break
          } return o
      }

      function v(L, e, t) {
        function N(A, j, e, t) {
          function D(e, t, o) {
            function n(o, i) {
              var a = 0 === oe.inArray(o, i.matches);
              return a || oe.each(i.matches, function(e, t) {
                if (!0 === t.isQuantifier ? a = n(o, i.matches[e - 1]) : t.hasOwnProperty("matches") && (a = n(o, t)), a) return !1
              }), a
            }

            function i(e, a, n) {
              var r, s;
              if ((q()
                  .tests[e] || q()
                  .validPositions[e]) && oe.each(q()
                  .tests[e] || [q()
                    .validPositions[e]],
                  function(e, t) {
                    if (t.mloc[a]) return r = t, !1;
                    var o = void 0 === n ? t.alternation : n,
                      i = void 0 === t.locator[o] ? -1 : t.locator[o].toString()
                      .indexOf(a);
                    (void 0 === s || i < s) && -1 !== i && (r = t, s = i)
                  }), r) {
                var t = r.locator[r.alternation];
                return (r.mloc[a] || r.mloc[t] || r.locator)
                  .slice((void 0 === n ? r.alternation : n) + 1)
              }
              return void 0 === n ? void 0 : i(e, a)
            }

            function a(e, t) {
              function o(e) {
                for (var t, o, i = [], a = 0, n = e.length; a < n; a++)
                  if ("-" === e.charAt(a))
                    for (o = e.charCodeAt(a + 1); ++t < o;) i.push(String.fromCharCode(t));
                  else t = e.charCodeAt(a), i.push(e.charAt(a));
                return i.join("")
              }
              return G.regex && null !== e.match.fn && null !== t.match.fn ? -1 !== o(t.match.def.replace(/[\[\]]/g, ""))
                .indexOf(o(e.match.def.replace(/[\[\]]/g, ""))) : e.match.def === t.match.nativeDef
            }

            function r(e, t) {
              return !(!(e.locator.slice(e.alternation)
                .join("") == t.locator.slice(t.alternation)
                .join("")) || null !== e.match.fn || null === t.match.fn) && t.match.fn.test(e.match.def, q(), L, !1, G, !1)
            }

            function s(e, t) {
              if (void 0 === t || e.alternation === t.alternation && -1 === e.locator[e.alternation].toString()
                .indexOf(t.locator[t.alternation])) {
                e.mloc = e.mloc || {};
                var o = e.locator[e.alternation];
                if (void 0 !== o) {
                  if ("string" == typeof o && (o = o.split(",")[0]), void 0 === e.mloc[o] && (e.mloc[o] = e.locator.slice()), void 0 !== t) {
                    for (var i in t.mloc) "string" == typeof i && (i = i.split(",")[0]), void 0 === e.mloc[i] && (e.mloc[i] = t.mloc[i]);
                    e.locator[e.alternation] = Object.keys(e.mloc)
                      .join(",")
                  }
                  return !0
                }
                e.alternation = void 0
              }
              return !1
            }
            if (500 < F && void 0 !== o) throw "Inputmask: There is probably an error in your mask definition or in the code. Create an issue on github with an example of the mask you are using. " + q()
              .mask;
            if (F === L && void 0 === e.matches) return z.push({
              match: e,
              locator: t.reverse(),
              cd: U,
              mloc: {}
            }), !0;
            if (void 0 === e.matches) F++;
            else if (e.isGroup && o !== e) {
              if (e = D(A.matches[oe.inArray(e, A.matches) + 1], t, o)) return !0
            } else if (e.isOptional) {
              var l = e;
              if (e = N(e, j, t, o)) {
                if (oe.each(z, function(e, t) {
                    t.match.optionality = !0
                  }), I = z[z.length - 1].match, void 0 !== o || !n(I, l)) return !0;
                R = !0, F = L
              }
            } else if (e.isAlternator) {
              var c, d = e,
                u = [],
                p = z.slice(),
                f = t.length,
                m = 0 < j.length ? j.shift() : -1;
              if (-1 === m || "string" == typeof m) {
                var h, v = F,
                  g = j.slice(),
                  _ = [];
                if ("string" == typeof m) _ = m.split(",");
                else
                  for (h = 0; h < d.matches.length; h++) _.push(h.toString());
                if (q()
                  .excludes[L]) {
                  for (var k = _.slice(), b = 0, y = q()
                      .excludes[L].length; b < y; b++) _.splice(_.indexOf(q()
                    .excludes[L][b].toString()), 1);
                  0 === _.length && (q()
                    .excludes[L] = void 0, _ = k)
                }(!0 === G.keepStatic || isFinite(parseInt(G.keepStatic)) && v >= G.keepStatic) && (_ = _.slice(0, 1));
                for (var $ = !1, x = 0; x < _.length; x++) {
                  h = parseInt(_[x]), z = [], j = "string" == typeof m && i(F, h, f) || g.slice(), d.matches[h] && D(d.matches[h], [h].concat(t), o) ? e = !0 : 0 === x && ($ = !0), c = z.slice(), F = v, z = [];
                  for (var w = 0; w < c.length; w++) {
                    var S = c[w],
                      C = !1;
                    S.match.jit = S.match.jit || $, S.alternation = S.alternation || f, s(S);
                    for (var T, E = 0; E < u.length; E++)
                      if (T = u[E], "string" != typeof m || void 0 !== S.alternation && -1 !== oe.inArray(S.locator[S.alternation].toString(), _)) {
                        if (S.match.nativeDef === T.match.nativeDef) {
                          C = !0, s(T, S);
                          break
                        }
                        if (a(S, T)) {
                          s(S, T) && (C = !0, u.splice(u.indexOf(T), 0, S));
                          break
                        }
                        if (a(T, S)) {
                          s(T, S);
                          break
                        }
                        if (r(S, T)) {
                          s(S, T) && (C = !0, u.splice(u.indexOf(T), 0, S));
                          break
                        }
                      } C || u.push(S)
                  }
                }
                z = p.concat(u), F = L, R = 0 < z.length, e = 0 < u.length, j = g.slice()
              } else e = D(d.matches[m] || A.matches[m], [m].concat(t), o);
              if (e) return !0
            } else if (e.isQuantifier && o !== A.matches[oe.inArray(e, A.matches) - 1]) {
              for (var P, O = e, M = 0 < j.length ? j.shift() : 0; M < (isNaN(O.quantifier.max) ? M + 1 : O.quantifier.max) && F <= L; M++)
                if (e = D(P = A.matches[oe.inArray(O, A.matches) - 1], [M].concat(t), P)) {
                  if ((I = z[z.length - 1].match)
                    .optionalQuantifier = M > O.quantifier.min - 1, I.jit = (M || 1) * P.matches.indexOf(I) >= O.quantifier.jit, I.optionalQuantifier && n(I, P)) {
                    R = !0, F = L;
                    break
                  }
                  if (I.jit && !I.optionalQuantifier) {
                    B = P.matches.indexOf(I), F = L, R = !0;
                    break
                  }
                  return !0
                }
            } else if (e = N(e, j, t, o)) return !0
          }
          for (var o = 0 < j.length ? j.shift() : 0; o < A.matches.length; o = o + 1 + B)
            if (B = 0, !0 !== A.matches[o].isQuantifier) {
              var i = D(A.matches[o], [o].concat(e), t);
              if (i && F === L) return i;
              if (F > L) break
            }
        }
        var I, o = q()
          .maskToken,
          F = e ? t : 0,
          i = e ? e.slice() : [0],
          z = [],
          R = !1,
          U = e ? e.join("") : "",
          B = 0;
        if (-1 < L) {
          if (void 0 === e) {
            for (var a, n = L - 1; void 0 === (a = q()
                .validPositions[n] || q()
                .tests[n]) && -1 < n;) n--;
            void 0 !== a && -1 < n && (i = function(e, t) {
              var i = [];
              return oe.isArray(t) || (t = [t]), 0 < t.length && (void 0 === t[0].alternation ? 0 === (i = f(e, t.slice())
                  .locator.slice())
                .length && (i = t[0].locator.slice()) : oe.each(t, function(e, t) {
                  if ("" !== t.def)
                    if (0 === i.length) i = t.locator.slice();
                    else
                      for (var o = 0; o < i.length; o++) t.locator[o] && -1 === i[o].toString()
                        .indexOf(t.locator[o]) && (i[o] += "," + t.locator[o])
                })), i
            }(n, a), U = i.join(""), F = n)
          }
          if (q()
            .tests[L] && q()
            .tests[L][0].cd === U) return q()
            .tests[L];
          for (var r = i.shift(); r < o.length && !(N(o[r], i, [r]) && F === L || F > L); r++);
        }
        return (0 === z.length || R) && z.push({
            match: {
              fn: null,
              optionality: !1,
              casing: null,
              def: "",
              placeholder: ""
            },
            locator: [],
            mloc: {},
            cd: U
          }), void 0 !== e && q()
          .tests[L] ? oe.extend(!0, [], z) : (q()
            .tests[L] = oe.extend(!0, [], z), q()
            .tests[L])
      }

      function h() {
        return void 0 === q()
          ._buffer && (q()
            ._buffer = p(!1, 1), void 0 === q()
            .buffer && (q()
              .buffer = q()
              ._buffer.slice())), q()
          ._buffer
      }

      function g(e) {
        return (void 0 === q()
            .buffer || !0 === e) && (q()
            .buffer = p(!0, x(), !0)), q()
          .buffer
      }

      function R(e, t, o) {
        var i, a;
        if (!0 === e) $(), e = 0, t = o.length;
        else
          for (i = e; i < t; i++) delete q()
            .validPositions[i];
        for (a = e, i = e; i < t; i++)
          if ($(!0), o[i] !== G.skipOptionalPartCharacter) {
            var n = C(a, o[i], !0, !0);
            !1 !== n && ($(!0), a = void 0 === n.caret ? n.pos + 1 : n.caret)
          }
      }

      function U(e, t, o) {
        switch (G.casing || t.casing) {
          case "upper":
            e = e.toUpperCase();
            break;
          case "lower":
            e = e.toLowerCase();
            break;
          case "title":
            var i = q()
              .validPositions[o - 1];
            e = 0 === o || i && i.input === String.fromCharCode(ne.keyCode.SPACE) ? e.toUpperCase() : e.toLowerCase();
            break;
          default:
            if (oe.isFunction(G.casing)) {
              var a = Array.prototype.slice.call(arguments);
              a.push(q()
                .validPositions), e = G.casing.apply(this, a)
            }
        }
        return e
      }

      function B(e, t, o) {
        for (var i, a = G.greedy ? t : t.slice(0, 1), n = !1, r = void 0 === o ? [] : o.split(","), s = 0; s < r.length; s++) - 1 !== (i = e.indexOf(r[s])) && e.splice(i, 1);
        for (var l = 0; l < e.length; l++)
          if (-1 !== oe.inArray(e[l], a)) {
            n = !0;
            break
          } return n
      }

      function S(e, t, o, i, a) {
        var n, r, s, l, c, d, u, p = oe.extend(!0, {}, q()
            .validPositions),
          f = !1,
          m = void 0 === a ? x() : a;
        if (-1 === m && void 0 === a) r = (l = w(n = 0))
          .alternation;
        else
          for (; 0 <= m; m--)
            if ((s = q()
                .validPositions[m]) && void 0 !== s.alternation) {
              if (l && l.locator[s.alternation] !== s.locator[s.alternation]) break;
              n = m, r = q()
                .validPositions[n].alternation, l = s
            } if (void 0 !== r) {
          u = parseInt(n), q()
            .excludes[u] = q()
            .excludes[u] || [], !0 !== e && q()
            .excludes[u].push(I(l));
          var h = [],
            v = 0;
          for (c = u; c < x(void 0, !0) + 1; c++)(d = q()
              .validPositions[c]) && !0 !== d.generatedInput ? h.push(d.input) : c < e && v++, delete q()
            .validPositions[c];
          for (; q()
            .excludes[u] && 10 > q()
            .excludes[u].length;) {
            var g = -1 * v,
              _ = h.slice();
            for (q()
              .tests[u] = void 0, $(!0), f = !0; 0 < _.length;) {
              var k = _.shift();
              if (!(f = C(x(void 0, !0) + 1, k, !1, i, !0))) break
            }
            if (f && void 0 !== t) {
              var b = x(e) + 1;
              for (c = u; c < x() + 1; c++)(void 0 === (d = q()
                .validPositions[c]) || null == d.match.fn) && c < e + g && g++;
              f = C((e += g) > b ? b : e, t, o, i, !0)
            }
            if (f) break;
            if ($(), l = w(u), q()
              .validPositions = oe.extend(!0, {}, p), !q()
              .excludes[u]) {
              f = S(e, t, o, i, u - 1);
              break
            }
            var y = I(l);
            if (-1 !== q()
              .excludes[u].indexOf(y)) {
              f = S(e, t, o, i, u - 1);
              break
            }
            for (q()
              .excludes[u].push(y), c = u; c < x(void 0, !0) + 1; c++) delete q()
              .validPositions[c]
          }
        }
        return q()
          .excludes[u] = void 0, f
      }

      function C(c, e, t, d, o, i) {
        function u(e) {
          return D ? 1 < e.begin - e.end || 1 == e.begin - e.end : 1 < e.end - e.begin || 1 == e.end - e.begin
        }

        function a(n, r, s) {
          var l = !1;
          return oe.each(v(n), function(e, t) {
            var o = t.match;
            if (g(!0), !1 !== (l = null == o.fn ? (r === o.def || r === G.skipOptionalPartCharacter) && "" !== o.def && {
                c: E(n, o, !0) || o.def,
                pos: n
              } : o.fn.test(r, q(), n, s, G, u(c)))) {
              var i = void 0 === l.c ? r : l.c,
                a = n;
              return i = i === G.skipOptionalPartCharacter && null === o.fn ? E(n, o, !0) || o.def : i, void 0 !== l.remove && (!oe.isArray(l.remove) && (l.remove = [l.remove]), oe.each(l.remove.sort(function(e, t) {
                return t - e
              }), function(e, t) {
                _({
                  begin: t,
                  end: t + 1
                })
              })), void 0 !== l.insert && (!oe.isArray(l.insert) && (l.insert = [l.insert]), oe.each(l.insert.sort(function(e, t) {
                return e - t
              }), function(e, t) {
                C(t.pos, t.c, !0, d)
              })), !0 !== l && void 0 !== l.pos && l.pos !== n && (a = l.pos), (!0 === l || void 0 !== l.pos || void 0 !== l.c) && (_(c, oe.extend({}, t, {
                input: U(i, o, a)
              }), d, a) || (l = !1), !1)
            }
          }), l
        }
        t = !0 === t;
        var n = c;
        void 0 !== c.begin && (n = D ? c.end : c.begin);
        var r = !0,
          s = oe.extend(!0, {}, q()
            .validPositions);
        if (oe.isFunction(G.preValidation) && !t && !0 !== d && !0 !== i && (r = G.preValidation(g(), n, e, u(c), G, q())), !0 === r) {
          if (H(void 0, n, !0), (void 0 === A || n < A) && (r = a(n, e, t), (!t || !0 === d) && !1 === r && !0 !== i)) {
            var l = q()
              .validPositions[n];
            if (!l || null !== l.match.fn || l.match.def !== e && e !== G.skipOptionalPartCharacter) {
              if ((G.insertMode || void 0 === q()
                  .validPositions[b(n)]) && !k(n, !0))
                for (var p = n + 1, f = b(n); p <= f; p++)
                  if (!1 !== (r = a(p, e, t))) {
                    r = H(n, void 0 === r.pos ? p : r.pos) || r, n = p;
                    break
                  }
            } else r = {
              caret: b(n)
            }
          }!1 === r && !1 !== G.keepStatic && (null == G.regex || O(g())) && !t && !0 !== o && (r = S(n, e, t, d)), !0 === r && (r = {
            pos: n
          })
        }
        if (oe.isFunction(G.postValidation) && !1 !== r && !t && !0 !== d && !0 !== i) {
          var m = G.postValidation(g(!0), void 0 === c.begin ? c : D ? c.end : c.begin, r, G);
          if (void 0 !== m) {
            if (m.refreshFromBuffer && m.buffer) {
              var h = m.refreshFromBuffer;
              R(!0 === h ? h : h.start, h.end, m.buffer)
            }
            r = !0 === m ? r : m
          }
        }
        return r && void 0 === r.pos && (r.pos = n), (!1 === r || !0 === i) && ($(!0), q()
          .validPositions = oe.extend(!0, {}, s)), r
      }

      function H(e, t, o) {
        var i;
        if (void 0 === e)
          for (e = t - 1; 0 < e && !q()
            .validPositions[e]; e--);
        for (var a = e; a < t; a++)
          if (void 0 === q()
            .validPositions[a] && !k(a, !0))
            if (0 == a ? w(a) : q()
              .validPositions[a - 1]) {
              var n = v(a)
                .slice();
              "" === n[n.length - 1].match.def && n.pop();
              var r = f(a, n);
              if ((r = oe.extend({}, r, {
                  input: E(a, r.match, !0) || r.match.def
                }))
                .generatedInput = !0, _(a, r, !0), !0 !== o) {
                var s = q()
                  .validPositions[t].input;
                q()
                  .validPositions[t] = void 0, i = C(t, s, !0, !0)
              }
            } return i
      }

      function _(e, t, o, i) {
        function a(e, t, o) {
          var i = t[e];
          if (void 0 !== i && (null === i.match.fn && !0 !== i.match.optionality || i.input === G.radixPoint)) {
            var a = o.begin <= e - 1 ? t[e - 1] && null === t[e - 1].match.fn && t[e - 1] : t[e - 1],
              n = o.end > e + 1 ? t[e + 1] && null === t[e + 1].match.fn && t[e + 1] : t[e + 1];
            return a && n
          }
          return !1
        }
        var n = void 0 === e.begin ? e : e.begin,
          r = void 0 === e.end ? e : e.end;
        if (e.begin > e.end && (n = e.end, r = e.begin), i = void 0 === i ? n : i, n !== r || G.insertMode && void 0 !== q()
          .validPositions[i] && void 0 === o) {
          var s = oe.extend(!0, {}, q()
              .validPositions),
            l = x(void 0, !0);
          for (q()
            .p = n, f = l; f >= n; f--) q()
            .validPositions[f] && "+" === q()
            .validPositions[f].match.nativeDef && (G.isNegative = !1), delete q()
            .validPositions[f];
          var c = !0,
            d = i,
            u = (q()
              .validPositions, !1),
            p = d,
            f = d;
          for (t && (q()
              .validPositions[i] = oe.extend(!0, {}, t), p++, d++, n < r && f++); f <= l; f++) {
            var m = s[f];
            if (void 0 !== m && (f >= r || f >= n && !0 !== m.generatedInput && a(f, s, {
                begin: n,
                end: r
              }))) {
              for (;
                "" !== w(p)
                .match.def;) {
                if (!1 === u && s[p] && s[p].match.nativeDef === m.match.nativeDef) q()
                  .validPositions[p] = oe.extend(!0, {}, s[p]), q()
                  .validPositions[p].input = m.input, H(void 0, p, !0), d = p + 1, c = !0;
                else if (z(p, m.match.def)) {
                  var h = C(p, m.input, !0, !0);
                  c = !1 !== h, d = h.caret || h.insert ? x() : p + 1, u = !0
                } else c = !0 === m.generatedInput || m.input === G.radixPoint && !0 === G.numericInput;
                if (c) break;
                if (!c && p > r && k(p, !0) && (null !== m.match.fn || p > q()
                    .maskLength)) break;
                p++
              }
              "" == w(p)
                .match.def && (c = !1), p = d
            }
            if (!c) break
          }
          if (!c) return q()
            .validPositions = oe.extend(!0, {}, s), $(!0), !1
        } else t && (q()
          .validPositions[i] = oe.extend(!0, {}, t));
        return $(!0), !0
      }

      function k(e, t) {
        var o = m(e)
          .match;
        if ("" === o.def && (o = w(e)
            .match), null != o.fn) return o.fn;
        if (!0 !== t && -1 < e) {
          var i = v(e);
          return i.length > 1 + ("" === i[i.length - 1].match.def ? 1 : 0)
        }
        return !1
      }

      function b(e, t) {
        for (var o = e + 1;
          "" !== w(o)
          .match.def && (!0 === t && (!0 !== w(o)
            .match.newBlockMarker || !k(o)) || !0 !== t && !k(o));) o++;
        return o
      }

      function y(e, t) {
        var o, i = e;
        if (0 >= i) return 0;
        for (; 0 < --i && (!0 === t && !0 !== w(i)
            .match.newBlockMarker || !0 !== t && !k(i) && (2 > (o = v(i))
              .length || 2 === o.length && "" === o[1].match.def)););
        return i
      }

      function T(e, t, o, i, a) {
        if (i && oe.isFunction(G.onBeforeWrite)) {
          var n = G.onBeforeWrite.call(u, i, t, o, G);
          if (n) {
            if (n.refreshFromBuffer) {
              var r = n.refreshFromBuffer;
              R(!0 === r ? r : r.start, r.end, n.buffer || t), t = g(!0)
            }
            void 0 !== o && (o = void 0 === n.caret ? o : n.caret)
          }
        }
        if (void 0 !== e && (e.inputmask._valueSet(t.join("")), void 0 === o || void 0 !== i && "blur" === i.type ? W(e, o, 0 === t.length) : P(e, o), !0 === a)) {
          var s = oe(e),
            l = e.inputmask._valueGet();
          L = !0, s.trigger("input"), setTimeout(function() {
            l === h()
              .join("") ? s.trigger("cleared") : !0 === O(t) && s.trigger("complete")
          }, 0)
        }
      }

      function E(e, t, o) {
        if (void 0 !== (t = t || w(e)
            .match)
          .placeholder || !0 === o) return oe.isFunction(t.placeholder) ? t.placeholder(G) : t.placeholder;
        if (null === t.fn) {
          if (-1 < e && void 0 === q()
            .validPositions[e]) {
            var i, a = v(e),
              n = [];
            if (a.length > 1 + ("" === a[a.length - 1].match.def ? 1 : 0))
              for (var r = 0; r < a.length; r++)
                if (!0 !== a[r].match.optionality && !0 !== a[r].match.optionalQuantifier && (null === a[r].match.fn || void 0 === i || !1 !== a[r].match.fn.test(i.match.def, q(), e, !0, G)) && (n.push(a[r]), null === a[r].match.fn && (i = a[r]), 1 < n.length && /[0-9a-bA-Z]/.test(n[0].match.def))) return G.placeholder.charAt(e % G.placeholder.length)
          }
          return t.def
        }
        return G.placeholder.charAt(e % G.placeholder.length)
      }

      function d(a, e, n, t, o) {
        var r, s = this || a.inputmask,
          l = t.slice(),
          c = "",
          d = -1;
        if ($(), n || !0 === G.autoUnmask) d = b(d);
        else {
          var i = h()
            .slice(0, b(-1))
            .join(""),
            u = l.join("")
            .match(new RegExp("^" + ne.escapeRegex(i), "g"));
          u && 0 < u.length && (l.splice(0, u.length * i.length), d = b(d))
        } - 1 === d ? (q()
            .p = b(d), d = 0) : q()
          .p = d, s.caretPos = {
            begin: d
          }, oe.each(l, function(e, t) {
            if (void 0 !== t)
              if (void 0 === q()
                .validPositions[e] && l[e] === E(e) && k(e, !0) && !1 === C(e, l[e], !0, void 0, void 0, !0)) q()
                .p++;
              else {
                var o = new oe.Event("_checkval");
                o.which = t.charCodeAt(0), c += t;
                var i = x(void 0, !0);
                ! function(e, t) {
                  return -1 !== p(!0, 0, !1)
                    .slice(e, b(e))
                    .join("")
                    .replace(/'/g, "")
                    .indexOf(t) && !k(e) && (w(e)
                      .match.nativeDef === t.charAt(0) || null === w(e)
                      .match.fn && w(e)
                      .match.nativeDef === "'" + t.charAt(0) || " " === w(e)
                      .match.nativeDef && (w(e + 1)
                        .match.nativeDef === t.charAt(0) || null === w(e + 1)
                        .match.fn && w(e + 1)
                        .match.nativeDef === "'" + t.charAt(0)))
                }(d, c) ? (r = N.keypressEvent.call(a, o, !0, !1, n, s.caretPos.begin)) && (d = s.caretPos.begin + 1, c = "") : r = N.keypressEvent.call(a, o, !0, !1, n, i + 1), r && (T(void 0, g(), r.forwardPosition, o, !1), s.caretPos = {
                  begin: r.forwardPosition,
                  end: r.forwardPosition
                })
              }
          }), e && T(a, g(), r ? r.forwardPosition : void 0, o || new oe.Event("checkval"), o && "input" === o.type)
      }

      function i(e) {
        if (e) {
          if (void 0 === e.inputmask) return e.value;
          e.inputmask && e.inputmask.refreshValue && N.setValueEvent.call(e)
        }
        var t = [],
          o = q()
          .validPositions;
        for (var i in o) o[i].match && null != o[i].match.fn && t.push(o[i].input);
        var a = 0 === t.length ? "" : (D ? t.reverse() : t)
          .join("");
        if (oe.isFunction(G.onUnMask)) {
          var n = (D ? g()
              .slice()
              .reverse() : g())
            .join("");
          a = G.onUnMask.call(u, n, a, G)
        }
        return a
      }

      function P(e, t, o, i) {
        function a(e) {
          return D && "number" == typeof e && (!G.greedy || "" !== G.placeholder) && c && (e = c.inputmask._valueGet()
            .length - e), e
        }
        var n;
        if (void 0 === t) return "selectionStart" in e ? (t = e.selectionStart, o = e.selectionEnd) : ie.getSelection ? ((n = ie.getSelection()
            .getRangeAt(0))
          .commonAncestorContainer.parentNode === e || n.commonAncestorContainer === e) && (t = n.startOffset, o = n.endOffset) : ae.selection && ae.selection.createRange && (o = (t = 0 - (n = ae.selection.createRange())
          .duplicate()
          .moveStart("character", -e.inputmask._valueGet()
            .length)) + n.text.length), {
          begin: i ? t : a(t),
          end: i ? o : a(o)
        };
        if (oe.isArray(t) && (o = D ? t[0] : t[1], t = D ? t[1] : t[0]), void 0 !== t.begin && (o = D ? t.begin : t.end, t = D ? t.end : t.begin), "number" == typeof t) {
          t = i ? t : a(t), o = "number" == typeof(o = i ? o : a(o)) ? o : t;
          var r = parseInt(((e.ownerDocument.defaultView || ie)
              .getComputedStyle ? (e.ownerDocument.defaultView || ie)
              .getComputedStyle(e, null) : e.currentStyle)
            .fontSize) * o;
          if (e.scrollLeft = r > e.scrollWidth ? r : 0, e.inputmask.caretPos = {
              begin: t,
              end: o
            }, e === ae.activeElement) {
            if ("selectionStart" in e) e.selectionStart = t, e.selectionEnd = o;
            else if (ie.getSelection) {
              if (n = ae.createRange(), void 0 === e.firstChild || null === e.firstChild) {
                var s = ae.createTextNode("");
                e.appendChild(s)
              }
              n.setStart(e.firstChild, t < e.inputmask._valueGet()
                .length ? t : e.inputmask._valueGet()
                .length), n.setEnd(e.firstChild, o < e.inputmask._valueGet()
                .length ? o : e.inputmask._valueGet()
                .length), n.collapse(!0);
              var l = ie.getSelection();
              l.removeAllRanges(), l.addRange(n)
            } else e.createTextRange && ((n = e.createTextRange())
              .collapse(!0), n.moveEnd("character", o), n.moveStart("character", t), n.select());
            W(e, {
              begin: t,
              end: o
            })
          }
        }
      }

      function r(e) {
        var t, o, i = p(!0, x(), !0, !0),
          a = i.length,
          n = x(),
          r = {},
          s = q()
          .validPositions[n],
          l = void 0 === s ? void 0 : s.locator.slice();
        for (t = n + 1; t < i.length; t++) l = (o = m(t, l, t - 1))
          .locator.slice(), r[t] = oe.extend(!0, {}, o);
        var c = s && void 0 !== s.alternation ? s.locator[s.alternation] : void 0;
        for (t = a - 1; t > n && ((o = r[t])
            .match.optionality || o.match.optionalQuantifier && o.match.newBlockMarker || c && (c !== r[t].locator[s.alternation] && null != o.match.fn || null === o.match.fn && o.locator[s.alternation] && B(o.locator[s.alternation].toString()
              .split(","), c.toString()
              .split(",")) && "" !== v(t)[0].def)) && i[t] === E(t, o.match); t--) a--;
        return e ? {
          l: a,
          def: r[a] ? r[a].match : void 0
        } : a
      }

      function s(e) {
        e.length = 0;
        for (var t, o = p(!0, 0, !0, void 0, !0); void 0 !== (t = o.shift());) e.push(t);
        return e
      }

      function O(e) {
        if (oe.isFunction(G.isComplete)) return G.isComplete(e, G);
        if ("*" !== G.repeat) {
          var t = !1,
            o = r(!0),
            i = y(o.l);
          if (void 0 === o.def || o.def.newBlockMarker || o.def.optionality || o.def.optionalQuantifier) {
            t = !0;
            for (var a, n = 0; n <= i; n++)
              if (null !== (a = m(n)
                  .match)
                .fn && void 0 === q()
                .validPositions[n] && !0 !== a.optionality && !0 !== a.optionalQuantifier || null === a.fn && e[n] !== E(n, a)) {
                t = !1;
                break
              }
          }
          return t
        }
      }

      function V(e, t, o, i, a) {
        if ((G.numericInput || D) && (t === ne.keyCode.BACKSPACE ? t = ne.keyCode.DELETE : t === ne.keyCode.DELETE && (t = ne.keyCode.BACKSPACE), D)) {
          var n = o.end;
          o.end = o.begin, o.begin = n
        }
        if (t === ne.keyCode.BACKSPACE && 1 > o.end - o.begin ? (o.begin = y(o.begin), void 0 !== q()
            .validPositions[o.begin] && q()
            .validPositions[o.begin].input === G.groupSeparator && o.begin--) : t === ne.keyCode.DELETE && o.begin === o.end && (o.end = k(o.end, !0) && q()
            .validPositions[o.end] && q()
            .validPositions[o.end].input !== G.radixPoint ? o.end + 1 : b(o.end) + 1, void 0 !== q()
            .validPositions[o.begin] && q()
            .validPositions[o.begin].input === G.groupSeparator && o.end++), _(o), !0 !== i && !1 !== G.keepStatic || null !== G.regex) {
          var r = S(!0);
          if (r) {
            var s = void 0 === r.caret ? r.pos ? b(r.pos.begin ? r.pos.begin : r.pos) : x(-1, !0) : r.caret;
            (t !== ne.keyCode.DELETE || o.begin > s) && o.begin
          }
        }
        var l = x(o.begin, !0);
        if (l < o.begin || -1 === o.begin) q()
          .p = b(l);
        else if (!0 !== i && (q()
            .p = o.begin, !0 !== a))
          for (; q()
            .p < l && void 0 === q()
            .validPositions[q()
              .p];) q()
            .p++
      }

      function n(c) {
        var d = (c.ownerDocument.defaultView || ie)
          .getComputedStyle(c, null),
          e = ae.createElement("div");
        e.style.width = d.width, e.style.textAlign = d.textAlign, j = ae.createElement("div"), c.inputmask.colorMask = j, j.className = "im-colormask", c.parentNode.insertBefore(j, c), c.parentNode.removeChild(c), j.appendChild(c), j.appendChild(e), c.style.left = e.offsetLeft + "px", oe(j)
          .on("mouseleave", function(e) {
            return N.mouseleaveEvent.call(c, [e])
          }), oe(j)
          .on("mouseenter", function(e) {
            return N.mouseenterEvent.call(c, [e])
          }), oe(j)
          .on("click", function(e) {
            return P(c, function(e) {
              var t, o = ae.createElement("span");
              for (var i in d) isNaN(i) && -1 !== i.indexOf("font") && (o.style[i] = d[i]);
              o.style.textTransform = d.textTransform, o.style.letterSpacing = d.letterSpacing, o.style.position = "absolute", o.style.height = "auto", o.style.width = "auto", o.style.visibility = "hidden", o.style.whiteSpace = "nowrap", ae.body.appendChild(o);
              var a, n = c.inputmask._valueGet(),
                r = 0;
              for (t = 0, a = n.length; t <= a; t++) {
                if (o.innerHTML += n.charAt(t) || "_", o.offsetWidth >= e) {
                  var s = e - r,
                    l = o.offsetWidth - e;
                  o.innerHTML = n.charAt(t), t = (s -= o.offsetWidth / 3) < l ? t - 1 : t;
                  break
                }
                r = o.offsetWidth
              }
              return ae.body.removeChild(o), t
            }(e.clientX)), N.clickEvent.call(c, [e])
          })
      }

      function W(e, t, o) {
        function i(e) {
          if (void 0 === e && (e = ""), l || null !== a.fn && void 0 !== n.input)
            if (l && (null !== a.fn && void 0 !== n.input || "" === a.def)) {
              l = !1;
              var t = s.length;
              s[t - 1] = s[t - 1] + "</span>", s.push(e)
            } else s.push(e);
          else l = !0, s.push("<span class='im-static'>" + e)
        }
        var a, n, r, s = [],
          l = !1,
          c = 0;
        if (void 0 !== j) {
          var d = g();
          if (void 0 === t ? t = P(e) : void 0 === t.begin && (t = {
              begin: t,
              end: t
            }), !0 !== o) {
            var u = x();
            do {
              q()
                .validPositions[c] ? (n = q()
                  .validPositions[c], a = n.match, r = n.locator.slice(), i(d[c])) : (n = m(c, r, c - 1), a = n.match, r = n.locator.slice(), !1 === G.jitMasking || c < u || "number" == typeof G.jitMasking && isFinite(G.jitMasking) && G.jitMasking > c ? i(E(c, a)) : l = !1), c++
            } while ((void 0 === A || c < A) && (null !== a.fn || "" !== a.def) || u > c || l);
            l && i(), ae.activeElement === e && (s.splice(t.begin, 0, t.begin === t.end || t.end > q()
              .maskLength ? '<mark class="im-caret" style="border-right-width: 1px;border-right-style: solid;">' : '<mark class="im-caret-select">'), s.splice(t.end + 1, 0, "</mark>"))
          }
          var p = j.getElementsByTagName("div")[0];
          p.innerHTML = s.join(""), e.inputmask.positionColorMask(e, p)
        }
      }
      t = t || this.maskset, G = G || this.opts;
      var M, a, A, j, o, u = this,
        c = this.el,
        D = this.isRTL,
        K = !1,
        L = !1,
        Q = !1,
        Y = !1,
        J = "",
        l = {
          on: function e(t, o, n) {
            var i = function e(t) {
              var o = this;
              if (void 0 === o.inputmask && "FORM" !== this.nodeName) {
                var e = oe.data(o, "_inputmask_opts");
                e ? new ne(e)
                  .mask(o) : l.off(o)
              } else {
                if ("setvalue" === t.type || "FORM" === this.nodeName || !(o.disabled || o.readOnly && !("keydown" === t.type && t.ctrlKey && 67 === t.keyCode || !1 === G.tabThrough && t.keyCode === ne.keyCode.TAB))) {
                  switch (t.type) {
                    case "input":
                      if (!0 === L) return L = !1, t.preventDefault();
                      if (le) {
                        var i = arguments;
                        return setTimeout(function() {
                          n.apply(o, i), P(o, o.inputmask.caretPos, void 0, !0)
                        }, 0), !1
                      }
                      break;
                    case "keydown":
                      K = !1, L = !1;
                      break;
                    case "keypress":
                      if (1 == K) return t.preventDefault();
                      K = !0;
                      break;
                    case "click":
                      if (ce || de) {
                        i = arguments;
                        return setTimeout(function() {
                          n.apply(o, i)
                        }, 0), !1
                      }
                  }
                  var a = n.apply(o, arguments);
                  return !1 === a && (t.preventDefault(), t.stopPropagation()), a
                }
                t.preventDefault()
              }
            };
            t.inputmask.events[o] = t.inputmask.events[o] || [], t.inputmask.events[o].push(i), -1 === oe.inArray(o, ["submit", "reset"]) ? oe(t)
              .on(o, i) : null !== t.form && oe(t.form)
              .on(o, i)
          },
          off: function e(i, t) {
            var o;
            i.inputmask && i.inputmask.events && (t ? (o = [])[t] = i.inputmask.events[t] : o = i.inputmask.events, oe.each(o, function(e, t) {
              for (; 0 < t.length;) {
                var o = t.pop(); - 1 === oe.inArray(e, ["submit", "reset"]) ? oe(i)
                  .off(e, o) : null !== i.form && oe(i.form)
                  .off(e, o)
              }
              delete i.inputmask.events[e]
            }))
          }
        },
        N = {
          keydownEvent: function e(t) {
            var o = this,
              i = oe(o),
              a = t.keyCode,
              n = P(o);
            if (a === ne.keyCode.BACKSPACE || a === ne.keyCode.DELETE || de && a === ne.keyCode.BACKSPACE_SAFARI || t.ctrlKey && a === ne.keyCode.X && !re("cut")) t.preventDefault(), V(0, a, n), T(o, g(!0), q()
              .p, t, o.inputmask._valueGet() !== g()
              .join(""));
            else if (a === ne.keyCode.END || a === ne.keyCode.PAGE_DOWN) {
              t.preventDefault();
              var r = b(x());
              P(o, t.shiftKey ? n.begin : r, r, !0)
            } else a === ne.keyCode.HOME && !t.shiftKey || a === ne.keyCode.PAGE_UP ? (t.preventDefault(), P(o, 0, t.shiftKey ? n.begin : 0, !0)) : (G.undoOnEscape && a === ne.keyCode.ESCAPE || 90 === a && t.ctrlKey) && !0 !== t.altKey ? (d(o, !0, !1, M.split("")), i.trigger("click")) : a !== ne.keyCode.INSERT || t.shiftKey || t.ctrlKey ? !0 === G.tabThrough && a === ne.keyCode.TAB && (!0 === t.shiftKey ? (null === w(n.begin)
                .match.fn && (n.begin = b(n.begin)), n.end = y(n.begin, !0), n.begin = y(n.end, !0)) : (n.begin = b(n.begin, !0), n.end = b(n.begin, !0), n.end < q()
                .maskLength && n.end--), n.begin < q()
              .maskLength && (t.preventDefault(), P(o, n.begin, n.end))) : (G.insertMode = !G.insertMode, o.setAttribute("im-insert", G.insertMode));
            G.onKeyDown.call(this, t, g(), P(o)
              .begin, G), Q = -1 !== oe.inArray(a, G.ignorables)
          },
          keypressEvent: function e(t, o, i, a, n) {
            var r = this,
              s = oe(r),
              l = t.which || t.charCode || t.keyCode;
            if (!0 !== o && (!t.ctrlKey || !t.altKey) && (t.ctrlKey || t.metaKey || Q)) return l === ne.keyCode.ENTER && M !== g()
              .join("") && (M = g()
                .join(""), setTimeout(function() {
                  s.trigger("change")
                }, 0)), !0;
            if (l) {
              46 === l && !1 === t.shiftKey && "" !== G.radixPoint && (l = G.radixPoint.charCodeAt(0));
              var c, d = o ? {
                  begin: n,
                  end: n
                } : P(r),
                u = String.fromCharCode(l),
                p = 0;
              if (G._radixDance && G.numericInput) {
                var f = g()
                  .indexOf(G.radixPoint.charAt(0)) + 1;
                d.begin <= f && (l === G.radixPoint.charCodeAt(0) && (p = 1), d.begin -= 1, d.end -= 1)
              }
              q()
                .writeOutBuffer = !0;
              var m = C(d, u, a);
              if (!1 !== m && ($(!0), c = void 0 === m.caret ? b(m.pos.begin ? m.pos.begin : m.pos) : m.caret, q()
                  .p = c), c = (G.numericInput && void 0 === m.caret ? y(c) : c) + p, !1 !== i && (setTimeout(function() {
                    G.onKeyValidation.call(r, l, m, G)
                  }, 0), q()
                  .writeOutBuffer && !1 !== m)) {
                var h = g();
                T(r, h, c, t, !0 !== o)
              }
              if (t.preventDefault(), o) return !1 !== m && (m.forwardPosition = c), m
            }
          },
          pasteEvent: function e(t) {
            var o, i = this,
              a = t.originalEvent || t,
              n = (oe(i), i.inputmask._valueGet(!0)),
              r = P(i);
            D && (o = r.end, r.end = r.begin, r.begin = o);
            var s = n.substr(0, r.begin),
              l = n.substr(r.end, n.length);
            if (s === (D ? h()
                .reverse() : h())
              .slice(0, r.begin)
              .join("") && (s = ""), l === (D ? h()
                .reverse() : h())
              .slice(r.end)
              .join("") && (l = ""), ie.clipboardData && ie.clipboardData.getData) n = s + ie.clipboardData.getData("Text") + l;
            else {
              if (!a.clipboardData || !a.clipboardData.getData) return !0;
              n = s + a.clipboardData.getData("text/plain") + l
            }
            var c = n;
            if (oe.isFunction(G.onBeforePaste)) {
              if (!1 === (c = G.onBeforePaste.call(u, n, G))) return t.preventDefault();
              c || (c = n)
            }
            return d(i, !1, !1, c.toString()
              .split("")), T(i, g(), b(x()), t, M !== g()
              .join("")), t.preventDefault()
          },
          inputFallBackEvent: function e(t) {
            var i = this,
              o = i.inputmask._valueGet();
            if (g()
              .join("") !== o) {
              var a = P(i);
              if (o = function(e, t, o) {
                  if (ce) {
                    var i = t.replace(g()
                      .join(""), "");
                    if (1 === i.length) {
                      var a = t.split("");
                      a.splice(o.begin, 0, i), t = a.join("")
                    }
                  }
                  return t
                }(0, o = function(e, t, o) {
                  return "." === t.charAt(o.begin - 1) && "" !== G.radixPoint && ((t = t.split(""))[o.begin - 1] = G.radixPoint.charAt(0), t = t.join("")), t
                }(0, o, a), a), g()
                .join("") !== o) {
                var n = g()
                  .join(""),
                  r = !G.numericInput && o.length > n.length ? -1 : 0,
                  s = o.substr(0, a.begin),
                  l = o.substr(a.begin),
                  c = n.substr(0, a.begin + r),
                  d = n.substr(a.begin + r),
                  u = a,
                  p = "",
                  f = !1;
                if (s !== c) {
                  var m, h = (f = s.length >= c.length) ? s.length : c.length;
                  for (m = 0; s.charAt(m) === c.charAt(m) && m < h; m++);
                  f && (u.begin = m - r, p += s.slice(m, u.end))
                }
                if (l !== d && (l.length > d.length ? p += l.slice(0, 1) : l.length < d.length && (u.end += d.length - l.length, !f && "" !== G.radixPoint && "" === l && s.charAt(u.begin + r - 1) === G.radixPoint && (u.begin--, p = G.radixPoint))), T(i, g(), {
                    begin: u.begin + r,
                    end: u.end + r
                  }), 0 < p.length) oe.each(p.split(""), function(e, t) {
                  var o = new oe.Event("keypress");
                  o.which = t.charCodeAt(0), Q = !1, N.keypressEvent.call(i, o)
                });
                else {
                  u.begin === u.end - 1 && (u.begin = y(u.begin + 1), u.begin === u.end - 1 ? P(i, u.begin) : P(i, u.begin, u.end));
                  var v = new oe.Event("keydown");
                  v.keyCode = G.numericInput ? ne.keyCode.BACKSPACE : ne.keyCode.DELETE, N.keydownEvent.call(i, v)
                }
                t.preventDefault()
              }
            }
          },
          beforeInputEvent: function e(t) {
            if (t.cancelable) {
              var i = this;
              switch (t.inputType) {
                case "insertText":
                  return oe.each(t.data.split(""), function(e, t) {
                    var o = new oe.Event("keypress");
                    o.which = t.charCodeAt(0), Q = !1, N.keypressEvent.call(i, o)
                  }), t.preventDefault();
                case "deleteContentBackward":
                  return (o = new oe.Event("keydown"))
                    .keyCode = ne.keyCode.BACKSPACE, N.keydownEvent.call(i, o), t.preventDefault();
                case "deleteContentForward":
                  var o;
                  return (o = new oe.Event("keydown"))
                    .keyCode = ne.keyCode.DELETE, N.keydownEvent.call(i, o), t.preventDefault()
              }
            }
          },
          setValueEvent: function e(t) {
            this.inputmask.refreshValue = !1;
            var o = this,
              i = (i = t && t.detail ? t.detail[0] : arguments[1]) || o.inputmask._valueGet(!0);
            oe.isFunction(G.onBeforeMask) && (i = G.onBeforeMask.call(u, i, G) || i), d(o, !0, !1, i = i.split("")), M = g()
              .join(""), (G.clearMaskOnLostFocus || G.clearIncomplete) && o.inputmask._valueGet() === h()
              .join("") && o.inputmask._valueSet("")
          },
          focusEvent: function e(t) {
            var o = this,
              i = o.inputmask._valueGet();
            G.showMaskOnFocus && (!G.showMaskOnHover || G.showMaskOnHover && "" === i) && (o.inputmask._valueGet() === g()
                .join("") ? !1 === Y && P(o, b(x())) : T(o, g(), b(x()))), !0 === G.positionCaretOnTab && !1 === Y && N.clickEvent.apply(o, [t, !0]), M = g()
              .join("")
          },
          mouseleaveEvent: function e() {
            Y = !1, G.clearMaskOnLostFocus && ae.activeElement !== this && (this.placeholder = J)
          },
          clickEvent: function e(t, c) {
            function d(e) {
              if ("" !== G.radixPoint) {
                var t = q()
                  .validPositions;
                if (void 0 === t[e] || t[e].input === E(e)) {
                  if (e < b(-1)) return !0;
                  var o = oe.inArray(G.radixPoint, g());
                  if (-1 !== o) {
                    for (var i in t)
                      if (o < i && t[i].input !== E(i)) return !1;
                    return !0
                  }
                }
              }
              return !1
            }
            var u = this;
            setTimeout(function() {
              if (ae.activeElement === u) {
                var e = P(u);
                if (c && (D ? e.end = e.begin : e.begin = e.end), e.begin === e.end) switch (G.positionCaretOnClick) {
                  case "none":
                    break;
                  case "select":
                    P(u, 0, g()
                      .length);
                    break;
                  case "ignore":
                    P(u, b(x()));
                    break;
                  case "radixFocus":
                    if (d(e.begin)) {
                      var t = g()
                        .join("")
                        .indexOf(G.radixPoint);
                      P(u, G.numericInput ? b(t) : t);
                      break
                    }
                  default:
                    var o = e.begin,
                      i = x(o, !0),
                      a = b(i);
                    if (o < a) P(u, k(o, !0) || k(o - 1, !0) ? o : b(o));
                    else {
                      var n = q()
                        .validPositions[i],
                        r = m(a, n ? n.match.locator : void 0, n),
                        s = E(a, r.match);
                      if ("" !== s && g()[a] !== s && !0 !== r.match.optionalQuantifier && !0 !== r.match.newBlockMarker || !k(a, G.keepStatic) && r.match.def === s) {
                        var l = b(a);
                        (o >= l || o === a) && (a = l)
                      }
                      P(u, a)
                    }
                }
              }
            }, 0)
          },
          cutEvent: function e(t) {
            var o = this,
              i = (oe(o), P(o)),
              a = t.originalEvent || t,
              n = ie.clipboardData || a.clipboardData,
              r = D ? g()
              .slice(i.end, i.begin) : g()
              .slice(i.begin, i.end);
            n.setData("text", D ? r.reverse()
              .join("") : r.join("")), ae.execCommand && ae.execCommand("copy"), V(0, ne.keyCode.DELETE, i), T(o, g(), q()
              .p, t, M !== g()
              .join(""))
          },
          blurEvent: function e(t) {
            var o = oe(this),
              i = this;
            if (i.inputmask) {
              i.placeholder = J;
              var a = i.inputmask._valueGet(),
                n = g()
                .slice();
              ("" !== a || void 0 !== j) && (G.clearMaskOnLostFocus && (-1 === x() && a === h()
                .join("") ? n = [] : s(n)), !1 === O(n) && (setTimeout(function() {
                o.trigger("incomplete")
              }, 0), G.clearIncomplete && ($(), n = G.clearMaskOnLostFocus ? [] : h()
                .slice())), T(i, n, void 0, t)), M !== g()
                .join("") && (M = n.join(""), o.trigger("change"))
            }
          },
          mouseenterEvent: function e() {
            Y = !0, ae.activeElement !== this && G.showMaskOnHover && (this.placeholder = (D ? g()
                .slice()
                .reverse() : g())
              .join(""))
          },
          submitEvent: function e() {
            M !== g()
              .join("") && a.trigger("change"), G.clearMaskOnLostFocus && -1 === x() && c.inputmask._valueGet && c.inputmask._valueGet() === h()
              .join("") && c.inputmask._valueSet(""), G.clearIncomplete && !1 === O(g()) && c.inputmask._valueSet(""), G.removeMaskOnSubmit && (c.inputmask._valueSet(c.inputmask.unmaskedvalue(), !0), setTimeout(function() {
                T(c, g())
              }, 0))
          },
          resetEvent: function e() {
            c.inputmask.refreshValue = !0, setTimeout(function() {
              a.trigger("setvalue")
            }, 0)
          }
        };
      if (ne.prototype.positionColorMask = function(e, t) {
          e.style.left = t.offsetLeft + "px"
        }, void 0 !== e) switch (e.action) {
        case "isComplete":
          return c = e.el, O(g());
        case "unmaskedvalue":
          return (void 0 === c || void 0 !== e.value) && (o = e.value, o = (oe.isFunction(G.onBeforeMask) && G.onBeforeMask.call(u, o, G) || o)
            .split(""), d.call(this, void 0, !1, !1, o), oe.isFunction(G.onBeforeWrite) && G.onBeforeWrite.call(u, void 0, g(), 0, G)), i(c);
        case "mask":
          ! function(e) {
            l.off(e);
            var t = function(e, r) {
              var t = e.getAttribute("type"),
                o = "INPUT" === e.tagName && -1 !== oe.inArray(t, r.supportsInputType) || e.isContentEditable || "TEXTAREA" === e.tagName;
              if (!o)
                if ("INPUT" === e.tagName) {
                  var i = ae.createElement("input");
                  i.setAttribute("type", t), o = "text" === i.type, i = null
                } else o = "partial";
              return !1 === o ? e.inputmask = void 0 : function(e) {
                function t() {
                  return this.inputmask ? this.inputmask.opts.autoUnmask ? this.inputmask.unmaskedvalue() : -1 !== x() || !0 !== r.nullable ? ae.activeElement === this && r.clearMaskOnLostFocus ? (D ? s(g()
                        .slice())
                      .reverse() : s(g()
                        .slice()))
                    .join("") : i.call(this) : "" : i.call(this)
                }

                function o(e) {
                  a.call(this, e), this.inputmask && oe(this)
                    .trigger("setvalue", [e])
                }
                var i, a;
                if (!e.inputmask.__valueGet) {
                  if (!0 !== r.noValuePatching) {
                    if (Object.getOwnPropertyDescriptor) {
                      "function" != typeof Object.getPrototypeOf && (Object.getPrototypeOf = "object" === ue("test".__proto__) ? function(e) {
                        return e.__proto__
                      } : function(e) {
                        return e.constructor.prototype
                      });
                      var n = Object.getPrototypeOf ? Object.getOwnPropertyDescriptor(Object.getPrototypeOf(e), "value") : void 0;
                      n && n.get && n.set ? (i = n.get, a = n.set, Object.defineProperty(e, "value", {
                        get: t,
                        set: o,
                        configurable: !0
                      })) : "INPUT" !== e.tagName && (i = function e() {
                        return this.textContent
                      }, a = function e(t) {
                        this.textContent = t
                      }, Object.defineProperty(e, "value", {
                        get: t,
                        set: o,
                        configurable: !0
                      }))
                    } else ae.__lookupGetter__ && e.__lookupGetter__("value") && (i = e.__lookupGetter__("value"), a = e.__lookupSetter__("value"), e.__defineGetter__("value", t), e.__defineSetter__("value", o));
                    e.inputmask.__valueGet = i, e.inputmask.__valueSet = a
                  }
                  e.inputmask._valueGet = function(e) {
                    return D && !0 !== e ? i.call(this.el)
                      .split("")
                      .reverse()
                      .join("") : i.call(this.el)
                  }, e.inputmask._valueSet = function(e, t) {
                    a.call(this.el, null == e ? "" : !0 !== t && D ? e.split("")
                      .reverse()
                      .join("") : e)
                  }, void 0 === i && (i = function e() {
                    return this.value
                  }, a = function e(t) {
                    this.value = t
                  }, function(e) {
                    if (oe.valHooks && (void 0 === oe.valHooks[e] || !0 !== oe.valHooks[e].inputmaskpatch)) {
                      var i = oe.valHooks[e] && oe.valHooks[e].get ? oe.valHooks[e].get : function(e) {
                          return e.value
                        },
                        n = oe.valHooks[e] && oe.valHooks[e].set ? oe.valHooks[e].set : function(e, t) {
                          return e.value = t, e
                        };
                      oe.valHooks[e] = {
                        get: function e(t) {
                          if (t.inputmask) {
                            if (t.inputmask.opts.autoUnmask) return t.inputmask.unmaskedvalue();
                            var o = i(t);
                            return -1 !== x(void 0, void 0, t.inputmask.maskset.validPositions) || !0 !== r.nullable ? o : ""
                          }
                          return i(t)
                        },
                        set: function e(t, o) {
                          var i, a = oe(t);
                          return i = n(t, o), t.inputmask && a.trigger("setvalue", [o]), i
                        },
                        inputmaskpatch: !0
                      }
                    }
                  }(e.type), function(e) {
                    l.on(e, "mouseenter", function() {
                      var e = oe(this);
                      this.inputmask._valueGet() !== g()
                        .join("") && e.trigger("setvalue")
                    })
                  }(e))
                }
              }(e), o
            }(e, G);
            if (!1 !== t && (a = oe(c = e), J = c.placeholder, -1 === (A = void 0 === c ? void 0 : c.maxLength) && (A = void 0), !0 === G.colorMask && n(c), le && ("inputmode" in c && (c.inputmode = G.inputmode, c.setAttribute("inputmode", G.inputmode)), !0 === G.disablePredictiveText && ("autocorrect" in c ? c.autocorrect = !1 : (!0 !== G.colorMask && n(c), c.type = "password"))), !0 === t && (c.setAttribute("im-insert", G.insertMode), l.on(c, "submit", N.submitEvent), l.on(c, "reset", N.resetEvent), l.on(c, "blur", N.blurEvent), l.on(c, "focus", N.focusEvent), !0 !== G.colorMask && (l.on(c, "click", N.clickEvent), l.on(c, "mouseleave", N.mouseleaveEvent), l.on(c, "mouseenter", N.mouseenterEvent)), l.on(c, "paste", N.pasteEvent), l.on(c, "cut", N.cutEvent), l.on(c, "complete", G.oncomplete), l.on(c, "incomplete", G.onincomplete), l.on(c, "cleared", G.oncleared), le || !0 === G.inputEventOnly ? c.removeAttribute("maxLength") : (l.on(c, "keydown", N.keydownEvent), l.on(c, "keypress", N.keypressEvent)), l.on(c, "input", N.inputFallBackEvent), l.on(c, "beforeinput", N.beforeInputEvent)), l.on(c, "setvalue", N.setValueEvent), M = h()
                .join(""), "" !== c.inputmask._valueGet(!0) || !1 === G.clearMaskOnLostFocus || ae.activeElement === c)) {
              var o = oe.isFunction(G.onBeforeMask) && G.onBeforeMask.call(u, c.inputmask._valueGet(!0), G) || c.inputmask._valueGet(!0);
              "" !== o && d(c, !0, !1, o.split(""));
              var i = g()
                .slice();
              M = i.join(""), !1 === O(i) && G.clearIncomplete && $(), G.clearMaskOnLostFocus && ae.activeElement !== c && (-1 === x() ? i = [] : s(i)), (!1 === G.clearMaskOnLostFocus || G.showMaskOnFocus && ae.activeElement === c || "" !== c.inputmask._valueGet(!0)) && T(c, i), ae.activeElement === c && P(c, b(x()))
            }
          }(c);
          break;
        case "format":
          return o = (oe.isFunction(G.onBeforeMask) && G.onBeforeMask.call(u, e.value, G) || e.value)
            .split(""), d.call(this, void 0, !0, !1, o), e.metadata ? {
              value: D ? g()
                .slice()
                .reverse()
                .join("") : g()
                .join(""),
              metadata: se.call(this, {
                action: "getmetadata"
              }, t, G)
            } : D ? g()
            .slice()
            .reverse()
            .join("") : g()
            .join("");
        case "isValid":
          e.value ? (o = e.value.split(""), d.call(this, void 0, !0, !0, o)) : e.value = g()
            .join("");
          for (var Z = g(), X = r(), ee = Z.length - 1; ee > X && !k(ee); ee--);
          return Z.splice(X, ee + 1 - X), O(Z) && e.value === g()
            .join("");
        case "getemptymask":
          return h()
            .join("");
        case "remove":
          if (c && c.inputmask) oe.data(c, "_inputmask_opts", null), a = oe(c), c.inputmask._valueSet(G.autoUnmask ? i(c) : c.inputmask._valueGet(!0)), l.off(c), c.inputmask.colorMask && ((j = c.inputmask.colorMask)
            .removeChild(c), j.parentNode.insertBefore(c, j), j.parentNode.removeChild(j)), Object.getOwnPropertyDescriptor && Object.getPrototypeOf ? Object.getOwnPropertyDescriptor(Object.getPrototypeOf(c), "value") && c.inputmask.__valueGet && Object.defineProperty(c, "value", {
            get: c.inputmask.__valueGet,
            set: c.inputmask.__valueSet,
            configurable: !0
          }) : ae.__lookupGetter__ && c.__lookupGetter__("value") && c.inputmask.__valueGet && (c.__defineGetter__("value", c.inputmask.__valueGet), c.__defineSetter__("value", c.inputmask.__valueSet)), c.inputmask = void 0;
          return c;
        case "getmetadata":
          if (oe.isArray(t.metadata)) {
            var te = p(!0, 0, !1)
              .join("");
            return oe.each(t.metadata, function(e, t) {
              if (t.mask === te) return te = t, !1
            }), te
          }
          return t.metadata
      }
    }
    var e = navigator.userAgent,
      le = re("touchstart"),
      ce = /iemobile/i.test(e),
      de = /iphone/i.test(e) && !ce;
    return ne.prototype = {
      dataAttribute: "data-inputmask",
      defaults: {
        placeholder: "_",
        optionalmarker: ["[", "]"],
        quantifiermarker: ["{", "}"],
        groupmarker: ["(", ")"],
        alternatormarker: "|",
        escapeChar: "\\",
        mask: null,
        regex: null,
        oncomplete: oe.noop,
        onincomplete: oe.noop,
        oncleared: oe.noop,
        repeat: 0,
        greedy: !1,
        autoUnmask: !1,
        removeMaskOnSubmit: !1,
        clearMaskOnLostFocus: !0,
        insertMode: !0,
        clearIncomplete: !1,
        alias: null,
        onKeyDown: oe.noop,
        onBeforeMask: null,
        onBeforePaste: function e(t, o) {
          return oe.isFunction(o.onBeforeMask) ? o.onBeforeMask.call(this, t, o) : t
        },
        onBeforeWrite: null,
        onUnMask: null,
        showMaskOnFocus: !0,
        showMaskOnHover: !0,
        onKeyValidation: oe.noop,
        skipOptionalPartCharacter: " ",
        numericInput: !1,
        rightAlign: !1,
        undoOnEscape: !0,
        radixPoint: "",
        _radixDance: !1,
        groupSeparator: "",
        keepStatic: null,
        positionCaretOnTab: !0,
        tabThrough: !1,
        supportsInputType: ["text", "tel", "password", "search"],
        ignorables: [8, 9, 13, 19, 27, 33, 34, 35, 36, 37, 38, 39, 40, 45, 46, 93, 112, 113, 114, 115, 116, 117, 118, 119, 120, 121, 122, 123, 0, 229],
        isComplete: null,
        preValidation: null,
        postValidation: null,
        staticDefinitionSymbol: void 0,
        jitMasking: !1,
        nullable: !0,
        inputEventOnly: !1,
        noValuePatching: !1,
        positionCaretOnClick: "lvp",
        casing: null,
        inputmode: "verbatim",
        colorMask: !1,
        disablePredictiveText: !1,
        importDataAttributes: !0
      },
      definitions: {
        9: {
          validator: "[0-9１-９]",
          definitionSymbol: "*"
        },
        a: {
          validator: "[A-Za-zА-яЁёÀ-ÿµ]",
          definitionSymbol: "*"
        },
        "*": {
          validator: "[0-9１-９A-Za-zА-яЁёÀ-ÿµ]"
        }
      },
      aliases: {},
      masksCache: {},
      mask: function e(t) {
        function a(i, e, a, n) {
          if (!0 === e.importDataAttributes) {
            var t, o, r, s, l = function e(t, o) {
                null !== (o = void 0 === o ? i.getAttribute(n + "-" + t) : o) && ("string" == typeof o && (0 === t.indexOf("on") ? o = ie[o] : "false" === o ? o = !1 : "true" === o && (o = !0)), a[t] = o)
              },
              c = i.getAttribute(n);
            if (c && "" !== c && (c = c.replace(/'/g, '"'), o = JSON.parse("{" + c + "}")), o)
              for (s in r = void 0, o)
                if ("alias" === s.toLowerCase()) {
                  r = o[s];
                  break
                } for (t in l("alias", r), a.alias && d(a.alias, a, e), e) {
              if (o)
                for (s in r = void 0, o)
                  if (s.toLowerCase() === t.toLowerCase()) {
                    r = o[s];
                    break
                  } l(t, r)
            }
          }
          return oe.extend(!0, e, a), ("rtl" === i.dir || e.rightAlign) && (i.style.textAlign = "right"), ("rtl" === i.dir || e.numericInput) && (i.dir = "ltr", i.removeAttribute("dir"), e.isRTL = !0), Object.keys(a)
            .length
        }
        var n = this;
        return "string" == typeof t && (t = ae.getElementById(t) || ae.querySelectorAll(t)), t = t.nodeName ? [t] : t, oe.each(t, function(e, t) {
          var o = oe.extend(!0, {}, n.opts);
          if (a(t, o, oe.extend(!0, {}, n.userOptions), n.dataAttribute)) {
            var i = r(o, n.noMasksCache);
            void 0 !== i && (void 0 !== t.inputmask && (t.inputmask.opts.autoUnmask = !0, t.inputmask.remove()), t.inputmask = new ne(void 0, void 0, !0), t.inputmask.opts = o, t.inputmask.noMasksCache = n.noMasksCache, t.inputmask.userOptions = oe.extend(!0, {}, n.userOptions), t.inputmask.isRTL = o.isRTL || o.numericInput, t.inputmask.el = t, t.inputmask.maskset = i, oe.data(t, "_inputmask_opts", o), se.call(t.inputmask, {
              action: "mask"
            }))
          }
        }), t && t[0] && t[0].inputmask || this
      },
      option: function e(t, o) {
        return "string" == typeof t ? this.opts[t] : "object" === (void 0 === t ? "undefined" : ue(t)) ? (oe.extend(this.userOptions, t), this.el && !0 !== o && this.mask(this.el), this) : void 0
      },
      unmaskedvalue: function e(t) {
        return this.maskset = this.maskset || r(this.opts, this.noMasksCache), se.call(this, {
          action: "unmaskedvalue",
          value: t
        })
      },
      remove: function e() {
        return se.call(this, {
          action: "remove"
        })
      },
      getemptymask: function e() {
        return this.maskset = this.maskset || r(this.opts, this.noMasksCache), se.call(this, {
          action: "getemptymask"
        })
      },
      hasMaskedValue: function e() {
        return !this.opts.autoUnmask
      },
      isComplete: function e() {
        return this.maskset = this.maskset || r(this.opts, this.noMasksCache), se.call(this, {
          action: "isComplete"
        })
      },
      getmetadata: function e() {
        return this.maskset = this.maskset || r(this.opts, this.noMasksCache), se.call(this, {
          action: "getmetadata"
        })
      },
      isValid: function e(t) {
        return this.maskset = this.maskset || r(this.opts, this.noMasksCache), se.call(this, {
          action: "isValid",
          value: t
        })
      },
      format: function e(t, o) {
        return this.maskset = this.maskset || r(this.opts, this.noMasksCache), se.call(this, {
          action: "format",
          value: t,
          metadata: o
        })
      },
      setValue: function e(t) {
        this.el && oe(this.el)
          .trigger("setvalue", [t])
      },
      analyseMask: function e(t, n, r) {
        function o(e, t, o, i) {
          this.matches = [], this.openGroup = e || !1, this.alternatorGroup = !1, this.isGroup = e || !1, this.isOptional = t || !1, this.isQuantifier = o || !1, this.isAlternator = i || !1, this.quantifier = {
            min: 1,
            max: 1
          }
        }

        function s(o, e, i) {
          i = void 0 === i ? o.matches.length : i;
          var a = o.matches[i - 1];
          if (n) 0 === e.indexOf("[") || v && /\\d|\\s|\\w]/i.test(e) || "." === e ? o.matches.splice(i++, 0, {
            fn: new RegExp(e, r.casing ? "i" : ""),
            optionality: !1,
            newBlockMarker: void 0 === a ? "master" : a.def !== e,
            casing: null,
            def: e,
            placeholder: void 0,
            nativeDef: e
          }) : (v && (e = e[e.length - 1]), oe.each(e.split(""), function(e, t) {
            a = o.matches[i - 1], o.matches.splice(i++, 0, {
              fn: null,
              optionality: !1,
              newBlockMarker: void 0 === a ? "master" : a.def !== t && null !== a.fn,
              casing: null,
              def: r.staticDefinitionSymbol || t,
              placeholder: void 0 === r.staticDefinitionSymbol ? void 0 : t,
              nativeDef: (v ? "'" : "") + t
            })
          })), v = !1;
          else {
            var t = (r.definitions ? r.definitions[e] : void 0) || ne.prototype.definitions[e];
            t && !v ? o.matches.splice(i++, 0, {
              fn: t.validator ? "string" == typeof t.validator ? new RegExp(t.validator, r.casing ? "i" : "") : new function() {
                this.test = t.validator
              } : /./,
              optionality: !1,
              newBlockMarker: void 0 === a ? "master" : a.def !== (t.definitionSymbol || e),
              casing: t.casing,
              def: t.definitionSymbol || e,
              placeholder: t.placeholder,
              nativeDef: e
            }) : (o.matches.splice(i++, 0, {
              fn: null,
              optionality: !1,
              newBlockMarker: void 0 === a ? "master" : a.def !== e && null !== a.fn,
              casing: null,
              def: r.staticDefinitionSymbol || e,
              placeholder: void 0 === r.staticDefinitionSymbol ? void 0 : e,
              nativeDef: (v ? "'" : "") + e
            }), v = !1)
          }
        }

        function i() {
          if (0 < _.length) {
            if (s(u = _[_.length - 1], c), u.isAlternator) {
              p = _.pop();
              for (var e = 0; e < p.matches.length; e++) p.matches[e].isGroup && (p.matches[e].isGroup = !1);
              0 < _.length ? (u = _[_.length - 1])
                .matches.push(p) : g.matches.push(p)
            }
          } else s(g, c)
        }

        function a(e) {
          var t = new o(!0);
          return t.openGroup = !1, t.matches = e, t
        }
        var l, c, d, u, p, f, m = /(?:[?*+]|\{[0-9\+\*]+(?:,[0-9\+\*]*)?(?:\|[0-9\+\*]*)?\})|[^.?*+^${[]()|\\]+|./g,
          h = /\[\^?]?(?:[^\\\]]+|\\[\S\s]?)*]?|\\(?:0(?:[0-3][0-7]{0,2}|[4-7][0-7]?)?|[1-9][0-9]*|x[0-9A-Fa-f]{2}|u[0-9A-Fa-f]{4}|c[A-Za-z]|[\S\s]?)|\((?:\?[:=!]?)?|(?:[?*+]|\{[0-9]+(?:,[0-9]*)?\})\??|[^.?*+^${[()|\\]+|./g,
          v = !1,
          g = new o,
          _ = [],
          k = [];
        for (n && (r.optionalmarker[0] = void 0, r.optionalmarker[1] = void 0); l = n ? h.exec(t) : m.exec(t);) {
          if (c = l[0], n) switch (c.charAt(0)) {
            case "?":
              c = "{0,1}";
              break;
            case "+":
            case "*":
              c = "{" + c + "}"
          }
          if (v) i();
          else switch (c.charAt(0)) {
            case "(?=":
            case "(?!":
            case "(?<=":
            case "(?<!":
              break;
            case r.escapeChar:
              v = !0, n && i();
              break;
            case r.optionalmarker[1]:
            case r.groupmarker[1]:
              if ((d = _.pop())
                .openGroup = !1, void 0 === d) i();
              else if (0 < _.length) {
                if ((u = _[_.length - 1])
                  .matches.push(d), u.isAlternator) {
                  p = _.pop();
                  for (var b = 0; b < p.matches.length; b++) p.matches[b].isGroup = !1, p.matches[b].alternatorGroup = !1;
                  0 < _.length ? (u = _[_.length - 1])
                    .matches.push(p) : g.matches.push(p)
                }
              } else g.matches.push(d);
              break;
            case r.optionalmarker[0]:
              _.push(new o(!1, !0));
              break;
            case r.groupmarker[0]:
              _.push(new o(!0));
              break;
            case r.quantifiermarker[0]:
              var y = new o(!1, !1, !0),
                $ = (c = c.replace(/[{}]/g, ""))
                .split("|"),
                x = $[0].split(","),
                w = isNaN(x[0]) ? x[0] : parseInt(x[0]),
                S = 1 === x.length ? w : isNaN(x[1]) ? x[1] : parseInt(x[1]);
              ("*" === w || "+" === w) && (w = "*" === S ? 0 : 1), y.quantifier = {
                min: w,
                max: S,
                jit: $[1]
              };
              var C = 0 < _.length ? _[_.length - 1].matches : g.matches;
              if ((l = C.pop())
                .isAlternator) {
                C.push(l), C = l.matches;
                var T = new o(!0),
                  E = C.pop();
                C.push(T), C = T.matches, l = E
              }
              l.isGroup || (l = a([l])), C.push(l), C.push(y);
              break;
            case r.alternatormarker:
              var P = function e(t) {
                var o = t.pop();
                return o.isQuantifier && (o = a([t.pop(), o])), o
              };
              if (0 < _.length) {
                var O = (u = _[_.length - 1])
                  .matches[u.matches.length - 1];
                f = u.openGroup && (void 0 === O.matches || !1 === O.isGroup && !1 === O.isAlternator) ? _.pop() : P(u.matches)
              } else f = P(g.matches);
              if (f.isAlternator) _.push(f);
              else if (f.alternatorGroup ? (p = _.pop(), f.alternatorGroup = !1) : p = new o(!1, !1, !1, !0), p.matches.push(f), _.push(p), f.openGroup) {
                f.openGroup = !1;
                var M = new o(!0);
                M.alternatorGroup = !0, _.push(M)
              }
              break;
            default:
              i()
          }
        }
        for (; 0 < _.length;) d = _.pop(), g.matches.push(d);
        return 0 < g.matches.length && (function i(a) {
          a && a.matches && oe.each(a.matches, function(e, t) {
            var o = a.matches[e + 1];
            (void 0 === o || void 0 === o.matches || !1 === o.isQuantifier) && t && t.isGroup && (t.isGroup = !1, !n && (s(t, r.groupmarker[0], 0), !0 !== t.openGroup && s(t, r.groupmarker[1]))), i(t)
          })
        }(g), k.push(g)), (r.numericInput || r.isRTL) && function e(t) {
          function o(e) {
            return e === r.optionalmarker[0] ? e = r.optionalmarker[1] : e === r.optionalmarker[1] ? e = r.optionalmarker[0] : e === r.groupmarker[0] ? e = r.groupmarker[1] : e === r.groupmarker[1] && (e = r.groupmarker[0]), e
          }
          for (var i in t.matches = t.matches.reverse(), t.matches)
            if (t.matches.hasOwnProperty(i)) {
              var a = parseInt(i);
              if (t.matches[i].isQuantifier && t.matches[a + 1] && t.matches[a + 1].isGroup) {
                var n = t.matches[i];
                t.matches.splice(i, 1), t.matches.splice(a + 1, 0, n)
              }
              t.matches[i] = void 0 === t.matches[i].matches ? o(t.matches[i]) : e(t.matches[i])
            } return t
        }(k[0]), k
      }
    }, ne.extendDefaults = function(e) {
      oe.extend(!0, ne.prototype.defaults, e)
    }, ne.extendDefinitions = function(e) {
      oe.extend(!0, ne.prototype.definitions, e)
    }, ne.extendAliases = function(e) {
      oe.extend(!0, ne.prototype.aliases, e)
    }, ne.format = function(e, t, o) {
      return ne(t)
        .format(e, o)
    }, ne.unmask = function(e, t) {
      return ne(t)
        .unmaskedvalue(e)
    }, ne.isValid = function(e, t) {
      return ne(t)
        .isValid(e)
    }, ne.remove = function(e) {
      "string" == typeof e && (e = ae.getElementById(e) || ae.querySelectorAll(e)), e = e.nodeName ? [e] : e, oe.each(e, function(e, t) {
        t.inputmask && t.inputmask.remove()
      })
    }, ne.setValue = function(e, o) {
      "string" == typeof e && (e = ae.getElementById(e) || ae.querySelectorAll(e)), e = e.nodeName ? [e] : e, oe.each(e, function(e, t) {
        t.inputmask ? t.inputmask.setValue(o) : oe(t)
          .trigger("setvalue", [o])
      })
    }, ne.escapeRegex = function(e) {
      return e.replace(new RegExp("(\\" + ["/", ".", "*", "+", "?", "|", "(", ")", "[", "]", "{", "}", "\\", "$", "^"].join("|\\") + ")", "gim"), "\\$1")
    }, ne.keyCode = {
      BACKSPACE: 8,
      BACKSPACE_SAFARI: 127,
      DELETE: 46,
      DOWN: 40,
      END: 35,
      ENTER: 13,
      ESCAPE: 27,
      HOME: 36,
      INSERT: 45,
      LEFT: 37,
      PAGE_DOWN: 34,
      PAGE_UP: 33,
      RIGHT: 39,
      SPACE: 32,
      TAB: 9,
      UP: 38,
      X: 88,
      CONTROL: 17
    }, ne.dependencyLib = oe, ne
  }) ? i.apply(t, o) : i) && (e.exports = t)
}, function(e, t, o) {
  var i, o = [o(4)];
  void 0 !== (t = "function" == typeof(i = function(e) {
    return e
  }) ? i.apply(t, o) : i) && (e.exports = t)
}, function(e) {
  e.exports = jQuery
}, function(e, t, o) {
  void 0 !== (o = function() {
    return window
  }.call(t, o, t, e)) && (e.exports = o)
}, function(e, t, o) {
  void 0 !== (o = function() {
    return document
  }.call(t, o, t, e)) && (e.exports = o)
}, function(e, t, o) {
  var i, m = "function" == typeof Symbol && "symbol" == _typeof(Symbol.iterator) ? function(e) {
    return _typeof(e)
  } : function(e) {
    return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : _typeof(e)
  };
  o = [o(2)], void 0 !== (t = "function" == typeof(i = function(l) {
    function u(e) {
      if (!e.tokenizer) {
        var t = [];
        for (var o in f) - 1 === t.indexOf(o[0]) && t.push(o[0]);
        e.tokenizer = "(" + t.join("+|") + ")+?|.", e.tokenizer = new RegExp(e.tokenizer, "g")
      }
      return e.tokenizer
    }

    function s(e, t, o, i) {
      for (var a, n = ""; a = u(o)
        .exec(e);)
        if (void 0 === t)
          if (f[a[0]]) n += "(" + f[a[0]][0] + ")";
          else switch (a[0]) {
            case "[":
              n += "(";
              break;
            case "]":
              n += ")?";
              break;
            default:
              n += l.escapeRegex(a[0])
          } else if (f[a[0]])
            if (!0 !== i && f[a[0]][3]) n += f[a[0]][3].call(t.date);
            else n += f[a[0]][2] ? t["raw" + f[a[0]][2]] : a[0];
      else n += a[0];
      return n
    }

    function c(e, t) {
      for (e += "", t = t || 2; e.length < t;) e = "0" + e;
      return e
    }

    function d(e, t, a) {
      function o(e, t) {
        e[n] = function(e) {
          var t;
          if (a.min && a.min[n] || a.max && a.max[n]) {
            var o = a.min && a.min[n] || a.max[n],
              i = a.max && a.max[n] || a.min[n];
            for (t = e.replace(/[^0-9]/g, ""), t += (o.indexOf(t) < i.indexOf(t) ? i : o)
              .toString()
              .substr(t.length); !new RegExp(s)
              .test(t);) t--
          } else t = e.replace(/[^0-9]/g, "0");
          return t
        }(t), e["raw" + n] = t, void 0 !== r && r.call(e.date, "month" == n ? parseInt(e[n]) - 1 : e[n])
      }
      var n, i, r, s, l = {
          date: new Date(1, 0, 1)
        },
        c = e;
      if ("string" == typeof c) {
        for (; i = u(a)
          .exec(t);) {
          var d = c.slice(0, i[0].length);
          f.hasOwnProperty(i[0]) && (s = f[i[0]][0], n = f[i[0]][2], r = f[i[0]][1], o(l, d)), c = c.slice(d.length)
        }
        return l
      }
      return c && "object" === (void 0 === c ? "undefined" : m(c)) && c.hasOwnProperty("date") ? c : void 0
    }
    var p = l.dependencyLib,
      f = {
        d: ["[1-9]|[12][0-9]|3[01]", Date.prototype.setDate, "day", Date.prototype.getDate],
        dd: ["0[1-9]|[12][0-9]|3[01]", Date.prototype.setDate, "day", function() {
          return c(Date.prototype.getDate.call(this), 2)
        }],
        ddd: [""],
        dddd: [""],
        m: ["[1-9]|1[012]", Date.prototype.setMonth, "month", function() {
          return Date.prototype.getMonth.call(this) + 1
        }],
        mm: ["0[1-9]|1[012]", Date.prototype.setMonth, "month", function() {
          return c(Date.prototype.getMonth.call(this) + 1, 2)
        }],
        mmm: [""],
        mmmm: [""],
        yy: ["[0-9]{2}", Date.prototype.setFullYear, "year", function() {
          return c(Date.prototype.getFullYear.call(this), 2)
        }],
        yyyy: ["[0-9]{4}", Date.prototype.setFullYear, "year", function() {
          return c(Date.prototype.getFullYear.call(this), 4)
        }],
        h: ["[1-9]|1[0-2]", Date.prototype.setHours, "hours", Date.prototype.getHours],
        hh: ["0[1-9]|1[0-2]", Date.prototype.setHours, "hours", function() {
          return c(Date.prototype.getHours.call(this), 2)
        }],
        hhh: ["[0-9]+", Date.prototype.setHours, "hours", Date.prototype.getHours],
        H: ["1?[0-9]|2[0-3]", Date.prototype.setHours, "hours", Date.prototype.getHours],
        HH: ["[01][0-9]|2[0-3]", Date.prototype.setHours, "hours", function() {
          return c(Date.prototype.getHours.call(this), 2)
        }],
        HHH: ["[0-9]+", Date.prototype.setHours, "hours", Date.prototype.getHours],
        M: ["[1-5]?[0-9]", Date.prototype.setMinutes, "minutes", Date.prototype.getMinutes],
        MM: ["[0-5][0-9]", Date.prototype.setMinutes, "minutes", function() {
          return c(Date.prototype.getMinutes.call(this), 2)
        }],
        s: ["[1-5]?[0-9]", Date.prototype.setSeconds, "seconds", Date.prototype.getSeconds],
        ss: ["[0-5][0-9]", Date.prototype.setSeconds, "seconds", function() {
          return c(Date.prototype.getSeconds.call(this), 2)
        }],
        l: ["[0-9]{3}", Date.prototype.setMilliseconds, "milliseconds", function() {
          return c(Date.prototype.getMilliseconds.call(this), 3)
        }],
        L: ["[0-9]{2}", Date.prototype.setMilliseconds, "milliseconds", function() {
          return c(Date.prototype.getMilliseconds.call(this), 2)
        }],
        t: ["[ap]"],
        tt: ["[ap]m"],
        T: ["[AP]"],
        TT: ["[AP]M"],
        Z: [""],
        o: [""],
        S: [""]
      },
      o = {
        isoDate: "yyyy-mm-dd",
        isoTime: "HH:MM:ss",
        isoDateTime: "yyyy-mm-dd'T'HH:MM:ss",
        isoUtcDateTime: "UTC:yyyy-mm-dd'T'HH:MM:ss'Z'"
      };
    return l.extendAliases({
      datetime: {
        mask: function e(t) {
          return f.S = t.i18n.ordinalSuffix.join("|"), t.inputFormat = o[t.inputFormat] || t.inputFormat, t.displayFormat = o[t.displayFormat] || t.displayFormat || t.inputFormat, t.outputFormat = o[t.outputFormat] || t.outputFormat || t.inputFormat, t.placeholder = "" === t.placeholder ? t.inputFormat.replace(/[\[\]]/, "") : t.placeholder, t.regex = s(t.inputFormat, void 0, t), null
        },
        placeholder: "",
        inputFormat: "isoDateTime",
        displayFormat: void 0,
        outputFormat: void 0,
        min: null,
        max: null,
        i18n: {
          dayNames: ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"],
          monthNames: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec", "January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
          ordinalSuffix: ["st", "nd", "rd", "th"]
        },
        postValidation: function e(t, o, i, a) {
          a.min = d(a.min, a.inputFormat, a), a.max = d(a.max, a.inputFormat, a);
          var n = i,
            r = d(t.join(""), a.inputFormat, a);
          return n && r.date.getTime() == r.date.getTime() && (n = (n = function(e, t) {
            return !(isFinite(e.rawday) && ("29" != e.day || isFinite(e.rawyear)) && !(new Date(e.date.getFullYear(), isFinite(e.rawmonth) ? e.month : e.date.getMonth() + 1, 0)
              .getDate() >= e.day)) && t
          }(r, n)) && function(e, t) {
            var o = !0;
            if (t.min) {
              if (e.rawyear) {
                var i = e.rawyear.replace(/[^0-9]/g, "");
                o = t.min.year.substr(0, i.length) <= i
              }
              e.year === e.rawyear && t.min.date.getTime() == t.min.date.getTime() && (o = t.min.date.getTime() <= e.date.getTime())
            }
            return o && t.max && t.max.date.getTime() == t.max.date.getTime() && (o = t.max.date.getTime() >= e.date.getTime()), o
          }(r, a)), o && n && i.pos !== o ? {
            buffer: s(a.inputFormat, r, a),
            refreshFromBuffer: {
              start: o,
              end: i.pos
            }
          } : n
        },
        onKeyDown: function e(t, o, i, a) {
          if (t.ctrlKey && t.keyCode === l.keyCode.RIGHT) {
            for (var n, r = new Date, s = ""; n = u(a)
              .exec(a.inputFormat);) "d" === n[0].charAt(0) ? s += c(r.getDate(), n[0].length) : "m" === n[0].charAt(0) ? s += c(r.getMonth() + 1, n[0].length) : "yyyy" === n[0] ? s += r.getFullYear()
              .toString() : "y" === n[0].charAt(0) && (s += c(r.getYear(), n[0].length));
            this.inputmask._valueSet(s), p(this)
              .trigger("setvalue")
          }
        },
        onUnMask: function e(t, o, i) {
          return s(i.outputFormat, d(t, i.inputFormat, i), i, !0)
        },
        casing: function e(t, o) {
          return 0 == o.nativeDef.indexOf("[ap]") ? t.toLowerCase() : 0 == o.nativeDef.indexOf("[AP]") ? t.toUpperCase() : t
        },
        insertMode: !1
      }
    }), l
  }) ? i.apply(t, o) : i) && (e.exports = t)
}, function(e, t, o) {
  var o = [o(2)],
    i = function(g) {
      function a(e, t) {
        for (var o = "", i = 0; i < e.length; i++) o += g.prototype.definitions[e.charAt(i)] || t.definitions[e.charAt(i)] || t.optionalmarker.start === e.charAt(i) || t.optionalmarker.end === e.charAt(i) || t.quantifiermarker.start === e.charAt(i) || t.quantifiermarker.end === e.charAt(i) || t.groupmarker.start === e.charAt(i) || t.groupmarker.end === e.charAt(i) || t.alternatormarker === e.charAt(i) ? "\\" + e.charAt(i) : e.charAt(i);
        return o
      }
      var _ = g.dependencyLib;
      return g.extendAliases({
        numeric: {
          mask: function(e) {
            0 !== e.repeat && isNaN(e.integerDigits) && (e.integerDigits = e.repeat), e.repeat = 0, e.groupSeparator === e.radixPoint && e.digits && "0" !== e.digits && ("." === e.radixPoint ? e.groupSeparator = "," : "," === e.radixPoint ? e.groupSeparator = "." : e.groupSeparator = ""), " " === e.groupSeparator && (e.skipOptionalPartCharacter = void 0), e.autoGroup = e.autoGroup && "" !== e.groupSeparator, e.autoGroup && ("string" == typeof e.groupSize && isFinite(e.groupSize) && (e.groupSize = parseInt(e.groupSize)), isFinite(e.integerDigits)) && (t = Math.floor(e.integerDigits / e.groupSize), i = e.integerDigits % e.groupSize, e.integerDigits = parseInt(e.integerDigits) + (0 == i ? t - 1 : t), e.integerDigits < 1 && (e.integerDigits = "*")), 1 < e.placeholder.length && (e.placeholder = e.placeholder.charAt(0)), "radixFocus" === e.positionCaretOnClick && "" === e.placeholder && !1 === e.integerOptional && (e.positionCaretOnClick = "lvp"), e.definitions[";"] = e.definitions["~"], e.definitions[";"].definitionSymbol = "~", !0 === e.numericInput && (e.positionCaretOnClick = "radixFocus" === e.positionCaretOnClick ? "lvp" : e.positionCaretOnClick, e.digitsOptional = !1, isNaN(e.digits) && (e.digits = 2), e.decimalProtect = !1);
            var t, o, i = "[+]",
              i = (i += a(e.prefix, e)) + (!0 === e.integerOptional ? "~{1," + e.integerDigits + "}" : "~{" + e.integerDigits + "}");
            return void 0 !== e.digits && (t = e.decimalProtect ? ":" : e.radixPoint, o = e.digits.toString()
              .split(","), isFinite(o[0]) && o[1] && isFinite(o[1]) ? i += t + ";{" + e.digits + "}" : (isNaN(e.digits) || 0 < parseInt(e.digits)) && (e.digitsOptional ? i += "[" + t + ";{1," + e.digits + "}]" : i += t + ";{" + e.digits + "}")), i = i + a(e.suffix, e) + "[-]", e.greedy = !1, i
          },
          placeholder: "",
          greedy: !1,
          digits: "*",
          digitsOptional: !0,
          enforceDigitsOnBlur: !1,
          radixPoint: ".",
          positionCaretOnClick: "radixFocus",
          groupSize: 3,
          groupSeparator: "",
          autoGroup: !1,
          allowMinus: !0,
          negationSymbol: {
            front: "-",
            back: ""
          },
          integerDigits: "+",
          integerOptional: !0,
          prefix: "",
          suffix: "",
          rightAlign: !0,
          decimalProtect: !0,
          min: null,
          max: null,
          step: 1,
          insertMode: !0,
          autoUnmask: !1,
          unmaskAsNumber: !1,
          inputmode: "numeric",
          preValidation: function(e, t, o, i, a, n) {
            if ("-" === o || o === a.negationSymbol.front) return !0 === a.allowMinus && (a.isNegative = void 0 === a.isNegative || !a.isNegative, "" === e.join("") || {
              caret: n.validPositions[t] ? t : void 0,
              dopost: !0
            });
            if (!1 === i && o === a.radixPoint && void 0 !== a.digits && (isNaN(a.digits) || 0 < parseInt(a.digits))) {
              i = _.inArray(a.radixPoint, e);
              if (-1 !== i && void 0 !== n.validPositions[i]) return !0 === a.numericInput ? t === i : {
                caret: i + 1
              }
            }
            return !0
          },
          postValidation: function(e, t, o, i) {
            var a = i.suffix.split(""),
              n = i.prefix.split("");
            if (void 0 === o.pos && void 0 !== o.caret && !0 !== o.dopost) return o;
            var r = void 0 === o.caret ? o.pos : o.caret,
              s = e.slice(),
              l = (i.numericInput && (r = s.length - r - 1, s = s.reverse()), s[r]);
            if (l === i.groupSeparator && (l = s[r += 1]), r === s.length - i.suffix.length - 1 && l === i.radixPoint) return o;
            void 0 !== l && l !== i.radixPoint && l !== i.negationSymbol.front && l !== i.negationSymbol.back && (s[r] = "?", 0 < i.prefix.length && r >= (!1 === i.isNegative ? 1 : 0) && r < i.prefix.length - 1 + (!1 === i.isNegative ? 1 : 0) ? n[r - (!1 === i.isNegative ? 1 : 0)] = "?" : 0 < i.suffix.length && r >= s.length - i.suffix.length - (!1 === i.isNegative ? 1 : 0) && (a[r - (s.length - i.suffix.length - (!1 === i.isNegative ? 1 : 0))] = "?"));
            var c, d, u, n = n.join(""),
              a = a.join(""),
              p = s.join("")
              .replace(n, "");
            if (p = (p = (p = (p = p.replace(a, ""))
                  .replace(new RegExp(g.escapeRegex(i.groupSeparator), "g"), ""))
                .replace(new RegExp("[-" + g.escapeRegex(i.negationSymbol.front) + "]", "g"), ""))
              .replace(new RegExp(g.escapeRegex(i.negationSymbol.back) + "$"), ""), "" !== (p = (p = 1 < (p = isNaN(i.placeholder) ? p.replace(new RegExp(g.escapeRegex(i.placeholder), "g"), "") : p)
                  .length && 1 !== p.indexOf(i.radixPoint) ? (p = "0" === l ? p.replace(/^\?/g, "") : p)
                  .replace(/^0/g, "") : p)
                .charAt(0) === i.radixPoint && "" !== i.radixPoint && !0 !== i.numericInput ? "0" + p : p)) {
              if (p = p.split(""), (!i.digitsOptional || i.enforceDigitsOnBlur && "blur" === o.event) && isFinite(i.digits)) {
                var f = _.inArray(i.radixPoint, p),
                  m = _.inArray(i.radixPoint, s); - 1 === f && (p.push(i.radixPoint), f = p.length - 1);
                for (var h = 1; h <= i.digits; h++) i.digitsOptional && (!i.enforceDigitsOnBlur || "blur" !== o.event) || void 0 !== p[f + h] && p[f + h] !== i.placeholder.charAt(0) ? -1 !== m && void 0 !== s[m + h] && (p[f + h] = p[f + h] || s[m + h]) : p[f + h] = o.placeholder || i.placeholder.charAt(0)
              }!0 !== i.autoGroup || "" === i.groupSeparator || l === i.radixPoint && void 0 === o.pos && !o.dopost ? p = p.join("") : (c = p[p.length - 1] === i.radixPoint && o.c === i.radixPoint, p = g((v = p, d = "", d += "(" + (u = i)
                  .groupSeparator + "*{" + u.groupSize + "}){*}", "" !== u.radixPoint && (v = v.join("")
                    .split(u.radixPoint))[1] && (d += u.radixPoint + "*{" + v[1].match(/^\d*\??\d*/)[0].length + "}"), d), {
                  numericInput: !0,
                  jitMasking: !0,
                  definitions: {
                    "*": {
                      validator: "[0-9?]",
                      cardinality: 1
                    }
                  }
                })
                .format(p.join("")), c && (p += i.radixPoint), p.charAt(0) === i.groupSeparator && p.substr(1))
            }
            i.isNegative && "blur" === o.event && (i.isNegative = "0" !== p), p = n + p, p += a, i.isNegative && (p = i.negationSymbol.front + p, p += i.negationSymbol.back), p = p.split(""), void 0 !== l && (l !== i.radixPoint && l !== i.negationSymbol.front && l !== i.negationSymbol.back ? -1 < (r = _.inArray("?", p)) ? p[r] = l : r = o.caret || 0 : l !== i.radixPoint && l !== i.negationSymbol.front && l !== i.negationSymbol.back || -1 !== (u = _.inArray(l, p)) && (r = u)), i.numericInput && (r = p.length - r - 1, p = p.reverse());
            var v = {
              caret: void 0 !== l && void 0 === o.pos || void 0 === r ? r : r + (i.numericInput ? -1 : 1),
              buffer: p,
              refreshFromBuffer: o.dopost || e.join("") !== p.join("")
            };
            return v.refreshFromBuffer ? v : o
          },
          onBeforeWrite: function(e, t, o, i) {
            if (e) switch (e.type) {
              case "keydown":
                return i.postValidation(t, o, {
                  caret: o,
                  dopost: !0
                }, i);
              case "blur":
              case "checkval":
                if (void 0 === (a = i)
                  .parseMinMaxOptions && (null !== a.min && (a.min = a.min.toString()
                    .replace(new RegExp(g.escapeRegex(a.groupSeparator), "g"), ""), "," === a.radixPoint && (a.min = a.min.replace(a.radixPoint, ".")), a.min = isFinite(a.min) ? parseFloat(a.min) : NaN, isNaN(a.min)) && (a.min = Number.MIN_VALUE), null !== a.max && (a.max = a.max.toString()
                    .replace(new RegExp(g.escapeRegex(a.groupSeparator), "g"), ""), "," === a.radixPoint && (a.max = a.max.replace(a.radixPoint, ".")), a.max = isFinite(a.max) ? parseFloat(a.max) : NaN, isNaN(a.max)) && (a.max = Number.MAX_VALUE), a.parseMinMaxOptions = "done"), null !== i.min || null !== i.max) {
                  if (a = i.onUnMask(t.join(""), void 0, _.extend({}, i, {
                      unmaskAsNumber: !0
                    })), null !== i.min && a < i.min) return i.isNegative = i.min < 0, i.postValidation(i.min.toString()
                    .replace(".", i.radixPoint)
                    .split(""), o, {
                      caret: o,
                      dopost: !0,
                      placeholder: "0"
                    }, i);
                  if (null !== i.max && a > i.max) return i.isNegative = i.max < 0, i.postValidation(i.max.toString()
                    .replace(".", i.radixPoint)
                    .split(""), o, {
                      caret: o,
                      dopost: !0,
                      placeholder: "0"
                    }, i)
                }
                return i.postValidation(t, o, {
                  caret: o,
                  placeholder: "0",
                  event: "blur"
                }, i);
              case "_checkval":
                return {
                  caret: o
                }
            }
            var a
          },
          regex: {
            integerPart: function(e, t) {
              return t ? new RegExp("[" + g.escapeRegex(e.negationSymbol.front) + "+]?") : new RegExp("[" + g.escapeRegex(e.negationSymbol.front) + "+]?\\d+")
            },
            integerNPart: function(e) {
              return new RegExp("[\\d" + g.escapeRegex(e.groupSeparator) + g.escapeRegex(e.placeholder.charAt(0)) + "]+")
            }
          },
          definitions: {
            "~": {
              validator: function(e, t, o, i, a, n) {
                if ("k" === e || "m" === e) {
                  for (var r = {
                      insert: [],
                      c: 0
                    }, s = 0, l = "k" === e ? 2 : 5; s < l; s++) r.insert.push({
                    pos: o + s,
                    c: 0
                  });
                  r.pos = o + l
                } else if (!0 !== (r = (i ? new RegExp("[0-9" + g.escapeRegex(a.groupSeparator) + "]") : /[0-9]/)
                    .test(e))) i || e !== a.radixPoint || void 0 !== t.validPositions[o - 1] || (r = {
                  insert: {
                    pos: o,
                    c: 0
                  },
                  pos: o + 1
                });
                else if (!0 !== a.numericInput && void 0 !== t.validPositions[o] && "~" === t.validPositions[o].match.def && !n) {
                  var c = t.buffer.join(""),
                    i = (c = (c = c.replace(new RegExp("[-" + g.escapeRegex(a.negationSymbol.front) + "]", "g"), ""))
                      .replace(new RegExp(g.escapeRegex(a.negationSymbol.back) + "$"), ""))
                    .split(a.radixPoint),
                    d = (1 < i.length && (i[1] = i[1].replace(/0/g, a.placeholder.charAt(0))), "0" === i[0] && (i[0] = i[0].replace(/0/g, a.placeholder.charAt(0))), c = i[0] + a.radixPoint + i[1] || "", t._buffer.join(""));
                  for (c === a.radixPoint && (c = d); null === c.match(g.escapeRegex(d) + "$");) d = d.slice(1);
                  r = void 0 === (c = (c = c.replace(d, ""))
                    .split(""))[o] ? {
                    pos: o,
                    remove: o
                  } : {
                    pos: o
                  }
                }
                return r
              },
              cardinality: 1
            },
            "+": {
              validator: function(e, t, o, i, a) {
                return a.allowMinus && ("-" === e || e === a.negationSymbol.front)
              },
              cardinality: 1,
              placeholder: ""
            },
            "-": {
              validator: function(e, t, o, i, a) {
                return a.allowMinus && e === a.negationSymbol.back
              },
              cardinality: 1,
              placeholder: ""
            },
            ":": {
              validator: function(e, t, o, i, a) {
                var n = "[" + g.escapeRegex(a.radixPoint) + "]",
                  n = new RegExp(n)
                  .test(e);
                return n = n && t.validPositions[o] && t.validPositions[o].match.placeholder === a.radixPoint ? {
                  caret: o + 1
                } : n
              },
              cardinality: 1,
              placeholder: function(e) {
                return e.radixPoint
              }
            }
          },
          onUnMask: function(e, t, o) {
            return ("" !== t || !0 !== o.nullable) && (t = (t = (t = e.replace(o.prefix, ""))
                  .replace(o.suffix, ""))
                .replace(new RegExp(g.escapeRegex(o.groupSeparator), "g"), ""), "" !== o.placeholder.charAt(0) && (t = t.replace(new RegExp(o.placeholder.charAt(0), "g"), "0")), o.unmaskAsNumber) ? +(t = (t = "" !== o.radixPoint && -1 !== t.indexOf(o.radixPoint) ? t.replace(g.escapeRegex.call(this, o.radixPoint), ".") : t)
                .replace(new RegExp("^" + g.escapeRegex(o.negationSymbol.front)), "-"))
              .replace(new RegExp(g.escapeRegex(o.negationSymbol.back) + "$"), "") : t
          },
          isComplete: function(e, t) {
            e = (e = (e = (e = (e = (e = (t.numericInput ? e.slice()
                          .reverse() : e)
                        .join(""))
                      .replace(new RegExp("^" + g.escapeRegex(t.negationSymbol.front)), "-"))
                    .replace(new RegExp(g.escapeRegex(t.negationSymbol.back) + "$"), ""))
                  .replace(t.prefix, ""))
                .replace(t.suffix, ""))
              .replace(new RegExp(g.escapeRegex(t.groupSeparator) + "([0-9]{3})", "g"), "$1");
            return "," === t.radixPoint && (e = e.replace(g.escapeRegex(t.radixPoint), ".")), isFinite(e)
          },
          onBeforeMask: function(e, t) {
            t.isNegative = void 0, e = (e = "number" == typeof e && "" !== t.radixPoint ? e.toString()
                .replace(".", t.radixPoint) : e)
              .toString()
              .charAt(e.length - 1) === t.radixPoint ? e.toString()
              .substr(0, e.length - 1) : e.toString();
            var o = (e = "" !== t.radixPoint && isFinite(e) && (o = e.split("."), i = "" === t.groupSeparator ? 0 : parseInt(t.groupSize), 2 === o.length) && (o[0].length > i || o[1].length > i || o[0].length <= i && o[1].length < i) ? e.replace(".", t.radixPoint) : e)
              .match(/,/g),
              i = e.match(/\./g);
            return e = i && o ? i.length > o.length ? (e = e.replace(/\./g, ""))
              .replace(",", t.radixPoint) : o.length > i.length ? (e = e.replace(/,/g, ""))
              .replace(".", t.radixPoint) : e.indexOf(".") < e.indexOf(",") ? e.replace(/\./g, "") : e.replace(/,/g, "") : e.replace(new RegExp(g.escapeRegex(t.groupSeparator), "g"), ""), 0 === t.digits && (-1 === e.indexOf(".") ? -1 !== e.indexOf(",") && (e = e.substring(0, e.indexOf(","))) : e = e.substring(0, e.indexOf("."))), "" !== t.radixPoint && isFinite(t.digits) && -1 !== e.indexOf(t.radixPoint) && (o = e.split(t.radixPoint)[1].match(/\d*/)[0], parseInt(t.digits) < o.toString()
                .length) && (i = Math.pow(10, parseInt(t.digits)), e = e.replace(g.escapeRegex(t.radixPoint), "."), e = (e = Math.round(parseFloat(e) * i) / i)
                .toString()
                .replace(".", t.radixPoint)),
              function(e, t) {
                if (t.numericInput) {
                  var o = _.inArray(t.radixPoint, e); - 1 === o && (e.push(t.radixPoint), o = e.length - 1);
                  for (var i = 1; i <= t.digits; i++) e[o + i] = e[o + i] || "0"
                }
                return e
              }(e.toString()
                .split(""), t)
              .join("")
          },
          onKeyDown: function(e, t, o, i) {
            var a = _(this);
            if (e.ctrlKey) switch (e.keyCode) {
              case g.keyCode.UP:
                a.val(parseFloat(this.inputmask.unmaskedvalue()) + parseInt(i.step)), a.trigger("setvalue");
                break;
              case g.keyCode.DOWN:
                a.val(parseFloat(this.inputmask.unmaskedvalue()) - parseInt(i.step)), a.trigger("setvalue")
            }
          }
        },
        currency: {
          prefix: "$ ",
          groupSeparator: ",",
          alias: "numeric",
          placeholder: "0",
          autoGroup: !0,
          digits: 2,
          digitsOptional: !1,
          clearMaskOnLostFocus: !1
        },
        decimal: {
          alias: "numeric"
        },
        integer: {
          alias: "numeric",
          digits: 0,
          radixPoint: ""
        },
        percentage: {
          alias: "numeric",
          digits: 2,
          digitsOptional: !0,
          radixPoint: ".",
          placeholder: "0",
          autoGroup: !1,
          min: 0,
          max: 100,
          suffix: " %",
          allowMinus: !1
        }
      }), g
    };
  void 0 !== (i = i.apply(t, o)) && (e.exports = i)
}, function(e, t, o) {
  var i, r = "function" == typeof Symbol && "symbol" == _typeof(Symbol.iterator) ? function(e) {
    return _typeof(e)
  } : function(e) {
    return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : _typeof(e)
  };
  o = [o(4), o(2)], void 0 !== (t = "function" == typeof(i = function(a, n) {
    return void 0 === a.fn.inputmask && (a.fn.inputmask = function(e, t) {
      var o, i = this[0];
      if (void 0 === t && (t = {}), "string" == typeof e) switch (e) {
        case "unmaskedvalue":
          return i && i.inputmask ? i.inputmask.unmaskedvalue() : a(i)
            .val();
        case "remove":
          return this.each(function() {
            this.inputmask && this.inputmask.remove()
          });
        case "getemptymask":
          return i && i.inputmask ? i.inputmask.getemptymask() : "";
        case "hasMaskedValue":
          return !(!i || !i.inputmask) && i.inputmask.hasMaskedValue();
        case "isComplete":
          return !(i && i.inputmask) || i.inputmask.isComplete();
        case "getmetadata":
          return i && i.inputmask ? i.inputmask.getmetadata() : void 0;
        case "setvalue":
          n.setValue(i, t);
          break;
        case "option":
          if ("string" != typeof t) return this.each(function() {
            if (void 0 !== this.inputmask) return this.inputmask.option(t)
          });
          if (i && void 0 !== i.inputmask) return i.inputmask.option(t);
          break;
        default:
          return t.alias = e, o = new n(t), this.each(function() {
            o.mask(this)
          })
      } else {
        if (Array.isArray(e)) return t.alias = e, o = new n(t), this.each(function() {
          o.mask(this)
        });
        if ("object" == (void 0 === e ? "undefined" : r(e))) return o = new n(e), void 0 === e.mask && void 0 === e.alias ? this.each(function() {
          return void 0 === this.inputmask ? void o.mask(this) : this.inputmask.option(e)
        }) : this.each(function() {
          o.mask(this)
        });
        if (void 0 === e) return this.each(function() {
          (o = new n(t))
          .mask(this)
        })
      }
    }), a.fn.inputmask
  }) ? i.apply(t, o) : i) && (e.exports = t)
}]);
var rc_total_count = 0,
  createOrder = (function(m) {
      var i = {
        url: !1,
        callback: !1,
        target: !1,
        duration: 120,
        on: "mouseover",
        touch: !0,
        onZoomIn: !1,
        onZoomOut: !1,
        magnify: 1
      };
      m.zoom = function(e, t, o, i) {
        var a, n, r, s, l, c, d, u = m(e),
          p = u.css("position"),
          f = m(t);
        return e.style.position = /(absolute|fixed)/.test(p) ? p : "relative", e.style.overflow = "hidden", o.style.width = o.style.height = "", m(o)
          .addClass("zoomImg")
          .css({
            position: "absolute",
            top: 0,
            left: 0,
            opacity: 0,
            width: o.width * i,
            height: o.height * i,
            border: "none",
            maxWidth: "none",
            maxHeight: "none"
          })
          .appendTo(e), {
            init: function() {
              n = u.outerWidth(), a = u.outerHeight(), r = t === e ? (s = n, a) : (s = f.outerWidth(), f.outerHeight()), l = (o.width - n) / s, c = (o.height - a) / r, d = f.offset()
            },
            move: function(e) {
              var t = e.pageX - d.left,
                e = e.pageY - d.top,
                e = Math.max(Math.min(e, r), 0),
                t = Math.max(Math.min(t, s), 0);
              o.style.left = t * -l + "px", o.style.top = e * -c + "px"
            }
          }
      }, m.fn.zoom = function(o) {
        return this.each(function() {
          var a = m.extend({}, i, o || {}),
            n = a.target && m(a.target)[0] || this,
            e = this,
            r = m(e),
            s = document.createElement("img"),
            l = m(s),
            c = !1,
            d = !1;
          if (!a.url) {
            var t = e.querySelector("img");
            if (t && (a.url = t.getAttribute("data-src") || t.currentSrc || t.src), !a.url) return
          }
          r.one("zoom.destroy", function(e, t) {
            r.off(".zoom"), n.style.position = e, n.style.overflow = t, s.onload = null, l.remove()
          }.bind(this, n.style.position, n.style.overflow)), s.onload = function() {
            function t(e) {
              i.init(), i.move(e), l.stop()
                .fadeTo(m.support.opacity ? a.duration : 0, 1, !!m.isFunction(a.onZoomIn) && a.onZoomIn.call(s))
            }

            function o() {
              l.stop()
                .fadeTo(a.duration, 0, !!m.isFunction(a.onZoomOut) && a.onZoomOut.call(s))
            }
            var i = m.zoom(n, e, s, a.magnify);
            "grab" === a.on ? r.on("mousedown.zoom", function(e) {
                1 === e.which && (m(document)
                  .one("mouseup.zoom", function() {
                    o(), m(document)
                      .off("mousemove.zoom", i.move)
                  }), t(e), m(document)
                  .on("mousemove.zoom", i.move), e.preventDefault())
              }) : "click" === a.on ? r.on("click.zoom", function(e) {
                return c ? void 0 : (c = !0, t(e), m(document)
                  .on("mousemove.zoom", i.move), m(document)
                  .one("click.zoom", function() {
                    o(), c = !1, m(document)
                      .off("mousemove.zoom", i.move)
                  }), !1)
              }) : "toggle" === a.on ? r.on("click.zoom", function(e) {
                c ? o() : t(e), c = !c
              }) : "mouseover" === a.on && (i.init(), r.on("mouseenter.zoom", t)
                .on("mouseleave.zoom", o)
                .on("mousemove.zoom", i.move)), a.touch && r.on("touchstart.zoom", function(e) {
                e.preventDefault(), d ? (d = !1, o()) : (d = !0, t(e.originalEvent.touches[0] || e.originalEvent.changedTouches[0]))
              })
              .on("touchmove.zoom", function(e) {
                e.preventDefault(), i.move(e.originalEvent.touches[0] || e.originalEvent.changedTouches[0])
              })
              .on("touchend.zoom", function(e) {
                e.preventDefault(), d && (d = !1, o())
              }), m.isFunction(a.callback) && a.callback.call(s)
          }, s.setAttribute("role", "presentation"), s.alt = "", s.src = a.url
        })
      }, m.fn.zoom.defaults = i
    }(window.jQuery), $(document)
    .ready(function() {
      var e, t;
      $(".page__slider:not(.page__slider_product-catalog)")
        .slick({
          dots: !1,
          arrows: !0,
          infinite: !1,
          speed: 300,
          slidesToShow: 4,
          swipeToSlide: !0,
          variableWidth: !1,
          autoplay: !1,
          autoplaySpeed: 4e3,
          responsive: [{
            breakpoint: 767,
            settings: {
              dots: !0,
              slidesToShow: 1,
              slidesToScroll: 1,
              arrows: !1
            }
          }, {
            breakpoint: 991,
            settings: {
              dots: !0,
              slidesToShow: 2,
              slidesToScroll: 1,
              arrows: !1
            }
          }, {
            breakpoint: 1080,
            settings: {
              dots: !0,
              slidesToShow: 3,
              slidesToScroll: 1,
              arrows: !1
            }
          }, {
            breakpoint: 1200,
            settings: {
              dots: !0,
              slidesToShow: 3.5,
              slidesToScroll: 1,
              arrows: !1
            }
          }]
        }), $(".page__slider-feedback")
        .slick({
          dots: !1,
          arrows: !0,
          infinite: !1,
          speed: 300,
          slidesToShow: 3,
          swipeToSlide: !0,
          variableWidth: !1,
          autoplay: !1,
          autoplaySpeed: 12e3,
          responsive: [{
            breakpoint: 767,
            settings: {
              dots: !0,
              slidesToShow: 1.1,
              arrows: !0,
              slidesToScroll: 1
            }
          }, {
            breakpoint: 992,
            settings: {
              dots: !0,
              slidesToShow: 2,
              slidesToScroll: 1,
              arrows: !0
            }
          }]
        }), $(".page__slider-our-work")
        .slick({
          dots: !0,
          arrows: !0,
          infinite: !1,
          speed: 300,
          slidesToShow: 3,
          swipeToSlide: !0,
          variableWidth: !1,
          pauseOnHover: !0,
          autoplay: !0,
          autoplaySpeed: 3e3,
          responsive: [{
            breakpoint: 767,
            settings: {
              dots: !0,
              slidesToShow: 1,
              arrows: !1,
              slidesToScroll: 1
            }
          }, {
            breakpoint: 991,
            settings: {
              dots: !0,
              slidesToShow: 2,
              slidesToScroll: 1,
              arrows: !1
            }
          }]
        }), $(".page__slider-certificate")
        .slick({
          dots: !0,
          arrows: !1,
          infinite: !1,
          speed: 300,
          slidesToShow: 1,
          swipeToSlide: !0,
          variableWidth: !1,
          pauseOnHover: !0,
          autoplay: !0,
          autoplaySpeed: 3e3,
          responsive: [{
            breakpoint: 767,
            settings: {
              dots: !0,
              slidesToShow: 1,
              arrows: !1,
              slidesToScroll: 1
            }
          }, {
            breakpoint: 991,
            settings: {
              dots: !0,
              slidesToShow: 1,
              slidesToScroll: 1,
              arrows: !1
            }
          }]
        }), $(".page__slider-manager")
        .slick({
          dots: !1,
          arrows: !0,
          infinite: !1,
          slidesToShow: 4,
          swipeToSlide: !1,
          variableWidth: !1,
          autoplay: !1,
          autoplaySpeed: 1e3,
          speed: 500,
          cssEase: "linear",
          responsive: [{
            breakpoint: 992,
            settings: {
              dots: !0,
              slidesToScroll: 2,
              arrows: !1
            }
          }]
        }), $(".page__slider-shop-1-photo")
        .slick({
          dots: !0,
          arrows: !0,
          infinite: !0,
          speed: 300,
          slidesToShow: 2,
          swipeToSlide: !0,
          variableWidth: !1,
          autoplay: !0,
          autoplaySpeed: 12e3,
          responsive: [{
            breakpoint: 767,
            settings: {
              dots: !0,
              slidesToShow: 1,
              arrows: !1,
              slidesToScroll: 1
            }
          }, {
            breakpoint: 991,
            settings: {
              dots: !1,
              slidesToShow: 1,
              slidesToScroll: 1,
              arrows: !1
            }
          }]
        }), $(".page__slider-shop-1-proezd")
        .slick({
          dots: !0,
          arrows: !0,
          infinite: !0,
          speed: 300,
          slidesToShow: 2,
          swipeToSlide: !0,
          variableWidth: !1,
          autoplay: !0,
          autoplaySpeed: 12e3,
          responsive: [{
            breakpoint: 767,
            settings: {
              dots: !0,
              slidesToShow: 1,
              arrows: !1,
              slidesToScroll: 1
            }
          }, {
            breakpoint: 991,
            settings: {
              dots: !1,
              slidesToShow: 1,
              slidesToScroll: 1,
              arrows: !1
            }
          }]
        }), $(".page__slider-shop-2-photo")
        .slick({
          dots: !0,
          arrows: !0,
          infinite: !0,
          speed: 300,
          slidesToShow: 2,
          swipeToSlide: !0,
          variableWidth: !1,
          autoplay: !0,
          autoplaySpeed: 12e3,
          responsive: [{
            breakpoint: 767,
            settings: {
              dots: !0,
              slidesToShow: 1,
              arrows: !1,
              slidesToScroll: 1
            }
          }, {
            breakpoint: 991,
            settings: {
              dots: !1,
              slidesToShow: 1,
              slidesToScroll: 1,
              arrows: !1
            }
          }]
        }), $(".page__slider-shop-2-proezd")
        .slick({
          dots: !0,
          arrows: !0,
          infinite: !0,
          speed: 300,
          slidesToShow: 2,
          swipeToSlide: !0,
          variableWidth: !1,
          autoplay: !0,
          autoplaySpeed: 12e3,
          responsive: [{
            breakpoint: 767,
            settings: {
              dots: !0,
              slidesToShow: 1,
              arrows: !1,
              slidesToScroll: 1
            }
          }, {
            breakpoint: 991,
            settings: {
              dots: !1,
              slidesToShow: 1,
              slidesToScroll: 1,
              arrows: !1
            }
          }]
        }), $(".work-vh-slider")
        .slick({
          dots: !0,
          arrows: !0,
          infinite: !0,
          speed: 300,
          slidesToShow: 3,
          swipeToSlide: !0,
          variableWidth: !1,
          autoplay: !0,
          autoplaySpeed: 12e3,
          slidesToScroll: 3,
          responsive: [{
            breakpoint: 767,
            settings: {
              dots: !0,
              slidesToShow: 1,
              arrows: !1,
              slidesToScroll: 1
            }
          }, {
            breakpoint: 991,
            settings: {
              dots: !1,
              slidesToShow: 2,
              slidesToScroll: 1,
              arrows: !1
            }
          }]
        }), $(".work-mk-slider")
        .slick({
          dots: !0,
          arrows: !0,
          infinite: !0,
          speed: 300,
          slidesToShow: 3,
          swipeToSlide: !0,
          variableWidth: !1,
          autoplay: !0,
          autoplaySpeed: 12e3,
          slidesToScroll: 3,
          responsive: [{
            breakpoint: 767,
            settings: {
              dots: !0,
              slidesToShow: 1,
              arrows: !1,
              slidesToScroll: 1
            }
          }, {
            breakpoint: 991,
            settings: {
              dots: !1,
              slidesToShow: 2,
              slidesToScroll: 1,
              arrows: !1
            }
          }]
        }), $(".page__top-banner")
        .slick({
          dots: !0,
          arrows: !1,
          infinite: !0,
          speed: 300,
          slidesToShow: 1,
          swipeToSlide: !0,
          variableWidth: !1,
          autoplay: !0,
          autoplaySpeed: 4e3
        }), getCookie("CompareTest2AB") || ((e = Math.floor(20 * Math.random())) < 5 ? t = "a" : e < 10 ? t = "b" : e < 15 ? t = "c" : e < 20 && (t = "d"), console.log("set CompareTest2AB = " + t), setCookie("CompareTest2AB", t, {
          path: "/"
        })), "a" == getCookie("CompareTest2AB") ? ($("body")
          .removeClass("compare_true"), $("body")
          .removeClass("popular_true"), $("body")
          .removeClass("defer_true")) : "b" == getCookie("CompareTest2AB") ? $("body")
        .addClass("compare_true") : "c" == getCookie("CompareTest2AB") ? $("body")
        .addClass("popular_true") : "d" == getCookie("CompareTest2AB") && $("body")
        .addClass("defer_true"), e = new Date, t = e.getFullYear(), e = e.getMonth(), (i = document.querySelector(".js__sale-first-day")) && (i.innerHTML = "1.".concat(e + 1, ".")
          .concat(t));
      for (var o = (i = new Date)
          .getYear(), i = (i.getDate(), i.getMonth()), a = document.querySelectorAll(".js__sale-last-day"), n = new Date(o, i + 1, 0)
          .getDate() + [" января", " февраля", " марта", " апреля", " мая", " июня", " июля", " августа", " сентября", " октября", " ноября", " декабря"][i], r = 0, s = a.length; r < s; r++) a[r].innerHTML = n;
      for (var i = (o = new Date)
          .getYear(), l = o.getDate(), o = o.getMonth(), c = document.querySelectorAll(".container-banners .js__sale-last-day"), i = new Date(i, o + 1, 0)
          .getDate(), d = [" января", " февраля", " марта", " апреля", " мая", " июня", " июля", " августа", " сентября", " октября", " ноября", " декабря"], u = 11 == o && 20 <= l ? 15 + d[0] : i + d[o], p = 0, f = c.length; p < f; p++) c[p].innerHTML = u;
      $(".success span, .warning span, .attention span, .information span")
        .on("click", function() {
          $(this)
            .parent()
            .fadeOut("slow", function() {
              $(this)
                .remove()
            })
        }), $(document)
        .on("click", function(e) {
          $("#page__map iframe")
            .length && ("page__map" === e.target.id ? $("#page__map iframe")[0].style.pointerEvents = "all" : $("#page__map iframe")[0].style.pointerEvents = "none")
        }), $(".info-btn")
        .on("click", function() {
          window.location.href = $(this)
            .attr("data-info")
        })
    }), window.addEventListener("DOMContentLoaded", function() {
      $(".header__reliability-item-feadback")
        .each(function() {
          var e = $(this)
            .data("count");
          $(this)
            .html(declOfNum(e, ["оценка", "оценки", "оценок"]))
        }), document.getElementById("nav");
      var e = document.querySelector(".header__logo-img"),
        t = document.getElementById("header-fix"),
        o = document.getElementById("back-to-gd"),
        i = document.getElementById("header-fix__back"),
        e = (new IntersectionObserver(function(e) {
            e[0].intersectionRatio <= 0 ? (t && t.classList.add("header-fix_show"), i.classList.add("header-fix__back_show"), o && o.classList.add("back-to-gd_fix")) : (t && t.classList.remove("header-fix_show"), i.classList.remove("header-fix__back_show"), o && o.classList.remove("back-to-gd_fix"))
          })
          .observe(e), document.querySelector(".page__slider-feedback")),
        a = !1;
      e && new IntersectionObserver(function(e) {
          0 < e[0].intersectionRatio && !a && (a = !0, window["yaCounter" + YaCounterId].reachGoal("watch-feedback"))
        })
        .observe(e)
    }), $(document)
    .ready(function() {
      $(".header__links-link")
        .on("click", function() {
          window.location.href = $(this)
            .data("info")
        }), $(".header__burger-checkbox")
        .change(function() {
          $(this)
            .is(":checked") ? $("html, body")
            .css("overflow", "hidden") : $("html, body")
            .css("overflow", "auto")
        }), $("#header-fix__back")
        .on("click", function() {
          return $("body,html")
            .animate({
              scrollTop: 0
            }, 300), !1
        })
    }), $(document)
    .ready(function() {
      $("#main__banner")
        .slick({
          dots: !0,
          arrows: !0,
          infinite: !0,
          speed: 500,
          slidesToShow: 1,
          variableWidth: !0,
          autoplay: !0,
          autoplaySpeed: 4e3
        }), $("#main__review")
        .slick({
          speed: 1e4,
          autoplay: !0,
          autoplaySpeed: 0,
          cssEase: "linear",
          slidesToShow: 1,
          slidesToScroll: 1,
          draggable: !1,
          pauseOnFocus: !1,
          pauseOnHover: !1,
          variableWidth: !0,
          infinite: !0,
          initialSlide: 1,
          arrows: !1,
          dots: !1
        })
    }), $(document)
    .ready(function() {
      $(".manager__analog")
        .each(function() {
          var o = $(this),
            e = o.data("analogid");
          "" != e ? $.memoizedAjax({
            url: "/products_by_id/" + e + ".json",
            localStorage: !0,
            type: "GET",
            success: function(e) {
              var e = e.products[0],
                t = e.variants[0];
              $(o)
                .append("<a href='/product/" + e.permalink + "'>" + e.title + "</a><br>Цена полотна: <b>" + t.base_price + " ₽ (" + t.old_price + " ₽)</b>")
            }
          }) : console.log("JSON argemunt is not exist", e)
        })
    }), $(document)
    .ready(function() {
      $(".product-door__analog")
        .each(function() {
          var t = $(this),
            e = t.data("analogid");
          "" != e ? $.memoizedAjax({
            url: "/products_by_id/" + e + ".json",
            localStorage: !0,
            type: "GET",
            success: function(e) {
              e = e.products[0];
              e.variants[0], $(t)
                .removeClass("product__button_hidden"), $(t)
                .attr("href", "/product/" + e.permalink)
            }
          }) : console.log("JSON argemunt is not exist", e)
        })
    }), $(function(t) {
      var o, i, a = new Date,
        n = 0;
      t(".date-price")
        .each(function(e) {
          i = "index" + e, t(this)
            .attr("id", i), i = t(this)
            .data()
            .date, n = new Date(t(this)
              .data()
              .date), o = (a.getTime() - n.getTime()) / 864e5, (o = Math.floor(o)) < 90 ? isNaN(o) || t(this)
            .css({
              color: "#3d9a1e"
            }) : isNaN(o) || (t(this)
              .html(i + " - проверить цену закупа!!!"), t(this)
              .css({
                color: "#ff0000",
                "font-weight": "bold"
              }))
        })
    }), window.addEventListener("DOMContentLoaded", function() {
      if (!ge("filter__btns")) return !1;
      console.log("START");
      var e, o, i, t = ge("filter__btns"),
        a = ge("aside__filter"),
        n = !1,
        r = (window.addEventListener("scroll", function() {
          var e = a.getBoundingClientRect();
          n = !!(e.top < 300), (n = e.bottom - window.innerHeight < 80 ? !1 : n) ? t.classList.add("filter__btns_fix") : t.classList.remove("filter__btns_fix")
        }), ge("filter__price")),
        s = (r && (e = {
          setMin: r.dataset.setMin || r.dataset.collMin,
          setMax: r.dataset.setMax || r.dataset.collMax,
          min: r.dataset.collMin,
          max: r.dataset.collMax
        }, noUiSlider.create(r, {
          start: [e.setMin, e.setMax],
          step: 10,
          connect: !0,
          range: {
            min: parseInt(e.min, 10),
            max: parseInt(e.max, 10)
          }
        }), o = [ge("filter__price-from"), ge("filter__price-to")], r.noUiSlider.on("update", function(e, t) {
          o[t].value = parseInt(e[t])
            .toFixed(0)
        }), o[0].addEventListener("change input paste", function() {
          r.noUiSlider.set([this.value, null])
        }), o[1].addEventListener("change input paste", function() {
          r.noUiSlider.set([null, this.value])
        })), ge("filter__price_mob")),
        l = (s && (s.dataset.setMin || s.dataset.collMin, s.dataset.setMax || s.dataset.collMax, s.dataset.collMin, s.dataset.collMax, noUiSlider.create(s, {
          start: [e.setMin, e.setMax],
          step: 10,
          connect: !0,
          range: {
            min: parseInt(e.min, 10),
            max: parseInt(e.max, 10)
          }
        }), i = [ge("filter__price-from_mob"), ge("filter__price-to_mob")], s.noUiSlider.on("update", function(e, t) {
          i[t].value = parseInt(e[t])
            .toFixed(0)
        }), i[0].addEventListener("change input paste", function() {
          s.noUiSlider.set([this.value, null])
        }), i[1].addEventListener("change input paste", function() {
          s.noUiSlider.set([null, this.value])
        })), !1),
        c = (ge("filter__active-submit") && ge("filter__active-submit")
          .addEventListener("click", function() {
            a.submit()
          }), ge("filter__active"));
      console.log(c), c && c.addEventListener("click", function(e) {
        console.log(e);
        for (var t = e.target; t != c;) {
          if (t.dataset && t.dataset.itemid) {
            var o = t;
            console.log(o);
            var i = !1;
            $(".filter__block .form__checkbox-el[value='" + o.dataset.itemid + "']")
              .each(function() {
                $(this)
                  .prop("checked", !$(this)
                    .prop("checked")), i = $(this)
                  .prop("checked")
              }), $(".filter__block option[value='" + o.dataset.itemid + "']")
              .each(function() {
                $(this)
                  .prop("selected", !$(this)
                    .prop("selected")), i = $(this)
                  .prop("selected")
              }), o.className = "filter__active-item filter__active-item_" + i, l || (l = !0, ge("filter__active-submit")
                .style.display = "inline-block");
            return
          }
          t = t.parentNode
        }
      }, !1)
    }), window.addEventListener("DOMContentLoaded", function() {
      function e(e) {
        return !!e && e.checked
      }
      var t, o, i = getCookie("design-modal-showed");
      i || (t = $(".filter__list_ton-polotna")
        .first()
        .find("input"), o = $(".filter__list_dizayn-dveri")
        .first()
        .find("input"), [].slice.call(t)
        .some(e) && [].slice.call(o)
        .some(e) && $(".filter__active-item")
        .one("mouseover", function() {
          i || (setCookie("design-modal-showed", !0), i = !0, $("#help-design")
            .modal())
        }))
    }), $(document)
    .ready(function() {
      $(".info-link-tsena")
        .on("click", function() {
          $(".pravila")
            .toggle()
        }), $("#filter__open-btn")
        .on("click", function() {
          $("#filters")
            .addClass("show");
          disableScroll()
        }), $("#filters__btn-close")
        .on("click", function() {
          $("#filters")
            .removeClass("show");
          enableScroll()
        }), $(".filter__star-block")
        .each(function() {
          var e = $(this),
            t = e.find(".filter__star-input"),
            o = e.find(".filter__star-item-5");
          o.hide(), $.each(t, function() {
            5 <= parseInt($(this)
              .data("value")) && o.show()
          })
        }), $(".filter__star-item")
        .hover(function() {
          $(this)
            .parent()
            .addClass("filter__star-svg-block_hover-" + $(this)
              .index())
        }, function() {
          $(this)
            .parent()
            .removeClass("filter__star-svg-block_hover-" + $(this)
              .index())
        }), $(".filter__star-item")
        .on("click", function() {
          var e = $(this)
            .parents(".filter__block"),
            t = $(this)
            .index(),
            o = $(this)
            .parents(".filter__star-block")
            .data("handle"),
            o = (e[0].className = "filter__block filter__block_" + o + " filter__star-svg-block_" + t, e.find(".filter__star-input"));
          e.find(".form__checkbox-el_star")
            .prop("checked", !0), $.each(o, function() {
              $(this)
                .prop("checked", !1), $(this)
                .data("value") >= t && $(this)
                .prop("checked", !0)
            })
        });
      var a = {};
      $(".filter__star-block")
        .each(function() {
          var o = $(this),
            e = o.find(".filter__star-input"),
            i = 10,
            t = o.data("name");
          a[o.data("handle")] = {
              min: 0,
              arr: [],
              name: o.data("name")
            }, $.each(e, function() {
              var e, t;
              1 == $(this)
                .prop("checked") && (e = parseInt($(this)
                    .data("value")), t = $(this)
                  .val(), a[o.data("handle")].arr.push(t), $("#filter__active-item-" + t)
                  .hide(), e < i && (i = e), a[o.data("handle")].min = i)
            }), o.find(".filter__star-item-" + i)
            .click(), i < 10 && $(".filter__active")
            .append("<div class='filter__active-item' data-handle='" + o.data("handle") + "'><span class='filter__active-title'>" + t + ": от " + i + " звезд</span></div>")
        }), $(document)
        .on("click", ".filter__active-item", function() {
          var e, t, o;
          $(this)
            .data("handle") && (t = (e = $(this))
              .data("handle"), $("#filter__active-submit")
              .css("display", "inline-block"), e.addClass("filter__active-item_false"), 1 == (o = $("#general-star-checkbox-" + t))
              .prop("checked") ? o.prop("checked", !1)
              .change() : (e.removeClass("filter__active-item_false"), e.addClass("filter__active-item_true"), o = a[t].min, $(".filter__star-block_" + t)
                .find(".filter__star-item-" + o)
                .click()))
        }), $(".form__checkbox-el_star")
        .change(function() {
          var e = $(this)
            .parents(".filter__block"),
            t = $(this)
            .parents(".filter__star-block")
            .data("handle");
          this.checked ? e.find(".filter__star-item-1")
            .click() : (e[0].className = "filter__block filter__block_" + t, e.find(".filter__star-input")
              .each(function() {
                $(this)
                  .prop("checked", !1)
              }))
        })
    }), window.addEventListener("DOMContentLoaded", function() {
      function t(e) {
        var e = e.getBoundingClientRect(),
          t = o.getBoundingClientRect(),
          e = e.top + e.height / 2 + window.pageYOffset,
          t = t.right + window.pageXOffset + 4;
        i.style.display = "block", i.style.top = e + "px", i.style.left = t + "px"
      }
      var e, o = document.querySelector(".aside__filter"),
        i = document.querySelector(".js-filter-popup");
      o && (e = o.querySelector(".form__range"), i && i.addEventListener("click", function() {
        o.querySelector(".filter__submit")
          .click()
      }), e.addEventListener("click", function() {
        t(e)
      }), o.addEventListener("change", function(e) {
        t(e.target.parentElement)
      }))
    }), $(document)
    .ready(function() {
      var e = $(".aside__filter");
      e.length && e.submit(function(e) {
        e.preventDefault();
        var e = this.querySelector(".filter__price-from"),
          t = this.querySelector(".filter__price-to");
        e.dataset.min == e.value && (e.disabled = !0), t.dataset.max == t.value && (t.disabled = !0), this.submit()
      })
    }),
    function() {
      function t(e) {
        "" != e ? $.memoizedAjax({
          url: "/products_by_id/" + e + ".json",
          localStorage: !0,
          type: "GET",
          success: function(e) {
            var t = e.products[0].variants[0].price;
            e.products[0].variants.forEach(function(e) {
                e.price != t && (t = !1), i[e.id] = {
                  price: parseInt(e.price),
                  oldPrice: parseInt(e.old_price)
                }
              }), t || $(o)
              .on("change", function() {
                var e = $(this)
                  .val();
                $("#price-field2")
                  .html(i[e].price + " ₽"), $("#old-field2")
                  .html(i[e].oldPrice + " ₽")
              })
          }
        }) : console.log("JSON argemunt is not exist", e)
      }
      var o, i = {};
      window.productVariant = function(e) {
        o = e, t($(e)
          .data("id"))
      }
    }(), ! function(n) {
      n.fn.feedbackToOrder = function(a) {
        return this.each(function() {
          var i = n(this);
          i.submit(function(e) {
            if (i.hasClass("feedback__form_sending")) return !1;
            i.addClass("feedback__form_sending");
            var t = 0,
              o = (i.find(".form__item")
                .removeClass("form__item_error"), {
                  rayon: i.find("[name='feedback[rayon]']"),
                  needDostavka: i.find("[name='feedback[nugna-dostavka]']"),
                  needInstall: i.find("[name='feedback[nugna-ustanovka]']"),
                  doorTitle: i.find(".modal-door-title"),
                  summ: i.find("[name='feedback[summ]']"),
                  name: i.find("input[name='feedback[name]']")
                    .val(),
                  phone: i.find("input[name='feedback[phone]']"),
                  content: i.find("input[name='feedback[content]']")
                    .val(),
                  precontent: i.find("input[name='feedback[pre-content]']"),
                  info: i.find("input[name='feedback[info]']")
                    .val(),
                  shop: localStorage.getItem("shop"),
                  email: i.find("input[name='feedback[from]']")
                    .val() || i.find("input[name='feedback[email]']")
                    .val(),
                  source: i.find("input[name='feedback[source]']")
                    .val(),
                  dop: i.find("input[name='feedback[dop]']"),
                  agreement: i.find("input[name='eula_accepted']"),
                  delivery: n("#createOrder")
                    .data("delivery"),
                  payment: n("#createOrder")
                    .data("payment"),
                  productId: 0,
                  doorType: n("#doors-select")
                    .val(),
                  doorSize: n("#door-size-select")
                    .val()
                });
            if ("shop_1" === o.shop) o.shop = localStorage.getItem("shop_1_adress");
            else if ("shop_2" === o.shop) o.shop = localStorage.getItem("shop_2_adress");
            else if ("shop_0" === localStorage.getItem("shop")) o.shop = "Магазин не выбран";
            else {
              if (null !== o.shop) return o.shop = "Магазин не выбран", $(".chooseCitySmall")
                .toggleClass("active"), $(".chooseCitySmall")
                .attr("data-form", $(this)
                  .attr("id")), console.log("id for small form", $(this)
                  .attr("id")), console.log("id for small form", $(this)), $(".popup.modal.fade.in")
                .css({
                  display: "none"
                }), i.removeClass("feedback__form_sending"), !1;
              o.shop = ""
            }
            return o.productId = n(".product")
              .length ? n(".product")
              .data("variant-id") : i.find("input[name='feedback[product-variant]']")
              .length && "" != i.find("input[name='feedback[product-variant]']")
              .val() ? i.find("input[name='feedback[product-variant]']")
              .val() : n("#createOrder")
              .data("product"), o.summ = (o.summ.length, (o.precontent && o.precontent.val() ? o.precontent.val() : "") + o.shop + "\n\n" + (o.summ && o.summ.val() ? "Количество комплектов: " + o.summ.val() + "\n" : "") + (o.rayon && o.rayon.val() ? "Район: " + o.rayon.val() + "\n" : "") + (o.needDostavka && o.needDostavka.val() ? o.needDostavka.val() + "\n" : "") + (o.needInstall && o.needInstall.val() ? o.needInstall.val() + "\n" : "") + (o.doorTitle && o.doorTitle.html() ? "Выбранная " + (o.doorTitle.hasClass("modal-article-title") ? "акция: " : "дверь: ") + o.doorTitle.html() + "\n" : "") + (o.doorType ? "Способ открывания: " + o.doorType + "\n" : "") + (o.doorSize ? "Размер: " + o.doorSize + "\n" : "")), o.dop = o.dop.length ? "Сайт где нашли дешевле " + o.dop.val() : "", o.phone.inputmask("isComplete") || (o.phone.parents(".form__item")
                .addClass("form__item_error"), $(".popup.modal.fade.in")
                .css({
                  display: "block"
                }), t += 1), 0 == o.agreement.prop("checked") && (o.agreement.parents(".form__item")
                .addClass("form__item_error"), $(".popup.modal.fade.in")
                .css({
                  display: "block"
                }), t += 1), t && i.removeClass("feedback__form_sending"), !t && (o.phone = o.phone.val(), createOrder(o, i, a), e.preventDefault(), !1)
          })
        })
      }
    }(jQuery), $(document)
    .ready(function() {
      var e = $(".accordion div.data"),
        t = $(".accordion .accordion-item"),
        o = ($(".accordion > .accordion-item")
          .click(function() {
            return $(this)
              .hasClass("open") ? ($(this)
                .removeClass("open"), void $(this)
                .next()
                .slideUp("fast")) : (e.slideUp("fast"), t.removeClass("open"), $(this)
                .addClass("open"), $(this)
                .next()
                .slideDown("fast"), !1)
          }), $(".product__buy_only-polotno")
          .on("click", function() {
            $.post("/cart_items.json", {
                variant_id: $(".product__form_variant_id")
                  .val(),
                quantity: $(".product__form .form__count-input")
                  .val()
              })
              .done(function(e) {
                $(".header__cart-count")
                  .html(e.items_count), $(".header__cart-summ")
                  .html(Math.round(e.total_price) + " ₽"), $("#product-popup-cart")
                  .modal("hide")
              })
          }), $(".product__gallery")
          .slick({
            dots: !1,
            arrows: !0,
            infinite: !1,
            slidesToShow: 5,
            slidesToScroll: 1,
            vertical: !0,
            speed: 300,
            responsive: [{
              breakpoint: 1024,
              settings: {
                slidesToShow: 3,
                slidesToScroll: 1,
                vertical: !0,
                dots: !1
              }
            }, {
              breakpoint: 992,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                vertical: !1,
                arrows: !1,
                dots: !0
              }
            }]
          }), 1 == $(".product__gallery-item")
          .length && $(".product__gallery")
          .addClass("product__gallery_solo"), $(".product__image")
          .zoom({
            url: $(this)
              .find(".product__image-main")
              .data("zoom")
          }), $(".product__gallery-item")
          .on("click", function() {
            $(".product__image")
              .trigger("zoom.destroy");
            var e = $(this)
              .data("image");
            $(".product__image")
              .zoom({
                url: e
              }), $(".product__image-main")
              .prop("src", $(this)
                .data("image"))
          }), $("#product__variant-size"));
      o.length && productVariant(o)
    }), $(document)
    .ready(function() {
      function o(e) {
        null == c.porog && null == c.dobor && null == c.zamok && $.post("/collection/calc-service.json", {})
          .done(function(e) {
            for (var t = 0; t < e.products.length; t++) switch (e.products[t].title) {
              case "(МКОБЛ) Установка порога межкомнатной двери":
                c.porog = parseInt(e.products[t].variants[0].base_price);
                break;
              case "(МКОБЛ) Установка 1го ряда доборного элемента межкомнатной двери до 20 см":
                c.dobor = parseInt(e.products[t].variants[0].base_price);
                break;
              case "(МКВРЕЗ) Врезка замка сантехнического/цилиндрового - 1 шт":
                c.zamok = parseInt(e.products[t].variants[0].base_price)
            }
          }), l || $.post("/collection/zashelka.json", {})
          .done(function(e) {
            l = {
                data: e.products[0],
                price: parseInt(e.products[0].variants[0].base_price),
                title: e.products[0].title.replace("Фурнитура - ", "")
              }, $("#calc__item_doorhandle-list")
              .html("<div class='calc__dop-item'><span class='calc__dop-name'>" + l.title + "</span> <span class='calc__dop-price'>" + Math.round(l.price) + " ₽</span></div>")
              .hide()
          });

        function s(e, t, o) {
          return '<label class="form__radio"><input type="radio" class="form__radio-el" ' + (e ? "" : "checked") + ' data-image="' + t.img + '" value="' + e + '" name="' + o + '"><span class="form__radio-label calc__item-label_img"><span class="calc__item-label-img" style="background-image: url(' + t.img + ')"></span><span class="calc__item-label-name">' + t.tip + ' <span class="calc__item-label-price">' + (t.garant ? "гарантия " + t.garant + ", " : "") + " " + t.price + " ₽</span></span></span></label>"
        }
        d.length || $.post("/collection/calc-doorhandle.json", {})
          .done(function(e) {
            for (var t = 0; t < e.products.length; t++) {
              for (var o = 0, i = 0, a = 0; a < e.products[t].properties.length; a++) "Гарантия на комплектующие" == e.products[t].properties[a].title && (o = e.products[t].properties[a].id), "Подвид товара" == e.products[t].properties[a].title && (i = e.products[t].properties[a].id);
              for (var n = {
                  id: e.products[t].id,
                  price: parseInt(e.products[t].variants[0].base_price),
                  img: e.products[t].first_image.thumb_url,
                  tip: ""
                }, r = 0; r < e.products[t].characteristics.length; r++) e.products[t].characteristics[r].property_id == i && (n.tip = e.products[t].characteristics[r].title), o && e.products[t].characteristics[r].property_id == o && (n.garant = e.products[t].characteristics[r].title);
              d.push(n), $("#calc__doorhandle")
                .append(s(t, n, "doorhandle-type"))
            }
            $("#calc__item_doorhandle .calc__item-price")
              .text(d[0].price + " ₽"), $("#calc__item_doorhandle .calc__item-selected-text")
              .html("<span class='calc__item-label-img' style='background-image: url(" + d[0].img + ")'></span>" + d[0].tip)
          }), u.length || $.post("/collection/calc-doorhinges.json", {})
          .done(function(e) {
            for (var t = 0; t < e.products.length; t++) {
              for (var o = 0, i = 0, a = 0; a < e.products[t].properties.length; a++) "Подвид товара" == e.products[t].properties[a].title && (o = e.products[t].properties[a].id), "Гарантия на комплектующие" == e.products[t].properties[a].title && (i = e.products[t].properties[a].id);
              for (var n = {
                  id: e.products[t].id,
                  price: parseInt(2 * e.products[t].variants[0].base_price),
                  img: e.products[t].first_image.thumb_url
                }, r = 0; r < e.products[t].characteristics.length; r++) e.products[t].characteristics[r].property_id == o && (n.tip = e.products[t].characteristics[r].title), i && e.products[t].characteristics[r].property_id == i && (n.garant = e.products[t].characteristics[r].title);
              u.push(n), $("#calc__doorhinges")
                .append(s(t, n, "doorhinges-type"))
            }
            $("#calc__item_doorhinges .calc__item-price")
              .text(u[0].price + " ₽"), $("#calc__item_doorhinges .calc__item-selected-text")
              .html("<span class='calc__item-label-img' style='background-image: url(" + u[0].img + ")'></span>" + u[0].tip)
          }), p.length && f ? n.zamok = f : $.post("/collection/santeh.json", {})
          .done(function(e) {
            for (var t, o = n.zamok = 0; o < e.products.length; o++) t = {
              id: e.products[o].id,
              price: parseInt(e.products[o].variants[0].base_price)
            }, f += t.price, n.zamok += t.price, p.push(t);
            $("#calc__item_zamok .calc__item-price")
              .text(n.zamok + " ₽")
          }), e.find(".form__radio-el")
          .parent()
          .show(), e.find(".calc__product-link")
          .prop("href", n.url)
          .html(n.product), n.sku ? e.find(".calc__product-sku")
          .show()
          .html(n.sku) : e.find(".calc__product-sku")
          .hide(), !n.korobt || n.dobor100t || n.dobor150t ? $("#calc__item_dobor")
          .show() : ($("#calc__item_dobor .form__checkbox-el")
            .prop("checked", !1), $("#calc__item_dobor")
            .hide()), (n.dobor150 || n.dobor150t) && ($("#calc__dobor-size-label")
            .html("150 мм"), m = "150"), (n.dobor100 || n.dobor100t) && ($("#calc__dobor-size-label")
            .html("100 мм"), m = "100"), e.find(".calc__product-sku")
          .html(n.sku), $("#calc__item_product")
          .find(".calc__item-price")
          .text(n.price + " ₽"), $("#calc__item_zamok")
          .find(".calc__item-price")
          .text(n.zamok + " ₽"), $("#calc__item_service")
          .find(".calc__item-price")
          .text(n.service + " ₽"), 0 == n.korobt && (e.find(".form__radio-el[name='pogon-type'][value='0']")
            .prop("checked", !0)
            .change(), e.find(".form__radio-el[name='pogon-type'][value='1']")
            .parent()
            .hide()), 0 == n.korob && (e.find(".form__radio-el[name='pogon-type'][value='1']")
            .prop("checked", !0)
            .change(), e.find(".form__radio-el[name='pogon-type'][value='0']")
            .parent()
            .hide()), n.oldprice && "0" != n.oldprice ? ($(".calc__modal-right")
            .addClass("calc__result_discount"), $("#calc__result-price_discount")
            .text(Math.round(n.oldprice - n.price) + " ₽"), $("#calc__result-desc-oldprice")
            .text(Math.round(n.oldprice) + " ₽")) : $(".calc__modal-right")
          .removeClass("calc__result_discount"), r = "", e.find(".form__radio-el[name='nalich-type'][value='1']")
          .prop("checked", !0)
          .change(), e.find(".form__radio-el[name='dobor-type'][value='1.5']")
          .prop("checked", !0)
          .change(), e.find(".form__radio-el[name='ruchka-type'][value='0']")
          .prop("checked", !0)
          .change(), $("#calc__item_korob")
          .find(".calc__item-price")
          .text(n["korob" + r] + " ₽")
      }

      function i() {
        var e = {
            price: n.price,
            korob: 0,
            porog: 0,
            porogService: 0,
            nalich: 0,
            dobor: 0,
            doborService: 0,
            doorhandle: 0,
            zashelka: 0,
            doorhinges: 0,
            zamok: 0,
            zamokService: 0,
            service: !1,
            serviceList: ""
          },
          t = (r = "1" == $(".form__radio-el[name='pogon-type']:checked")
            .val() ? "t" : "", e.pogon = $(".form__radio-el[name='pogon-type']:checked")
            .next()
            .text(), e.korob = $("#calc__item_korob .form__checkbox-el")
            .is(":checked") ? 2.5 * n["korob" + r] : 0, "1" == $(".form__radio-el[name='porog']:checked")
            .val() && $("#calc__item_korob .form__checkbox-el")
            .is(":checked") && (e.porog = Math.round(.5 * n["korob" + r]), e.porogService = Math.round(c.porog), e.serviceList += "<div class='calc__dop-item'>Установка порога межкомнатной двери <span class='calc__dop-price'>" + Math.round(c.porog) + " ₽</span></div>"), $("#calc__item_korob")
            .find(".calc__item-price")
            .text(Math.round(2.5 * n["korob" + r] + ("1" == $(".form__radio-el[name='porog']:checked")
              .val() ? .5 * n["korob" + r] : 0)) + " ₽"), e.nalichType = $(".form__radio-el[name='nalich-type']:checked")
            .val(), e.nalich = $("#calc__item_nalich .form__checkbox-el")
            .is(":checked") ? 2.5 * n["nalich" + r] * e.nalichType : 0, $("#calc__item_nalich")
            .find(".calc__item-price")
            .text(Math.round(2.5 * n["nalich" + r] * e.nalichType) + " ₽"), e.doborType = $(".form__radio-el[name='dobor-type']:checked")
            .val(), $("#calc__item_dobor .form__checkbox-el")
            .is(":checked") && (e.dobor = n["dobor" + m + r] * parseFloat(e.doborType), e.doborService = c.dobor, e.serviceList += "<div class='calc__dop-item'>Установка добора для 1 проема <span class='calc__dop-price'>" + Math.round(c.dobor) + " ₽</span></div>"), $("#calc__item_dobor")
            .find(".calc__item-price")
            .text(Math.round(n["dobor" + m + r] * parseFloat(e.doborType)) + " ₽"), e.doorhandleType = $(".form__radio-el[name='doorhandle-type']:checked")
            .val(), null != e.doorhandleType && (e.doorhandle = $("#calc__item_doorhandle .form__checkbox-el")
              .is(":checked") ? d[e.doorhandleType] : 0, $("#calc__item_doorhandle .calc__item-price")
              .html(d[e.doorhandleType].price + " ₽"), "Нажимная" == d[e.doorhandleType].tip ? ($("#calc__item_doorhandle-list")
                .removeClass("calc__dop-item_active")
                .show(), $("#calc__item_doorhandle .form__checkbox-el")
                .is(":checked") && ($("#calc__item_doorhandle-list")
                  .addClass("calc__dop-item_active"), e.zashelka = l.price)) : $("#calc__item_doorhandle-list")
              .hide()), e.doorhingesType = $(".form__radio-el[name='doorhinges-type']:checked")
            .val(), null != e.doorhingesType && (e.doorhinges = $("#calc__item_doorhinges .form__checkbox-el")
              .is(":checked") ? u[e.doorhingesType] : 0, $("#calc__item_doorhinges")
              .find(".calc__item-price")
              .text(u[e.doorhingesType].price + " ₽")), $("#calc__item_zamok .form__checkbox-el")
            .is(":checked") && (e.zamok = n.zamok, e.zamokService = c.zamok, e.serviceList += "<div class='calc__dop-item'>Врезка замка сантехнического/цилиндрового <span class='calc__dop-price'>" + Math.round(c.zamok) + " ₽</span></div>"), e.price + e.korob + e.porog + e.nalich + e.dobor + (e.doorhandle ? e.doorhandle.price : 0) + (e.doorhinges ? e.doorhinges.price : 0) + e.zashelka + e.zamok),
          o = ($("#calc__result-price_summ")
            .text(Math.round(t) + " ₽"), $("#calc__result-desc-oldprice, #calc__result-price_summ-old")
            .text(Math.round(t + n.oldprice - n.price) + " ₽"), e.service = !!$("#calc__item_service .form__checkbox-el")
            .is(":checked"), e.serviceList = "<div class='calc__dop-service'>в комплект входит:</div><div class='calc__dop-item'>Установка дверного полотна <span class='calc__dop-price'>" + Math.round(n.service) + " ₽</span></div>" + e.serviceList, n.service + e.porogService + e.doborService + e.zamokService),
          i = ($("#calc__result-service-summ")
            .text(Math.round(o) + " ₽"), $("#calc__item_service .calc__item-price")
            .text(Math.round(o) + " ₽"), ""),
          a = ($(".calc__item .form__checkbox-el")
            .each(function() {
              var e;
              $(this)
                .is(":checked") && (e = $(this)
                  .prop("name"), i += " calc__result_" + e)
            }), "1" == $(".form__radio-el[name='porog']:checked")
            .val() && (i += " calc__result_porog"), "1" == $(".form__radio-el[name='pogon-type']:checked")
            .val() && (i += " calc__result_teleskop"), $(".calc__result")[0].className = "calc__result " + i, $("#calc__item_service-list")
            .html(e.serviceList), ""),
          a = (a += "Дверь: " + n.url + " , " + n.product + "\n\n Артикул: " + n.sku) + (", цена: " + Math.round(n.price) + " ₽ ");
        n.oldprice && "0" != n.oldprice && (a += ",скидка: " + Math.round(n.oldprice - n.price) + " ₽\n\n"), a = (a = (a = (a += "\n\n\nКороб: " + (e.korob ? Math.round(e.korob) + " ₽, тип: " + e.pogon : "нет") + "\n") + "Порог: " + (e.porog ? e.porog + " ₽" : "нет") + "\n") + "Наличники: " + (e.nalich ? e.nalich + " ₽, сторон: " + e.nalichType : "нет") + "\nДобор: " + (e.dobor ? e.dobor + " ₽, размер: " + m + "мм, кол-во: " + e.doborType + "шт." : "нет") + "\n") + "Ручка: " + (e.doorhandle ? e.doorhandle.price + " ₽, тип: " + e.doorhandle.tip : "нет") + "\n", e.zashelka && (a += "Защелка: " + e.zashelka + " ₽ \n"), a = (a = (a = (a = (a += "Петли: " + (e.doorhinges ? e.doorhinges.price + " ₽, тип: " + e.doorhinges.tip : "нет") + "\n") + "Замок + завертка: " + (e.zamok ? e.zamok + " ₽" : "нет") + "\n\n\n") + "Стоимость 1 комплекта*: " + Math.round(t) + " ₽\n") + "Установка выбранного комплекта: " + (e.service ? o + " ₽" : "нет") + "\n\n") + (n.oldprice && "0" != n.oldprice ? "* Указанная скидка действует при покупке 2-х комплектов дверей и более. Цена 1 комплекта без скидки " + Math.round(t + n.oldprice - n.price) + " ₽. В зависимости от комплектации, размера и цвета двери, итоговая цена комплекта и установки может меняться.\n\n" : "* В зависимости от комплектации, размера и цвета двери, итоговая цена комплекта и установки может меняться.\n\n\n"), $("#calc__send-list")
          .html(a), $("#calc__result-manager")
          .val(a)
      }
      var n, r, l, a, t, c = {
          porog: null,
          dobor: null,
          zamok: null
        },
        d = [],
        u = [],
        p = [],
        f = 0,
        m = "100",
        s = ($("#modal__calc")
          .on("show.bs.modal", function(e) {
            a = new Date, window["yaCounter" + YaCounterId].reachGoal("OPEN-CALC");
            var e = $(e.relatedTarget),
              t = $(this);
            n = e.data(), o(t), i()
          }), $("#modal__calc")
          .on("hidden.bs.modal", function() {
            t = new Date;
            var e = {
              calcTime: Math.round((t - a) / 1e3),
              currency: "SEK"
            };
            window["yaCounter" + YaCounterId].reachGoal("CLOSE-CALC", e)
          }), $("#modal__calc-result")
          .on("show.bs.modal", function() {
            window["yaCounter" + YaCounterId].reachGoal("OPEN-CALC-RESULT")
          }), $("#modal__calc-result")
          .on("show.bs.modal", function() {
            window["yaCounter" + YaCounterId].reachGoal("OPEN-CALC-RESULT")
          }), $("#calc__form")
          .length && $("#calc__form")
          .feedbackToOrder(function() {
            window["yaCounter" + YaCounterId].reachGoal("SEND-CALC-RESULT"), $("#modal__calc-result_done")
              .modal(), setTimeout(function() {
                $("#modal__calc-result, #modal__calc, #modal__calc-result_done")
                  .modal("hide")
              }, 3e3)
          }), null);
      $(document)
        .click(function(e) {
          if (s && null != s)
            for (var t = e.target || e.srcElement; t != document && $(t)[0] != s[0];) {
              if (t == document.body) {
                s = null, $(".calc__item-select_show")
                  .removeClass("calc__item-select_show");
                break
              }
              t = t.parentNode
            }
        }), $(".calc__item")
        .on("change", ".form__radio-el", function() {
          var e, t;
          e = this, s = null, (t = $(e)
              .closest(".calc__item-selected"))
            .removeClass("calc__item-select_show"), t.find(".calc__item-selected-text")
            .html($(e)
              .next()
              .html()), i()
        }), $(".calc__item")
        .hover(function() {
          $(".calc__result")
            .addClass("calc__result_" + $(this)
              .data("item") + "-hover")
        }, function() {
          $(".calc__result")
            .removeClass("calc__result_" + $(this)
              .data("item") + "-hover")
        }), $(".calc__item")
        .on("change", ".form__checkbox-el", function() {
          i(), $(this)
            .closest(".calc__item")
            .prop("class", "calc__item calc__item_" + $(this)
              .is(":checked"))
        }), $(".calc__item-selected")
        .on("click", function() {
          null === s ? ($(this)
            .closest(".calc__item-selected")
            .addClass("calc__item-select_show"), s = $(this)) : (s.closest(".calc__item-selected")
            .removeClass("calc__item-select_show"), $(this)[0] == s[0] && (s = null))
        }), $(".calc__popup-form-phone")
        .inputmask("+7(999)999-99-99")
        .focus(function() {
          $(this)
            .parent()
            .removeClass("calc__popup-form-item_error")
        }), $(".calc__popup")
        .on("hide.bs.modal", function() {
          var e = $(this);
          e.find(".calc__popup-form_data")
            .show(), e.find(".calc__popup-form_send")
            .hide(), e.find(".calc__popup-form-phone")
            .val(""), e.find(".calc__popup-form-sum")
            .val("")
        }), $(".calc__popup")
        .on("show.bs.modal", function(e) {
          function t(e, t, o) {
            return (e ? "<li class='calc__popup-item'><b>" + e + " ₽</b> (полотно + наличники с 1 стороны без порога)</li>" : "") + (t ? "<li class='calc__popup-item'><b>" + t + " ₽</b> (полотно + наличники с 2 сторон без порога)</li>" : "") + (o ? "<li class='calc__popup-item'><b>" + o + " ₽</b> (полотно + наличники с 2 сторон без порога + добор 1,5 шт)</li>" : "")
          }
          var e = $(e.relatedTarget),
            o = $(this),
            e = {
              product: e.data("product"),
              k1: e.data("kompl-1"),
              k2: e.data("kompl-2"),
              k3: e.data("kompl-3"),
              kt1: e.data("kompl-t-1"),
              kt2: e.data("kompl-t-2"),
              kt3: e.data("kompl-t-3")
            };
          o.find(".calc__popup-block_com, .calc__popup-block_tel")
            .hide(), o.find(".calc__popup-block_com .calc__popup-list, .calc__popup-block_tel .calc__popup-list")
            .html(""), o.find(".calc__popup-form-product")
            .html(e.product), o.find(".calc__popup-form-product-input")
            .val(e.product), (e.k1 || e.k2 || e.k3) && (o.find(".calc__popup-block_com")
              .show(), o.find(".calc__popup-block_com .calc__popup-list")
              .append(t(e.k1, e.k2, e.k3))), (e.kt1 || e.kt2 || e.kt3) && (o.find(".calc__popup-block_tel")
              .show(), o.find(".calc__popup-block_tel .calc__popup-list")
              .append(t(e.kt1, e.kt2, e.kt3)))
        }), $(".calc__popup-form")
        .on("submit", function(e) {
          e.preventDefault();
          var e = !0,
            t = $(this)
            .eq(0),
            o = t.find(".calc__popup-form-phone"),
            i = t.find(".calc__popup-form-sum")
            .val(),
            a = t.find(".calc__popup-form-content")
            .data("content"),
            n = t.find(".calc__popup-form-product-input")
            .val(),
            r = t.find("input[name='feedback[info]']")
            .val();
          o.inputmask("isComplete") ? o.parent()
            .removeClass("calc__popup-form-item_error") : (o.parent()
              .addClass("calc__popup-form-item_error"), e = !1);
          a = i && "" != i ? a + " В заявке указано " + i + " дверей. " + n : a + " " + n;
          return t.find(".calc__popup-form-content")
            .val(a + "\n\n" + r + o.val()), e && (t.serialize(), t.find(".calc__popup-form_data")
              .hide(), t.find(".calc__popup-form_send")
              .html("<img src='/served_assets/loading.svg'>")
              .show(), (n = {
                summ: i,
                name: "не указано",
                phone: o.val(),
                content: a + "\n\n" + r + o.val(),
                info: t.find("input[name='feedback[info]']")
                  .val(),
                email: t.find("input[name='feedback[from]']")
                  .val(),
                source: t.find("input[name='feedback[source]']")
                  .val(),
                dop: t.find("input[name='feedback[dop]']"),
                delivery: $("#createOrder")
                  .data("delivery"),
                payment: $("#createOrder")
                  .data("payment"),
                productId: 0
              })
              .productId = $(".product")
              .length ? $(".product")
              .data("variant-id") : $("#createOrder")
              .data("product"), createOrder(n, t, function() {})), !1
        })
    }), $(document)
    .ready(function() {
      $(".form__phone")
        .inputmask("+7 (999) 999-99-99"), $(".feedback__form")
        .feedbackToOrder(), $("#contact, #whatsapp, #calc-with-discounts, #selection, #consultation, #sample")
        .on("show.bs.modal", function(e) {
          e = $(e.relatedTarget);
          $(this)
            .find("input[name='feedback[product-variant]']")
            .val(e.data("product"))
        }), $("#contact, #whatsapp, #calc-with-discounts, #selection, #consultation, #sample")
        .on("hide.bs.modal", function() {
          $(this)
            .find("input[name='feedback[product-variant]']")
            .val("")
        })
    }),
    function(n, i) {
      var r, a;
      $(".page_cart")
        .length && i.is('[data-callibri_form_name^="feedback-calc-with-discounts"]') ? new Promise(function(a) {
          $.ajax({
            url: "/cart_items.json",
            type: "get",
            success: function(e) {
              if (console.log(e), 0 == e.items_count) $.ajax({
                url: "/cart_items.json",
                type: "post",
                data: "_method=put&cart[quantity][" + n.productId + "]=1",
                success: function(e) {
                  console.log(e), a(!0)
                }
              });
              else {
                r = JSON.parse(JSON.stringify(e)), console.log(r);
                for (var t = {}, o = 0; o < r.order_lines.length; o++) t["cart[quantity][" + r.order_lines[o].variant_id + "]"] = 0;
                console.log(t), $.ajax({
                  url: "/cart_items.json",
                  type: "PUT",
                  data: t,
                  success: function(e) {
                    var i;
                    console.log(e), $(".cart-checkbox-item_active")
                      .length ? (i = {}, $(".cart-checkbox-item_active")
                        .each(function(e) {
                          var t = $(this)
                            .closest(".catalog__item"),
                            o = t.find('[name="variant_id"]')
                            .val(),
                            t = +t.find(".catalog-addToBasket-form__count")
                            .text();
                          i["cart[quantity][" + o + "]"] = t
                        }), $.ajax({
                          url: "/cart_items.json",
                          type: "PUT",
                          data: i,
                          success: function(e) {
                            console.log(e), a(!1)
                          }
                        })) : $.ajax({
                        url: "/cart_items.json",
                        type: "post",
                        data: "_method=put&cart[quantity][" + n.productId + "]=1",
                        success: function(e) {
                          console.log(e), a(!1)
                        }
                      })
                  }
                })
              }
            }
          })
        })
        .then(function(e) {
          var t = "";
          $.getJSON("/client_account/contacts.json", function(e) {
              console.log("contacts"), e && e.client && (t = e.client.email)
            })
            .then(function(e) {
              $.ajax({
                url: "/fast_checkout.json",
                type: "post",
                data: {
                  client: {
                    email: n.email || t || "client@mail.ru",
                    name: n.name,
                    phone: n.phone,
                    registered: !1,
                    subscribe: !1
                  },
                  order: {
                    comment: n.summ + n.content + "\n" + n.dop + "\n" + n.source + "\n\n" + n.info.replace("Заказ расчета со скидками", "Корзина"),
                    delivery_variant_id: n.delivery,
                    payment_gateway_id: n.payment
                  }
                },
                success: function(t) {
                  if (console.log(t), t.errors && console.log(t), r && r.order_lines.length) {
                    for (var e = {}, o = 0; o < r.order_lines.length; o++) ! function(t) {
                      var o = !1;
                      $(".cart-checkbox-item_active")
                        .each(function(e) {
                          $(this)
                            .closest(".catalog__item")
                            .find('[name="variant_id"]')
                            .val() == r.order_lines[t].variant_id && (o = !0)
                        }), o || (e["cart[quantity][" + r.order_lines[t].variant_id + "]"] = r.order_lines[t].quantity)
                    }(o);
                    console.log(e), $.ajax({
                      url: "/cart_items.json",
                      type: "PUT",
                      data: e,
                      success: function(e) {
                        console.log(e), console.log("Заказ ниже:"), console.log(t), i.removeClass("feedback__form_sending"), i.parents(".modal")
                          .modal("hide"), $("#modal__calc-result_done")
                          .modal(), setTimeout(function() {
                            $("#modal__calc-result_done")
                              .modal("hide"), location.reload()
                          }, 2e3)
                      }
                    })
                  } else i.removeClass("feedback__form_sending"), i.parents(".modal")
                    .modal("hide"), $("#modal__calc-result_done")
                    .modal(), setTimeout(function() {
                      $("#modal__calc-result_done")
                        .modal("hide"), location.reload()
                    }, 2e3)
                },
                error: function(e) {
                  i.removeClass("feedback__form_sending"), console.log(e)
                }
              })
            })
        }) : new Promise(function(i) {
          $.ajax({
            url: "/cart_items.json",
            type: "get",
            success: function(e) {
              if (console.log(e), 0 == e.items_count) $.ajax({
                url: "/cart_items.json",
                type: "post",
                data: "_method=put&cart[quantity][" + n.productId + "]=1",
                success: function(e) {
                  console.log(e), i(!0)
                }
              });
              else {
                a = JSON.parse(JSON.stringify(e)), console.log(a);
                for (var t = {}, o = 0; o < a.order_lines.length; o++) t["cart[quantity][" + a.order_lines[o].variant_id + "]"] = 0;
                console.log(t), $.ajax({
                  url: "/cart_items.json",
                  type: "PUT",
                  data: t,
                  success: function(e) {
                    console.log(e), $.ajax({
                      url: "/cart_items.json",
                      type: "post",
                      data: "_method=put&cart[quantity][" + n.productId + "]=1",
                      success: function(e) {
                        console.log(e), i(!1)
                      }
                    })
                  }
                })
              }
            }
          })
        })
        .then(function(e) {
          var t = "";
          $.getJSON("/client_account/contacts.json", function(e) {
              console.log("contacts"), e && e.client && (t = e.client.email)
            })
            .then(function(e) {
              $.ajax({
                url: "/fast_checkout.json",
                type: "post",
                data: {
                  client: {
                    email: n.email || t || "client@mail.ru",
                    name: n.name,
                    phone: n.phone,
                    registered: !1,
                    subscribe: !1
                  },
                  order: {
                    comment: n.summ + n.content + "\n" + n.dop + "\n" + n.source + "\n\n" + n.info,
                    delivery_variant_id: n.delivery,
                    payment_gateway_id: n.payment
                  }
                },
                success: function(e) {
                  if (console.log(e), e.errors && console.log(e), a && a.order_lines.length) {
                    for (var t = {}, o = 0; o < a.order_lines.length; o++) t["cart[quantity][" + a.order_lines[o].variant_id + "]"] = a.order_lines[o].quantity;
                    console.log(t), $.ajax({
                      url: "/cart_items.json",
                      type: "PUT",
                      data: t,
                      success: function(e) {
                        console.log(e), i.removeClass("feedback__form_sending"), i.parents(".modal")
                          .modal("hide"), $("#modal__calc-result_done")
                          .modal(), setTimeout(function() {
                            $("#modal__calc-result_done")
                              .modal("hide")
                          }, 2e3)
                      }
                    })
                  } else i.removeClass("feedback__form_sending"), i.parents(".modal")
                    .modal("hide"), $("#modal__calc-result_done")
                    .modal(), setTimeout(function() {
                      $("#modal__calc-result_done")
                        .modal("hide")
                    }, 2e3)
                },
                error: function(e) {
                  i.removeClass("feedback__form_sending"), console.log(e)
                }
              })
            })
        })
    }),
  CompareObj = (function(m) {
      m.fn.ajaxFeedback = function(f) {
        return this.each(function() {
          var p = m(this);
          p.submit(function(e) {
            var t, o, i = !1,
              a = (p.find(".form__item")
                .removeClass("form__item_error"), p.find("input[name='feedback[summ]']")),
              n = p.find("input[name='feedback[name]']"),
              r = p.find("input[name='feedback[phone]']"),
              s = p.find("input[name='feedback[content]']"),
              l = p.find("input[name='feedback[info]']"),
              c = (p.find("input[name='feedback[from]']") || p.find("input[name='feedback[email]']"), p.find("input[name='feedback[source]']")),
              d = p.find("input[name='feedback[dop]']"),
              u = p.find("input[name='eula_accepted']"),
              a = a.length ? "<b>Количество комплектов: " + a.val() + "</b><br>" : "",
              d = d.length ? "Сайт где нашли дешевле " + d.val() : "";
            return r.inputmask("isComplete") || (r.parents(".form__item")
              .addClass("form__item_error"), i = !0), 0 == u.prop("checked") && (u.parents(".form__item")
              .addClass("form__item_error"), i = !0), i || (u = {
              "feedback[subject]": p.find("input[name='feedback[subject]']")
                .val(),
              "feedback[name]": n.val(),
              "feedback[phone]": r.val(),
              "feedback[content]": a + s.val() + "\n" + d + "\n" + c.val() + "\n\n" + l.val() + r.val(),
              "feedback[from]": "noreply@gigant-dveri.ru"
            }, t = p, o = f, m.ajax({
              url: "/client_account/feedback.json",
              type: "post",
              dataType: "json",
              data: u,
              beforeSend: function() {
                console.log("beforeSend")
              },
              complete: function() {
                consolr.log("complete")
              },
              success: function(e) {
                "ok" == e.status && (o && "function" == typeof o && o(), t.parents(".modal")
                  .modal("hide"))
              }
            }), e.preventDefault()), !1
          })
        })
      }
    }(jQuery), $(function() {
      $(document)
        .on("click", ".form__count-minus", function(e) {
          e.preventDefault();
          var e = $(this)
            .closest(".form__count")
            .find(".form__count-input"),
            t = parseInt(e.val());
          if (t <= 1) return !1;
          e[0].value = --t, e.trigger("change")
        }), $(document)
        .on("click", ".form__count-plus", function(e) {
          e.preventDefault();
          var e = $(this)
            .closest(".form__count")
            .find(".form__count-input"),
            t = parseInt(e.val());
          e[0].value = t += 1, e.trigger("change")
        })
    }), $(document)
    .ready(function() {
      var o = [];

      function e() {
        if (i && i.length) {
          for (var e = Math.floor(Math.random() * i.length); o.includes(e);) e = Math.floor(Math.random() * i.length);
          o.push(e);
          var t = i.eq(e)
            .clone();
          t.removeClass("slick-slide slick-active")
            .css("width", "100%"), t.appendTo($(".aside__review")), t.find(".fancybox")
            .fancybox({
              helpers: {
                overlay: {
                  locked: !1
                },
                title: {
                  type: "float"
                }
              }
            }), document.getElementById("lazyload-script")
            .onload = void new LazyLoad({
              elements_selector: ".reliability-feedback__slide .lazyload"
            })
        }
      }
      $(".aside__review .reliability-feedback__text, .page__slider-feedback .reliability-feedback__text, .feedback__feedback-block .reliability-feedback__text")
        .each(function() {
          var e = 102;
          (e = 991 < $(window)
            .width() ? 114 : e) < $(this)
            .height() && ($(this)
              .addClass("part-hidden"), $(this)
              .parents(".reliability-feedback__text-block")
              .addClass("reliability-feedback__text-block--hide"), $(this)
              .after("<a href='#' class='reliability-feedback__more'>Показать полностью</a>"))
        }), $(document)
        .on("click", ".aside__review .reliability-feedback__more, .page__slider-feedback .reliability-feedback__more, .feedback__feedback-block .reliability-feedback__more", function(e) {
          e.preventDefault();
          var e = $(this),
            t = e.parents(".reliability-feedback__text-block"),
            o = t.find(".reliability-feedback__text");
          "Показать полностью" == e.html() ? (e.html("Скрыть"), o.removeClass("part-hidden"), t.removeClass("reliability-feedback__text-block--hide")) : (e.html("Показать полностью"), t.addClass("reliability-feedback__text-block--hide"), o.addClass("part-hidden"))
        });
      var i = $(".reliability-feedback__slide");
      e(), e(), e()
    }), {}),
  stringToColor = ($(document)
    .ready(function() {
      function a(e) {
        for (var t = {}, o = 0; o < e.properties.length; o++) t[e.properties[o].permalink] = function(e, t) {
          for (var o = 0; o < e.length; o++)
            if (e[o].property_id == t) return "глухие" == e[o].title ? "Глухая" : "остекленные" == e[o].title ? "Остекленная" : e[o].title
        }(e.characteristics, e.properties[o].id);
        return t
      }

      function n(o) {
        $.getJSON("/compares.json")
          .done(function(e) {
            var i, t;
            "function" == typeof o && o(e.products), CompareObj = e.products, (t = e.products)
              .length ? ($("#compare__ears")
                .addClass("compare__ears_show"), $(".ears_prezent")
                .animate({
                  right: "-300px"
                }, 500, function() {
                  $(".ears_prezent")
                    .addClass("hide")
                })) : ($("#compare__ears")
                .removeClass("compare__ears_show"), $(".ears_prezent")
                .removeClass("hide"), $(".ears_prezent")
                .animate({
                  right: "0px"
                })), $("#compare__ears-val")
              .html(1 == t.length ? "1 товар" : t.length + " товара"), i = e.products, $(".compare__add")
              .each(function() {
                for (var e, t = !1, o = i.length - 1; 0 <= o; o--) e = i[o].id, $(this)
                  .data("product-id") == e && (t = !0);
                t ? $(this)
                  .addClass("compare__js-del")
                  .removeClass("compare__js-add") : $(this)
                  .removeClass("compare__js-del")
                  .addClass("compare__js-add")
              })
          })
          .fail(function(e) {
            o(null, e)
          })
      }
      var e, t, o;
      n(function() {}), $(document)
        .on("click", ".compare__js-del", function(e) {
          e.preventDefault();
          var t = $(this)
            .data("product-id");
          $.post("/compares/" + t + ".json", {
              _method: "delete"
            })
            .done(function() {
              n(function(e) {
                $("#compare")
                  .length && ($(".compare__value[data-compared-id='" + t + "']")
                    .hide(), 0 == e.length) && $("#compare")
                  .html('<p>В сравнении 0 товаров.</p><p>Выберите товары для сравнения из каталога <a href="/collection/dveri-mezhkomnatnye">межкомнатных</a> или <a href="/collection/dveri-vhodnye">входных</a> дверей.</p>')
              })
            })
            .fail(function() {})
        }), $(document)
        .on("click", ".compare__js-add", function(e) {
          e.preventDefault();
          var t, o, e = $(this),
            i = e.data("product-id"),
            e = e.data("sku")
            .slice(0, 2);
          if (4 == CompareObj.length) return $.miniNoty ? $.miniNoty({
            message: "Для сравнения можно выбрать не более 4 товаров",
            timeoutToHide: 5e3
          }) : alert("Для сравнения можно выбрать не более 4 товаров"), window["yaCounter" + YaCounterId].reachGoal("compare-4-more"), !1;
          CompareObj.length && (t = a(CompareObj[0]), "" != (o = CompareObj[0].variants[0].sku) && null != o || (o = "межкомнатная" == t["vid-tovara"] ? "ДМ0000" : "входная" == t["vid-tovara"] ? "ДВ0000" : "ФУР000")), CompareObj.length && o.slice(0, 2) != e ? $.miniNoty ? $.miniNoty({
              message: "Выбран товар из другой категории",
              timeoutToHide: 5e3
            }) : alert("Выбран товар из другой категории") : $.post("/compares.json", {
              "product[id]": i
            })
            .done(function() {
              n(function() {})
            })
            .fail(function() {})
        }), $("#compare")
        .length && (e = $("#compare"), t = !0, $(".compare__same-btn")
          .on("click", function() {
            t = !t, e.className = "compare compare__same_" + t
          }), o = !1, $(".compare__group-tr")
          .on("click", function() {
            var e = $(this)
              .data("group");
            $(this)
              .toggleClass("compare__group-btn_show"), $(".compare__group_" + e)
              .toggle(), o || (o = !0, window["yaCounter" + YaCounterId].reachGoal("open-stars-compare"))
          }))
    }), $(document)
    .ready(function() {
      var u = $(".manager-block.manager-block_for-form"),
        p = $(".product__call-right-block"),
        f = $(".modal-dialog--reliability");
      u.length && ! function e() {
        var t, o = u.eq(Math.floor(Math.random() * u.length))
          .clone(),
          i = o.children(".manager__photo"),
          a = o.find(".manager__name")
          .html(),
          n = f.find(".modal-input-callback"),
          r = p.find(".input-callback-title"),
          s = r.val(),
          l = i.find("source"),
          c = i.find("img"),
          d = n.val();
        o.removeClass("slick-slide slick-active lazyload")
          .css("width", "100%") ? (t = i.data("bg"), i.css("background", t), i.css("background-size", "cover"), l && l.length && l.attr("srcset", l.attr("data-srcset")), c && c.length && c.attr("data-src", l.attr("src")), o.appendTo($(".product__call-left-block")), n.val("ВНИМАНИЕ Менеджер " + a + "! " + d), r.val("ВНИМАНИЕ Менеджер " + a + "! " + s)) : e()
      }()
    }), $(document)
    .ready(function() {
      function s(e) {
        return 0 == e ? null : e.toString()
          .replace(/\B(?=(\d{3})+(?!\d))/g, " ")
      }

      function a(e, t) {
        i[t] = {
          price: parseInt(e.variants[0].base_price),
          variantId: e.variants[0].id
        }
      }

      function e() {
        function e(e, t, o) {
          if (0 == arguments.length) return i;
          t ? ((t = Object.assign({}, t))
            .count = o || 1, t.name = e, i += "<li>" + t.name + " <b>" + Math.round(parseInt(t.price) * Math.round(t.count)) + " ₽</b></li>", a.push(t)) : i += "<li>" + e + "</li>"
        }
        var i = "",
          a = [];
        return e.cost = function(e) {
          for (var t = 0, o = a.length - 1; 0 <= o; o--) t += Math.round(a[o].count * e) * a[o].price;
          return Math.round(t)
        }, e.items = function() {
          return a
        }, e.clear = function() {
          i = "", cost = 0, a = []
        }, e
      }

      function t() {
        var e = 0,
          o = parseInt($(".popular-solution__count .form__count-input")
            .val()),
          t = 0,
          i = "",
          a = "",
          n = d.items();
        switch (e += d.cost(o), $("#popular-solution__doorhandle-complect")
          .prop("checked") && (e += u.cost(o), n = n.concat(u.items())), $("#popular-solution__porog")
          .prop("checked") && (e += p.cost(o), n = n.concat(p.items())), 0 < parseInt(l.oldcost) && (t = parseInt(l.oldcost) - parseInt(l.cost), i = "Цена действительна при покупке от 2 комплектов"), l.stock) {
          case "tretya-dver-v-podarok":
            t = Math.round(parseInt(l.cost) - .666 * parseInt(l.cost)), o < 3 ? i = "Цена действительна при покупке от 3 комплектов" : (i = "Цена по акции «1+1=3» ", a = '<i class="catalog__price-help" data-tooltip="tretya-dver-v-podarok" data-from="html">?</i>');
            break;
          case "novaya-tsena-ustanovki-2":
            t = 0, i = "Скидка по акции «Супер установка»";
            break;
          case "darim-800-rub-na-furnituru":
            t = 800, i = "Скидка по акции «Дарим 800 ₽ на фурнитуру»"
        }
        window.GlobalPopularSolution = null, window.GlobalPopularSolution = {}, GlobalPopularSolution.count = o, GlobalPopularSolution.discount = t, GlobalPopularSolution.discountText = i, t ? $(".popular-solution__price-discount, .popular-solution__price-old")
          .show() : $(".popular-solution__price-discount, .popular-solution__price-old")
          .hide();
        var r, n = n.reduce((r = Object.create(null), function(e, t) {
          return (r[t.variantId] = r[t.variantId] || e[e.push({
              variantId: t.variantId,
              count: 0
            }) - 1])
            .count += t.count * o, e
        }), []);
        GlobalPopularSolution.items = n, GlobalPopularSolution.resultSumm = Math.round(e - t * o), $(".popular-solution__price-description")
          .html(i + a), $(".popular-solution__price-old")
          .html(s(Math.round(e)) + " ₽"), $(".popular-solution__price")
          .html(s(GlobalPopularSolution.resultSumm) + " ₽"), $(".popular-solution__price-discount")
          .html("Выгода " + s(Math.round(t * o)) + " ₽"), GlobalPopularSolution.comment = "Количество комплектов: " + o + "\n" + (i ? "Акция: " + i : " ") + "\n" + (t ? "Сумма скидки: " + Math.round(t * o) + " ₽" : " ") + "\nОбщая сумма заказа" + (t ? " со скидкой" : "") + ": " + GlobalPopularSolution.resultSumm + " ₽"
      }

      function n(e, t) {
        function o() {
          $.post("/cart_items.json", {
              variant_ids: function(e) {
                for (var t = {}, o = 0; o < e.length; ++o) t[e[o].variantId] = Math.round(e[o].count);
                return t
              }(GlobalPopularSolution.items)
            })
            .done(function() {
              $.ajax({
                url: "/fast_checkout.json",
                type: "post",
                data: {
                  client: {
                    email: e.email || "client@mail.ru",
                    name: e.name,
                    phone: e.phone
                  },
                  order: {
                    comment: GlobalPopularSolution.comment + "\n\n" + e.source + "\n\n" + e.info,
                    delivery_variant_id: e.delivery,
                    payment_gateway_id: e.payment
                  }
                },
                success: function(e) {
                  console.log(e), t.parents(".modal")
                    .modal("hide"), $("#modal__calc-result_done")
                    .modal(), setTimeout(function() {
                      $("#modal__calc-result_done")
                        .modal("hide")
                    }, 4e3)
                }
              })
            })
        }
        $.post("/cart_items.json")
          .done(function(e) {
            e.items_count ? function t(e) {
              $.post("/cart_items/" + e + ".json", {
                  _method: "delete"
                })
                .done(function(e) {
                  e.items_count ? t(e.items[0].variant_id) : o()
                })
            }(e.items[0].variant_id) : o()
          })
      }
      var o, i = {},
        l = $(".product")
        .data(),
        r = $("#popular-solution")
        .data(),
        c = "";
      for (o in r) r[o] && (c += r[o] + ",");
      var c = c.slice(0, -1),
        d = e(),
        u = e(),
        p = e();
      Promise.all([new Promise(function(t) {
          $.post("/collection/price-tag-mk.json", {})
            .done(function(e) {
              e.products.forEach(function(e) {
                (e.title.toLowerCase()
                  .indexOf("навес") + 1 || e.title.toLowerCase()
                  .indexOf("петля") + 1) && a(e, "doorhinges"), e.title.toLowerCase()
                  .indexOf("ручка") + 1 && a(e, "doorhandle"), e.title.toLowerCase()
                  .indexOf("защёлка") + 1 && a(e, "latch")
              }), t()
            })
        }), new Promise(function(t) {
          $.post("/collection/calc-service.json", {})
            .done(function(e) {
              e.products.forEach(function(e) {
                switch (e.title) {
                  case "(МКОБЛ) Установка порога межкомнатной двери":
                    a(e, "porogService");
                    break;
                  case "(МКОБЛ) Установка 1го ряда доборного элемента межкомнатной двери до 20 см":
                    a(e, "doborService");
                    break;
                  case "(МКВРЕЗ) Врезка замка сантехнического/цилиндрового - 1 шт":
                    a(e, "santehService")
                }
              }), t()
            })
        }), new Promise(function(i) {
          "" != c ? $.memoizedAjax({
            url: "/products_by_id/" + c + ".json",
            localStorage: !0,
            type: "GET",
            success: function(e) {
              for (var t = e.products.length - 1; 0 <= t; t--)
                for (var o in r) r[o] == e.products[t].id && a(e.products[t], o);
              i()
            }
          }) : console.log("JSON argemunt is not exist", c)
        })])
        .then(function() {
          d("Полотно", {
              variantId: l.variantId,
              price: 0 < parseInt(l.oldcost) ? l.oldcost : l.cost
            }, 1), d("2,5 шт Короба", i[i.hasOwnProperty("korobkaPr") ? "korobkaPr" : "korobkaTel"], 2.5), i.hasOwnProperty("dobor100Pr") || i.hasOwnProperty("dobor100Tel") ? d("2,5 шт Добора ", i[i.hasOwnProperty("dobor100Pr") ? "dobor100Pr" : "dobor100Tel"], 2.5) : d("2,5 шт Добора ", i[i.hasOwnProperty("dobor150Pr") ? "dobor150Pr" : "dobor150Tel"], 2.5), d("Наличники с 2 сторон", i[i.hasOwnProperty("nalichnikPr") ? "nalichnikPr" : "nalichnikTel"], 5), $("#popular-solution__list-door")
            .append(d()), u("Ручка", i.doorhandle, 1), u("Защелка", i.latch, 1), u("2 петли", i.doorhinges, 2), $("#popular-solution__list-doorhandle")
            .append(u()), p("Базовая установка", i.ustanovka, 1), p("Устан. доборов", i.doborService, 1), $("#popular-solution__list-porog")
            .append(p()), t()
        }), $(".popular-solution__checkbox-el, .popular-solution__count .form__count-input")
        .change(function() {
          t()
        }), $("#popular-solution__submit")
        .on("click", function() {
          $("#complect-cart")
            .modal(), window["yaCounter" + YaCounterId].reachGoal("popular-click")
        }), $(".popular-solution__start")
        .on("click", function() {
          window["yaCounter" + YaCounterId].reachGoal("popular-top-yes"), $("#product-popup-cart")
            .modal("hide"), $("body,html")
            .animate({
              scrollTop: Math.round($(".popular-solution__wrap")
                .offset()
                .top) - 50
            }, 300)
        }), $("#product-popup-cart")
        .on("click", function() {
          window["yaCounter" + YaCounterId].reachGoal("popular-top")
        }), $("#complect-cart__form")
        .submit(function(e) {
          e.preventDefault();
          var t = 0,
            o = $(this),
            i = {
              summ: o.find("input[name='feedback[summ]']"),
              name: o.find("input[name='feedback[name]']")
                .val(),
              phone: o.find("input[name='feedback[phone]']"),
              content: o.find("input[name='feedback[content]']")
                .val(),
              info: o.find("input[name='feedback[info]']")
                .val(),
              email: o.find("input[name='feedback[from]']")
                .val() || o.find("input[name='feedback[email]']")
                .val(),
              source: o.find("input[name='feedback[source]']")
                .val(),
              agreement: o.find("input[name='eula_accepted']"),
              delivery: $("#createOrder")
                .data("delivery"),
              payment: $("#createOrder")
                .data("payment"),
              productId: 0
            };
          return o.find(".form__item")
            .removeClass("form__item_error"), i.phone.inputmask("isComplete") || (i.phone.parents(".form__item")
              .addClass("form__item_error"), t += 1), 0 == i.agreement.prop("checked") && (i.agreement.parents(".form__item")
              .addClass("form__item_error"), t += 1), !t && (i.phone = i.phone.val(), n(i, o), e.preventDefault(), !1)
        })
    }), $(document)
    .ready(function() {
      var e = localStorage.getItem("doorsCount"),
        t = (0 == e ? $("body")
          .attr("id", "doors1") : ($(".count-image")
            .removeClass("hide"), $(".count-empty")
            .addClass("hide"), $(".count-full")
            .removeClass("hide"), $(".ears-counter")
            .html(e), $(".ears-counter-text")
            .data("count", e), $("body")
            .attr("id", "doors" + e), $(".modal-door-counter option[value=" + e + "]")
            .attr("selected", "true"), $(".counter__advantage-text")
            .each(function() {
              $(this)
                .addClass("hide"), ($(this)
                  .data("count") == e || 6 < e && 6 == $(this)
                  .data("count")) && $(this)
                .removeClass("hide")
            }), $(".mk-size-input")
            .val(e), $(".count-btn")
            .each(function() {
              $(this)
                .addClass("hide"), ($(this)
                  .data("count") == e || 6 < e && 6 == $(this)
                  .data("count")) && $(this)
                .removeClass("hide")
            }), $(".door-counter option")
            .each(function() {
              ($(this)
                .val() == e || 6 < e && 6 == $(this)
                .val()) && $(this)
                .attr("selected", !0)
            }), $(".mk-doors-presents") && (e < 3 ? ($(".quantity-discount")
              .each(function() {
                $(this)
                  .html($(this)
                    .data("one"))
              }), $("#tooltip_tretya-dver-v-podarok-help")
              .html("<h6>Экономия по акции 1+1=3</h6><p>Экономия равна цене 1 полотна при условии покупки 3 комплектов дверей с погонажем и фурнитурой.</p><p>Подробности узнавайте у менеджеров магазина</p>"), $("#tooltip_ruchka-v-podarok")
              .html('<h6>Экономия по акции "Ручка в подарок!" - 2250 Р (экономия равна цене 3 ручек)</h6><p>Скидка на 3 полотна - 3450 Р</p><p>Акция и скидка действуют при покупкие 3 комплектов с погонажем и фурнитурой. Подробности узнавайте у менеджера магазина.</p>')) : 3 == e ? ($(".quantity-discount")
              .each(function() {
                $(this)
                  .html($(this)
                    .data("three"))
              }), $("#tooltip_tretya-dver-v-podarok-help")
              .html("<h6>Экономия по акции 1+1=3</h6><p>Экономия равна цене 1 полотна при условии покупки 3 комплектов дверей с погонажем и фурнитурой.</p><p>Подробности узнавайте у менеджеров магазина</p>"), $("#tooltip_ruchka-v-podarok")
              .html('<h6>Экономия по акции "Ручка в подарок!" - 2250 Р (экономия равна цене 3 ручек)</h6><p>Скидка на 3 полотна - 3450 Р</p><p>Акция и скидка действуют при покупкие 3 комплектов с погонажем и фурнитурой. Подробности узнавайте у менеджера магазина.</p>')) : 4 == e ? ($(".quantity-discount")
              .each(function() {
                $(this)
                  .html($(this)
                    .data("four"))
              }), $("#tooltip_tretya-dver-v-podarok-help")
              .html("<h6>Экономия по акции 1+1=3</h6><p>Экономия равна цене 1 полотна + 1 комплекта фурнитуры при условии покупки 4 комплектов дверей с погонажем и фурнитурой.</p><p>Подробности узнавайте у менеджеров магазина</p>"), $("#tooltip_ruchka-v-podarok")
              .html('<h6>Экономия по акции "Ручка в подарок!" - 3000 Р (экономия равна цене 4 ручек)</h6><p>Скидка на 4 полотна - 4600 Р</p><p>Акция и скидка действуют при покупкие 3 комплектов с погонажем и фурнитурой. Подробности узнавайте у менеджера магазина.</p>')) : 5 == e ? ($(".quantity-discount")
              .each(function() {
                $(this)
                  .html($(this)
                    .data("five"))
              }), $("#tooltip_tretya-dver-v-podarok-help")
              .html("<h6>Экономия по акции 1+1=3</h6><p>Экономия равна цене 1 полотна + 1 комплекта фурнитуры + 1 базовой установке при условии покупки 5 комплектов дверей с погонажем и фурнитурой.</p><p>Подробности узнавайте у менеджеров магазина</p>"), $("#tooltip_ruchka-v-podarok")
              .html('<h6>Экономия по акции "Ручка в подарок!" - 3000 Р (экономия равна цене 4 ручек)</h6><p>Скидка на 4 полотна - 4600 Р</p><p>Акция и скидка действуют при покупкие 3 комплектов с погонажем и фурнитурой. Подробности узнавайте у менеджера магазина.</p>')) : (6 == e || 6 < e) && ($(".quantity-discount")
              .each(function() {
                $(this)
                  .html($(this)
                    .data("six"))
              }), $("#tooltip_tretya-dver-v-podarok-help")
              .html("<h6>Экономия по акции 1+1=3</h6><p>Экономия равна цене 2 полотен при условии покупки 6 комплектов дверей с погонажем и фурнитурой.</p><p>Подробности узнавайте у менеджеров магазина</p>"), $("#tooltip_ruchka-v-podarok")
              .html('<h6>Экономия по акции "Ручка в подарок!" - 3000 Р (экономия равна цене 4 ручек)</h6><p>Скидка на 4 полотна - 4600 Р</p><p>Акция и скидка действуют при покупкие 3 комплектов с погонажем и фурнитурой. Подробности узнавайте у менеджера магазина.</p>'))), $(".ears-counter-text")
            .each(function() {
              var e = $(this)
                .data("count");
              $(this)
                .html(declOfNum(e, ["дверь", "двери", "дверей"]))
            })), $(document)
          .on("change", "#feedbackDoorCounter, #feedbackSummDoorCounter, #fullpriceDoorCounter, #feedbackZvonokDoorCounter, .mk-size-input", function() {
            console.log("change");
            var e = $(this)
              .val();
            $(".counter__advantage-text")
              .each(function() {
                $(this)
                  .addClass("hide"), ($(this)
                    .data("count") == e || 6 < e && 6 == $(this)
                    .data("count")) && $(this)
                  .removeClass("hide")
              }), $(".count-btn")
              .each(function() {
                $(this)
                  .addClass("hide"), ($(this)
                    .data("count") == e || 6 < e && 6 == $(this)
                    .data("count")) && $(this)
                  .removeClass("hide")
              }), localStorage.setItem("doorsCount", e), $(".ears-counter")
              .html(e), $(".ears-counter-text")
              .data("count", e), $(".count-image")
              .removeClass("hide"), $(".count-empty")
              .addClass("hide"), $(".count-full")
              .removeClass("hide"), $("body")
              .attr("id", ""), $("body")
              .attr("id", "doors" + e), $(".door-counter option")
              .each(function() {
                $(this)
                  .attr("selected", !1), ($(this)
                    .val() == e || 6 < e && 6 == $(this)
                    .val()) && $(this)
                  .attr("selected", !0)
              }), $(".mk-size-input")
              .val(e), $(".ears-counter-text")
              .each(function() {
                var e = $(this)
                  .data("count");
                $(this)
                  .html(declOfNum(e, ["дверь", "двери", "дверей"]))
              }), $(".mk-doors-presents") && (e < 3 ? ($(".quantity-discount")
                .each(function() {
                  $(this)
                    .html($(this)
                      .data("one"))
                }), $("#tooltip_tretya-dver-v-podarok-help")
                .html("<h6>Экономия по акции 1+1=3</h6><p>Экономия равна цене 1 полотна при условии покупки 3 комплектов дверей с погонажем и фурнитурой.</p><p>Подробности узнавайте у менеджеров магазина</p>"), $("#tooltip_ruchka-v-podarok")
                .html('<h6>Экономия по акции "Ручка в подарок!" - 2250 Р (экономия равна цене 3 ручек)</h6><p>Скидка на 3 полотна - 3450 Р</p><p>Акция и скидка действуют при покупкие 3 комплектов с погонажем и фурнитурой. Подробности узнавайте у менеджера магазина.</p>')) : 3 == e ? ($(".quantity-discount")
                .each(function() {
                  $(this)
                    .html($(this)
                      .data("three"))
                }), $("#tooltip_tretya-dver-v-podarok-help")
                .html("<h6>Экономия по акции 1+1=3</h6><p>Экономия равна цене 1 полотна при условии покупки 3 комплектов дверей с погонажем и фурнитурой.</p><p>Подробности узнавайте у менеджеров магазина</p>"), $("#tooltip_ruchka-v-podarok")
                .html('<h6>Экономия по акции "Ручка в подарок!" - 2250 Р (экономия равна цене 3 ручек)</h6><p>Скидка на 3 полотна - 3450 Р</p><p>Акция и скидка действуют при покупкие 3 комплектов с погонажем и фурнитурой. Подробности узнавайте у менеджера магазина.</p>')) : 4 == e ? ($(".quantity-discount")
                .each(function() {
                  $(this)
                    .html($(this)
                      .data("four"))
                }), $("#tooltip_tretya-dver-v-podarok-help")
                .html("<h6>Экономия по акции 1+1=3</h6><p>Экономия равна цене 1 полотна + 1 комплекта фурнитуры при условии покупки 4 комплектов дверей с погонажем и фурнитурой.</p><p>Подробности узнавайте у менеджеров магазина</p>"), $("#tooltip_ruchka-v-podarok")
                .html('<h6>Экономия по акции "Ручка в подарок!" - 3000 Р (экономия равна цене 4 ручек)</h6><p>Скидка на 4 полотна - 4600 Р</p><p>Акция и скидка действуют при покупкие 3 комплектов с погонажем и фурнитурой. Подробности узнавайте у менеджера магазина.</p>')) : 5 == e ? ($(".quantity-discount")
                .each(function() {
                  $(this)
                    .html($(this)
                      .data("five"))
                }), $("#tooltip_tretya-dver-v-podarok-help")
                .html("<h6>Экономия по акции 1+1=3</h6><p>Экономия равна цене 1 полотна + 1 комплекта фурнитуры + 1 базовой установке при условии покупки 5 комплектов дверей с погонажем и фурнитурой.</p><p>Подробности узнавайте у менеджеров магазина</p>"), $("#tooltip_ruchka-v-podarok")
                .html('<h6>Экономия по акции "Ручка в подарок!" - 3000 Р (экономия равна цене 4 ручек)</h6><p>Скидка на 4 полотна - 4600 Р</p><p>Акция и скидка действуют при покупкие 3 комплектов с погонажем и фурнитурой. Подробности узнавайте у менеджера магазина.</p>')) : (6 == e || 6 < e) && ($(".quantity-discount")
                .each(function() {
                  $(this)
                    .html($(this)
                      .data("six"))
                }), $("#tooltip_tretya-dver-v-podarok-help")
                .html("<h6>Экономия по акции 1+1=3</h6><p>Экономия равна цене 2 полотен при условии покупки 6 комплектов дверей с погонажем и фурнитурой.</p><p>Подробности узнавайте у менеджеров магазина</p>"), $("#tooltip_ruchka-v-podarok")
                .html('<h6>Экономия по акции "Ручка в подарок!" - 3000 Р (экономия равна цене 4 ручек)</h6><p>Скидка на 4 полотна - 4600 Р</p><p>Акция и скидка действуют при покупкие 3 комплектов с погонажем и фурнитурой. Подробности узнавайте у менеджера магазина.</p>')))
          }), $(".modal-door-title")
          .html($(".product__title")
            .html()), "closed" == localStorage.getItem("notice") && 768 < $(window)
          .width() ? ($(".notice-2")
            .addClass("closed"), $(".notice-2")
            .css({
              display: "flex"
            })) : "closed" == localStorage.getItem("notice") && $(window)
          .width() < 768 ? $(".notice-2")
          .css({
            display: "none"
          }) : $(".notice-2")
          .css({
            display: "flex"
          }), $(".notice-2 .close")
          .on("click", function() {
            $(".notice-2")
              .addClass("closed"), localStorage.setItem("notice", "closed"), $(window)
              .width() < 768 && $(".notice-2")
              .css({
                display: "none"
              })
          }), $(".notice-2 .info")
          .on("click", function() {
            $(".notice-2")
              .removeClass("closed")
          }), $(".product__btns-chaffer")
          .on("click", function() {
            $(".install-block")
              .find("#count_".concat(localStorage.getItem("doorsCount")))
              .prop("checked", !0)
          }), $(document)
          .on("click", '.catalog__set [data-target="#calc-with-discounts"], .catalog__set [data-target="#modal__request-complect-stock113"], .catalog__set [data-target="#zamer"], .catalog__item [data-target="#rassrochka"]', function(e) {
            var t = $(this)
              .closest(".catalog__item")
              .find(".catalog__title");
            t && $(".modal-door-title")
              .html(t.html())
          }), $(".birtday-left, .birthday__ears, .promo-banner a")
          .on("click", function(e) {
            var t;
            $(this)
              .attr("href") && "#" == $(this)
              .attr("href")[0] && (t = $($(this)
                  .attr("href"))
                .find(".modal-door-title")) && t.length && t.parent()
              .remove()
          }), $('[data-target="#calc-with-action"]')
          .on("click", function(e) {
            var t = $(this)
              .closest(".promo")
              .find(".promo__title a");
            t && $(".modal-article-title")
              .html(t.html())
          }), localStorage.getItem("needInstall")),
        o = (null !== t && (t = "false" !== t, $(".modal__want-install-checkbox")
            .each(function() {
              $(this)
                .prop("checked", t), $(this)
                .val($(this)
                  .attr("data-text") + (t ? "Да" : "Нет"))
            })), $(document)
          .on("change", ".modal__want-install-checkbox", function(e) {
            t = $(this)
              .is(":checked"), $(this)
              .val($(this)
                .attr("data-text") + (t ? "Да" : "Нет")), localStorage.setItem("needInstall", t), $(".modal__want-install-checkbox")
              .each(function() {
                $(this)
                  .prop("checked", t), $(this)
                  .val($(this)
                    .attr("data-text") + (t ? "Да" : "Нет"))
              })
          }), localStorage.getItem("needDostavka"));
      null !== o && (o = "false" !== o, $(".modal__want-dostavka-checkbox")
          .each(function() {
            $(this)
              .prop("checked", o), $(this)
              .val($(this)
                .attr("data-text") + (o ? "Да" : "Нет"))
          })), $(document)
        .on("change", ".modal__want-dostavka-checkbox", function(e) {
          o = $(this)
            .is(":checked"), $(this)
            .val($(this)
              .attr("data-text") + (o ? "Да" : "Нет")), localStorage.setItem("needDostavka", o), $(".modal__want-dostavka-checkbox")
            .each(function() {
              $(this)
                .prop("checked", o), $(this)
                .val($(this)
                  .attr("data-text") + (o ? "Да" : "Нет"))
            })
        })
    }),
    function(e) {
      var t, o, i = 0,
        a = "#";
      if (!e) return a + "333333";
      for (o = e.length, t = 0; t < o; t++) i = e.charCodeAt(t) + ((i << 5) - i);
      for (t = 0; t < 3; t++) a += ("00" + (i >> 8 * t & 255)
          .toString(16))
        .substr(-2);
      return a
    }),
  ajaxJSON = (document.addEventListener("DOMContentLoaded", function(e) {
      for (var t = document.querySelectorAll(".reliability-feedback__slide"), o = 0; o < t.length; o++) {
        var i, a = t[o].querySelector(".reliability-feedback__user-no-photo");
        a && (i = t[o].querySelector(".reliability-feedback__user-name")
          .textContent, a.parentNode.style.backgroundColor = stringToColor(i))
      }
    }), document.addEventListener("DOMContentLoaded", function(e) {
      for (var a = document.querySelector(".product-filter"), n = document.querySelector(".header__opened-menu"), r = document.querySelector(".header__fix-menu__top"), s = null, l = (r && (s = r.offsetHeight, a) && (a.style.top = s + "px"), document.querySelector(".cart-fixed-row")), c = document.querySelector(".catalog"), d = document.querySelector(".birthday__text"), u = document.querySelector(".header__logo-img_mobile img"), p = document.querySelector(".header-fix__title_mobile"), f = 0, m = document.querySelector(".header__contacts"), h = document.querySelector(".js-header__contacts"), v = null, g = (m && (v = m.offsetHeight), !1), t = (p && p.addEventListener("transitionend", function() {
          g && (s = r.offsetHeight, n.style.paddingTop = s + "px", document.body.style.paddingTop = r.offsetHeight + "px")
        }, !1), m && window.addEventListener("scroll", function(e) {
          g || (console.log("scroll first"), (t = document.querySelector(".header__fix-menu")) && t.classList.add("active"), (t = document.querySelector(".header__opened-menu")) && t.classList.add("active"), o = null, (i = document.querySelector(".header__fix-menu__top")) && (o = i.offsetHeight, document.body.style.paddingTop = o + "px", t) && (t.style.paddingTop = o + "px"), g = !0);
          var t, o, i = window.pageYOffset || document.documentElement.scrollTop;
          0 < i ? (u && !u.classList.contains("active") && u.classList.add("active"), m && m.classList.contains("active") && m.classList.remove("active"), h && h.classList.contains("active") && h.classList.remove("active"), r && !r.classList.contains("active") && r.classList.add("active"), p && !p.classList.contains("active") && p.classList.add("active"), d && !d.classList.contains("active") && d.classList.add("active")) : (u && u.classList.contains("active") && u.classList.remove("active"), m && !m.classList.contains("active") && m.classList.add("active"), h && !h.classList.contains("active") && h.classList.add("active"), r && r.classList.contains("active") && r.classList.remove("active"), p && p.classList.contains("active") && p.classList.remove("active"), d && d.classList.contains("active") && d.classList.remove("active")), v = m.offsetHeight, f < i ? (d && (d.style.display = "block"), s = r.offsetHeight, n.style.paddingTop = s + "px", a && (a.classList.remove("product-filter--fixed"), a.style.top = s - v - 10 + "px", a.parentElement.style.paddingTop = "0px"), l && (112 < i ? (c.style.paddingTop = "62px", l.classList.add("active"), d && d.classList.add("dni")) : (c.style.paddingTop = "0px", l.classList.remove("active"), d && d.classList.remove("dni")))) : (l && (112 < i ? (c.style.paddingTop = "62px", l.classList.add("active"), d && d.classList.add("dni")) : (c.style.paddingTop = "0px", l.classList.remove("active"), d && d.classList.remove("dni"))), a && (310 < i ? (a.classList.add("product-filter--fixed"), d && (d.style.display = "none"), a.parentElement.style.paddingTop = a.offsetHeight + "px") : (a.classList.remove("product-filter--fixed"), d && (d.style.display = "block"), a.parentElement.style.paddingTop = "0px"), s = r.offsetHeight, a.style.top = s + "px"), s = r.offsetHeight, n.style.paddingTop = s + "px"), document.body.style.paddingTop = r.offsetHeight + "px", f = i <= 0 ? 0 : i
        }, !1), document.querySelectorAll(".header__links-link a")), o = 0; o < t.length; o++) "https://" + window.location.hostname + t[o].getAttribute("href") == window.location.href && t[o].closest(".header__links-item")
        .classList.add("header__links-link_active");
      for (var i = document.querySelector(".bottom-menu-mobile__item_make-call"), _ = (i && i.addEventListener("click", function(e) {
          for (var t = i.querySelectorAll(".header__contact_phone"), o = 0; o < t.length; o++)
            if ("none" != t[o].style.display) return void t[o].click()
        }), document.querySelectorAll(".bottom-menu-mobile__item, .bottom-menu-mobile__item_sub")), k = 0; k < _.length; k++) ! function(t) {
        "https://" + window.location.hostname + _[t].getAttribute("data-info") == window.location.href && _[t].classList.add("bottom-menu-mobile__item_active"), _[t].addEventListener("click", function(e) {
          _[t].classList.toggle("bottom-menu-mobile__item_active")
        })
      }(k);
      var b = document.querySelector('.bottom-menu-mobile__item[data-target="#zamer"]');
      b && $("#zamer")
        .on("hidden.bs.modal", function(e) {
          b.classList.remove("bottom-menu-mobile__item_active")
        })
    }), $(document)
    .ready(function() {
      $(".popup")
        .on("hidden.bs.modal", function() {
          var e = $(this)
            .find("iframe"),
            t = e.attr("src");
          e.attr("src", ""), e.attr("src", t)
        })
    }),
    function(e, t, o) {
      var i = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : void 0,
        a = 4 < arguments.length && void 0 !== arguments[4] ? arguments[4] : void 0,
        n = new XMLHttpRequest;
      if (n.open(e, t, !0), n.responseType = "json", a) {
        var r, s = new FormData;
        for (r in a) s.append(r, a[r])
      }
      n.onload = function() {
        var e = n.status;
        o(200 === e ? null : e, i, n.response)
      }, a ? n.send(s) : n.send()
    });
document.addEventListener("DOMContentLoaded", function() {
  var s = 20,
    l = 0,
    c = document.querySelector("[data-ui-favorites-clear]"),
    d = document.querySelector("[data-ui-favorites-counter]"),
    u = document.querySelectorAll(".favorites-item");

  function p(e, t, o) {
    console.log("clearFavorites", t, " data: ", o);
    for (var i = document.querySelectorAll(".favorites-added"), a = 0; a < i.length; a++) i[a].classList.remove("favorites-added"), i[a].classList.add("favorites-not-added");
    if (l == s)
      for (a = 0; a < u.length; a++) u[a].classList.remove("favorites-limit");
    l = 0, d && (d.textContent = l)
  }

  function f(e, t, o) {
    if (console.log("deleteFavorites", t, " data: ", o), t.classList.contains("favorites-added")) {
      if (l == s)
        for (var i = 0; i < u.length; i++) u[i].classList.remove("favorites-limit");
      t.classList.remove("favorites-added"), t.classList.add("favorites-not-added"), l--, d && (d.textContent = l)
    }
  }

  function m(e, t, o) {
    if (console.log("addFavorites", t, " data: ", o), t.classList.contains("favorites-not-added")) {
      if (t.classList.remove("favorites-not-added"), t.classList.add("favorites-added"), t.classList.add("favorites-adding"), l++, d && (d.textContent = l), l == s)
        for (var i = 0; i < u.length; i++) u[i].classList.contains("favorites-added") || u[i].classList.add("favorites-limit");
      setTimeout(function() {
        t.classList.remove("favorites-adding")
      }, 3e3)
    }
  }
  ajaxJSON("GET", "/front_api/favorites.json", function(e, t, o) {
    var i = o;
    l = i.products.length, d && (d.textContent = l);
    for (var a = 0; a < i.products.length; a++) {
      var n = document.querySelector('[data-ui-favorites-trigger="'.concat(i.products[a].id, '"]'));
      n && (n.classList.remove("favorites-not-added"), n.classList.add("favorites-added"))
    }
    if (l == s)
      for (a = 0; a < u.length; a++) u[a].classList.contains("favorites-added") || u[a].classList.add("favorites-limit");
    c && c.addEventListener("click", function() {
      ajaxJSON("POST", "/front_api/favorites/clear.json", p, this)
    });
    for (var r = 0; r < u.length; r++) u[r].addEventListener("click", function() {
      this.classList.contains("favorites-limit") ? alert("Товар не добавлен. Максимум товаров в избранном: ".concat(s)) : this.classList.contains("favorites-added") ? ajaxJSON("POST", "/front_api/favorites/" + this.getAttribute("data-ui-favorites-trigger") + ".json", f, this, {
        lang: null,
        _method: "delete"
      }) : this.classList.contains("favorites-not-added") && ajaxJSON("POST", "/front_api/favorites.json", m, this, {
        lang: null,
        "product[id]": this.getAttribute("data-ui-favorites-trigger")
      })
    })
  })
}); 
